/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	MutationFunction,
	QueryFunction,
	QueryKey,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from '@tanstack/react-query';
import type {
	AcceptInvitation401,
	AcceptInvitation403,
	AcceptInvitation404,
	AcceptInvitation500,
	AcceptInvitation503,
	AcceptInvitationResponse,
	ActionItem,
	ActionItemList,
	AgendaItem,
	AgendaItemList,
	AppSseEvent,
	AssignDocumentToPatient404,
	AssignDocumentToPatientRequest,
	AuthProvisioningStatus,
	AuthUpdatePasswordRequest,
	AuthUpdatePasswordResponse,
	BulkUploadUrlsRequest,
	BulkUploadUrlsResponse,
	CareGapUploadDocumentsResponse,
	CareProtocolOpportunity,
	ChangeEmail200,
	ChangeEmail400,
	ChangeEmail401,
	ChangeEmail403,
	ChangeEmail404,
	ChangeEmail429,
	ChangeEmail500,
	ChangeEmailBody,
	ChangePassword200,
	ChangePassword400,
	ChangePassword401,
	ChangePassword403,
	ChangePassword404,
	ChangePassword429,
	ChangePassword500,
	ChangePasswordBody,
	CleanupIntegrationTestUser200,
	CleanupIntegrationTestUser404,
	CleanupIntegrationTestUserParams,
	CreateAgendaItem401,
	CreateAgendaItem403,
	CreateAgendaItem404,
	CreateAgendaItem500,
	CreateAgendaItem503,
	CreateAgendaItemRequest,
	CreateElationVisitNote401,
	CreateElationVisitNote403,
	CreateElationVisitNote404,
	CreateElationVisitNote500,
	CreateElationVisitNote503,
	CreateElationVisitNoteRequest,
	CreateElationVisitNoteResponse,
	CreateEncounter401,
	CreateEncounter403,
	CreateEncounter404,
	CreateEncounter500,
	CreateEncounter503,
	CreateEncounterRequest,
	CreateHealthConcern401,
	CreateHealthConcern403,
	CreateHealthConcern404,
	CreateHealthConcern500,
	CreateHealthConcern503,
	CreateHealthConcernRequest,
	CreateInvitation,
	CreateInvitation401,
	CreateInvitation403,
	CreateInvitation404,
	CreateInvitation500,
	CreateInvitation503,
	CreateInvitationResponse,
	CreateOrganizationInvitation200,
	CreateOrganizationInvitation400,
	CreateOrganizationInvitation401,
	CreateOrganizationInvitation403,
	CreateOrganizationInvitation404,
	CreateOrganizationInvitation429,
	CreateOrganizationInvitation500,
	CreateOrganizationInvitationBody,
	CreatePatient,
	CreatePatient401,
	CreatePatient403,
	CreatePatient404,
	CreatePatient500,
	CreatePatient503,
	CreatePatientResponse,
	CreateTranscriptionSession401,
	CreateTranscriptionSession403,
	CreateTranscriptionSession404,
	CreateTranscriptionSession500,
	CreateTranscriptionSession503,
	CreateTranscriptionSessionRequest,
	CreateWaitlistEntry201,
	CreateWaitlistEntry400,
	CreateWaitlistEntry429,
	CreateWaitlistEntryBody,
	DeleteAgendaItem401,
	DeleteAgendaItem403,
	DeleteAgendaItem404,
	DeleteAgendaItem500,
	DeleteAgendaItem503,
	DeleteUser200,
	DeleteUser400,
	DeleteUser401,
	DeleteUser403,
	DeleteUser404,
	DeleteUser429,
	DeleteUser500,
	DeleteUserBody,
	DismissCareProtocolOpportunity401,
	DismissCareProtocolOpportunity403,
	DismissCareProtocolOpportunity404,
	DismissCareProtocolOpportunity500,
	DismissCareProtocolOpportunity503,
	Document,
	DocumentJobsCountResponse,
	DocumentViewUrlResponse,
	EhrConnector,
	Encounter,
	GetConnectorCapabilities401,
	GetConnectorCapabilities403,
	GetConnectorCapabilities404,
	GetConnectorCapabilities500,
	GetConnectorCapabilities503,
	GetConnectorCapabilitiesResponse,
	GetDocumentById404,
	GetDocumentViewUrl404,
	GetEncounterById401,
	GetEncounterById403,
	GetEncounterById404,
	GetEncounterById500,
	GetEncounterById503,
	GetEncounterReportPdf401,
	GetEncounterReportPdf403,
	GetEncounterReportPdf404,
	GetEncounterReportPdf500,
	GetEncounterReportPdf503,
	GetEncounterTranscriptLastOffset401,
	GetEncounterTranscriptLastOffset403,
	GetEncounterTranscriptLastOffset404,
	GetEncounterTranscriptLastOffset500,
	GetEncounterTranscriptLastOffset503,
	GetEncounterVisitNoteJson401,
	GetEncounterVisitNoteJson403,
	GetEncounterVisitNoteJson404,
	GetEncounterVisitNoteJson500,
	GetEncounterVisitNoteJson503,
	GetGwStitchWebApiAuthAccountInfo200,
	GetGwStitchWebApiAuthAccountInfo400,
	GetGwStitchWebApiAuthAccountInfo401,
	GetGwStitchWebApiAuthAccountInfo403,
	GetGwStitchWebApiAuthAccountInfo404,
	GetGwStitchWebApiAuthAccountInfo429,
	GetGwStitchWebApiAuthAccountInfo500,
	GetGwStitchWebApiAuthCallbackId400,
	GetGwStitchWebApiAuthCallbackId401,
	GetGwStitchWebApiAuthCallbackId403,
	GetGwStitchWebApiAuthCallbackId404,
	GetGwStitchWebApiAuthCallbackId429,
	GetGwStitchWebApiAuthCallbackId500,
	GetGwStitchWebApiAuthDeleteUserCallback200,
	GetGwStitchWebApiAuthDeleteUserCallback400,
	GetGwStitchWebApiAuthDeleteUserCallback401,
	GetGwStitchWebApiAuthDeleteUserCallback403,
	GetGwStitchWebApiAuthDeleteUserCallback404,
	GetGwStitchWebApiAuthDeleteUserCallback429,
	GetGwStitchWebApiAuthDeleteUserCallback500,
	GetGwStitchWebApiAuthDeleteUserCallbackParams,
	GetGwStitchWebApiAuthError400,
	GetGwStitchWebApiAuthError401,
	GetGwStitchWebApiAuthError403,
	GetGwStitchWebApiAuthError404,
	GetGwStitchWebApiAuthError429,
	GetGwStitchWebApiAuthError500,
	GetGwStitchWebApiAuthMobileOauthHandoffStart400,
	GetGwStitchWebApiAuthMobileOauthHandoffStart401,
	GetGwStitchWebApiAuthMobileOauthHandoffStart403,
	GetGwStitchWebApiAuthMobileOauthHandoffStart404,
	GetGwStitchWebApiAuthMobileOauthHandoffStart429,
	GetGwStitchWebApiAuthMobileOauthHandoffStart500,
	GetGwStitchWebApiAuthOauth2CallbackProviderId200,
	GetGwStitchWebApiAuthOauth2CallbackProviderId400,
	GetGwStitchWebApiAuthOauth2CallbackProviderId401,
	GetGwStitchWebApiAuthOauth2CallbackProviderId403,
	GetGwStitchWebApiAuthOauth2CallbackProviderId404,
	GetGwStitchWebApiAuthOauth2CallbackProviderId429,
	GetGwStitchWebApiAuthOauth2CallbackProviderId500,
	GetGwStitchWebApiAuthOauth2CallbackProviderIdParams,
	GetGwStitchWebApiAuthOk200,
	GetGwStitchWebApiAuthOk400,
	GetGwStitchWebApiAuthOk401,
	GetGwStitchWebApiAuthOk403,
	GetGwStitchWebApiAuthOk404,
	GetGwStitchWebApiAuthOk429,
	GetGwStitchWebApiAuthOk500,
	GetGwStitchWebApiAuthOrganizationGetActiveMember200,
	GetGwStitchWebApiAuthOrganizationGetActiveMember400,
	GetGwStitchWebApiAuthOrganizationGetActiveMember401,
	GetGwStitchWebApiAuthOrganizationGetActiveMember403,
	GetGwStitchWebApiAuthOrganizationGetActiveMember404,
	GetGwStitchWebApiAuthOrganizationGetActiveMember429,
	GetGwStitchWebApiAuthOrganizationGetActiveMember500,
	GetGwStitchWebApiAuthOrganizationGetActiveMemberRole400,
	GetGwStitchWebApiAuthOrganizationGetActiveMemberRole401,
	GetGwStitchWebApiAuthOrganizationGetActiveMemberRole403,
	GetGwStitchWebApiAuthOrganizationGetActiveMemberRole404,
	GetGwStitchWebApiAuthOrganizationGetActiveMemberRole429,
	GetGwStitchWebApiAuthOrganizationGetActiveMemberRole500,
	GetGwStitchWebApiAuthOrganizationGetInvitation200,
	GetGwStitchWebApiAuthOrganizationGetInvitation400,
	GetGwStitchWebApiAuthOrganizationGetInvitation401,
	GetGwStitchWebApiAuthOrganizationGetInvitation403,
	GetGwStitchWebApiAuthOrganizationGetInvitation404,
	GetGwStitchWebApiAuthOrganizationGetInvitation429,
	GetGwStitchWebApiAuthOrganizationGetInvitation500,
	GetGwStitchWebApiAuthOrganizationGetInvitationParams,
	GetGwStitchWebApiAuthOrganizationList400,
	GetGwStitchWebApiAuthOrganizationList401,
	GetGwStitchWebApiAuthOrganizationList403,
	GetGwStitchWebApiAuthOrganizationList404,
	GetGwStitchWebApiAuthOrganizationList429,
	GetGwStitchWebApiAuthOrganizationList500,
	GetGwStitchWebApiAuthOrganizationListInvitations400,
	GetGwStitchWebApiAuthOrganizationListInvitations401,
	GetGwStitchWebApiAuthOrganizationListInvitations403,
	GetGwStitchWebApiAuthOrganizationListInvitations404,
	GetGwStitchWebApiAuthOrganizationListInvitations429,
	GetGwStitchWebApiAuthOrganizationListInvitations500,
	GetGwStitchWebApiAuthOrganizationListMembers400,
	GetGwStitchWebApiAuthOrganizationListMembers401,
	GetGwStitchWebApiAuthOrganizationListMembers403,
	GetGwStitchWebApiAuthOrganizationListMembers404,
	GetGwStitchWebApiAuthOrganizationListMembers429,
	GetGwStitchWebApiAuthOrganizationListMembers500,
	GetGwStitchWebApiAuthOrganizationListUserInvitations200Item,
	GetGwStitchWebApiAuthOrganizationListUserInvitations400,
	GetGwStitchWebApiAuthOrganizationListUserInvitations401,
	GetGwStitchWebApiAuthOrganizationListUserInvitations403,
	GetGwStitchWebApiAuthOrganizationListUserInvitations404,
	GetGwStitchWebApiAuthOrganizationListUserInvitations429,
	GetGwStitchWebApiAuthOrganizationListUserInvitations500,
	GetGwStitchWebApiAuthSignUpStitchStatus400,
	GetGwStitchWebApiAuthSignUpStitchStatus401,
	GetGwStitchWebApiAuthSignUpStitchStatus403,
	GetGwStitchWebApiAuthSignUpStitchStatus404,
	GetGwStitchWebApiAuthSignUpStitchStatus429,
	GetGwStitchWebApiAuthSignUpStitchStatus500,
	GetGwStitchWebApiAuthVerifyEmail200,
	GetGwStitchWebApiAuthVerifyEmail400,
	GetGwStitchWebApiAuthVerifyEmail401,
	GetGwStitchWebApiAuthVerifyEmail403,
	GetGwStitchWebApiAuthVerifyEmail404,
	GetGwStitchWebApiAuthVerifyEmail429,
	GetGwStitchWebApiAuthVerifyEmail500,
	GetGwStitchWebApiAuthVerifyEmailParams,
	GetInvitationResponse,
	GetJobById404,
	GetLatestIntegrationTestEmail200,
	GetLatestIntegrationTestEmail404,
	GetLatestIntegrationTestEmailParams,
	GetLatestIntegrationTestInvitation200,
	GetLatestIntegrationTestInvitation404,
	GetLatestIntegrationTestInvitationParams,
	GetLatestIntegrationTestTwoFactorOtp200,
	GetLatestIntegrationTestTwoFactorOtp404,
	GetLatestIntegrationTestTwoFactorOtpParams,
	GetMe401,
	GetMe403,
	GetMe404,
	GetMe500,
	GetMe503,
	GetMyProvisioningStatus401,
	GetMyProvisioningStatus403,
	GetMyProvisioningStatus404,
	GetMyProvisioningStatus500,
	GetMyProvisioningStatus503,
	GetOrganization400,
	GetOrganization401,
	GetOrganization403,
	GetOrganization404,
	GetOrganization429,
	GetOrganization500,
	GetPatientById401,
	GetPatientById403,
	GetPatientById404,
	GetPatientById500,
	GetPatientById503,
	GetPatientReportHtml401,
	GetPatientReportHtml403,
	GetPatientReportHtml404,
	GetPatientReportHtml500,
	GetPatientReportHtml503,
	GetPatientReportMetadata401,
	GetPatientReportMetadata403,
	GetPatientReportMetadata404,
	GetPatientReportMetadata500,
	GetPatientReportMetadata503,
	GetPracticeById401,
	GetPracticeById403,
	GetPracticeById404,
	GetPracticeById500,
	GetPracticeById503,
	GetSessionGet200,
	GetSessionGet400,
	GetSessionGet401,
	GetSessionGet403,
	GetSessionGet404,
	GetSessionGet429,
	GetSessionGet500,
	GetSessionPost200,
	GetSessionPost400,
	GetSessionPost401,
	GetSessionPost403,
	GetSessionPost404,
	GetSessionPost429,
	GetSessionPost500,
	GetSessionPostBody,
	HealthConcern,
	HealthConcernWithOpportunities,
	IntegrationTestCleanupElationPatient200,
	IntegrationTestCleanupElationPatient401,
	IntegrationTestCleanupElationPatient403,
	IntegrationTestCleanupElationPatient404,
	IntegrationTestCleanupElationPatient500,
	IntegrationTestCleanupElationPatient503,
	IntegrationTestCleanupElationPatientParams,
	IntegrationTestPrepareElationPatient200,
	IntegrationTestPrepareElationPatient401,
	IntegrationTestPrepareElationPatient403,
	IntegrationTestPrepareElationPatient404,
	IntegrationTestPrepareElationPatient500,
	IntegrationTestPrepareElationPatient503,
	IntegrationTestPrepareElationPatientBody,
	InvitationAlreadyExists,
	InvitationInvalid,
	InvitationNotFound,
	JobUnion,
	LinkSocialAccount200,
	LinkSocialAccount400,
	LinkSocialAccount401,
	LinkSocialAccount403,
	LinkSocialAccount404,
	LinkSocialAccount429,
	LinkSocialAccount500,
	LinkSocialAccountBody,
	ListActionItemsForEncounter401,
	ListActionItemsForEncounter403,
	ListActionItemsForEncounter404,
	ListActionItemsForEncounter500,
	ListActionItemsForEncounter503,
	ListAgendaItems401,
	ListAgendaItems403,
	ListAgendaItems404,
	ListAgendaItems500,
	ListAgendaItems503,
	ListCareGapUploadDocumentsParams,
	ListCareProtocolOpportunities401,
	ListCareProtocolOpportunities403,
	ListCareProtocolOpportunities404,
	ListCareProtocolOpportunities500,
	ListCareProtocolOpportunities503,
	ListCareProtocolOpportunitiesParams,
	ListCareProtocolOpportunitiesResponse,
	ListEncounters401,
	ListEncounters403,
	ListEncounters404,
	ListEncounters500,
	ListEncounters503,
	ListEncountersByPatient401,
	ListEncountersByPatient403,
	ListEncountersByPatient404,
	ListEncountersByPatient500,
	ListEncountersByPatient503,
	ListEncountersByPatientParams,
	ListEncountersByPatientResponse,
	ListEncountersParams,
	ListEncountersResponse,
	ListHealthConcerns401,
	ListHealthConcerns403,
	ListHealthConcerns404,
	ListHealthConcerns500,
	ListHealthConcerns503,
	ListMedicalCodesByEncounter401,
	ListMedicalCodesByEncounter403,
	ListMedicalCodesByEncounter404,
	ListMedicalCodesByEncounter500,
	ListMedicalCodesByEncounter503,
	ListMedicalCodesByEncounterResponse,
	ListPatientCareProtocolOpportunities401,
	ListPatientCareProtocolOpportunities403,
	ListPatientCareProtocolOpportunities404,
	ListPatientCareProtocolOpportunities500,
	ListPatientCareProtocolOpportunities503,
	ListPracticeMembers401,
	ListPracticeMembers403,
	ListPracticeMembers404,
	ListPracticeMembers500,
	ListPracticeMembers503,
	ListPracticeMembersParams,
	ListPracticeMembersResponse,
	ListTranscriptItemsForEncounter401,
	ListTranscriptItemsForEncounter403,
	ListTranscriptItemsForEncounter404,
	ListTranscriptItemsForEncounter500,
	ListTranscriptItemsForEncounter503,
	ListTranscriptItemsForScribingSession401,
	ListTranscriptItemsForScribingSession403,
	ListTranscriptItemsForScribingSession404,
	ListTranscriptItemsForScribingSession500,
	ListTranscriptItemsForScribingSession503,
	ListTranscriptItemsResponse,
	ListUnmatchedPatientUploadsParams,
	ListUserAccounts200Item,
	ListUserAccounts400,
	ListUserAccounts401,
	ListUserAccounts403,
	ListUserAccounts404,
	ListUserAccounts429,
	ListUserAccounts500,
	ListUserSessions400,
	ListUserSessions401,
	ListUserSessions403,
	ListUserSessions404,
	ListUserSessions429,
	ListUserSessions500,
	MeProfile,
	Organization,
	Patient,
	PatientCareProtocolOpportunities,
	PatientSearchResult,
	Physician,
	PhysicianNotFound,
	PhysicianNpiSearchResponse,
	PhysicianNpiVerifyRequest,
	PhysicianNpiVerifyResponse,
	PostGwStitchWebApiAuthCallbackId400,
	PostGwStitchWebApiAuthCallbackId401,
	PostGwStitchWebApiAuthCallbackId403,
	PostGwStitchWebApiAuthCallbackId404,
	PostGwStitchWebApiAuthCallbackId429,
	PostGwStitchWebApiAuthCallbackId500,
	PostGwStitchWebApiAuthCallbackIdBody,
	PostGwStitchWebApiAuthExchangeElationJwt200,
	PostGwStitchWebApiAuthExchangeElationJwt400,
	PostGwStitchWebApiAuthExchangeElationJwt401,
	PostGwStitchWebApiAuthExchangeElationJwt403,
	PostGwStitchWebApiAuthExchangeElationJwt404,
	PostGwStitchWebApiAuthExchangeElationJwt429,
	PostGwStitchWebApiAuthExchangeElationJwt500,
	PostGwStitchWebApiAuthExchangeElationJwtBody,
	PostGwStitchWebApiAuthGetAccessToken200,
	PostGwStitchWebApiAuthGetAccessToken401,
	PostGwStitchWebApiAuthGetAccessToken403,
	PostGwStitchWebApiAuthGetAccessToken404,
	PostGwStitchWebApiAuthGetAccessToken429,
	PostGwStitchWebApiAuthGetAccessToken500,
	PostGwStitchWebApiAuthGetAccessTokenBody,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange200,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange400,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange401,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange403,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange404,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange429,
	PostGwStitchWebApiAuthMobileOauthHandoffExchange500,
	PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody,
	PostGwStitchWebApiAuthOauth2Link200,
	PostGwStitchWebApiAuthOauth2Link400,
	PostGwStitchWebApiAuthOauth2Link401,
	PostGwStitchWebApiAuthOauth2Link403,
	PostGwStitchWebApiAuthOauth2Link404,
	PostGwStitchWebApiAuthOauth2Link429,
	PostGwStitchWebApiAuthOauth2Link500,
	PostGwStitchWebApiAuthOauth2LinkBody,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation200,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation400,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation401,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation403,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation404,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation429,
	PostGwStitchWebApiAuthOrganizationAcceptInvitation500,
	PostGwStitchWebApiAuthOrganizationAcceptInvitationBody,
	PostGwStitchWebApiAuthOrganizationCancelInvitation400,
	PostGwStitchWebApiAuthOrganizationCancelInvitation401,
	PostGwStitchWebApiAuthOrganizationCancelInvitation403,
	PostGwStitchWebApiAuthOrganizationCancelInvitation404,
	PostGwStitchWebApiAuthOrganizationCancelInvitation429,
	PostGwStitchWebApiAuthOrganizationCancelInvitation500,
	PostGwStitchWebApiAuthOrganizationCancelInvitationBody,
	PostGwStitchWebApiAuthOrganizationCheckSlug400,
	PostGwStitchWebApiAuthOrganizationCheckSlug401,
	PostGwStitchWebApiAuthOrganizationCheckSlug403,
	PostGwStitchWebApiAuthOrganizationCheckSlug404,
	PostGwStitchWebApiAuthOrganizationCheckSlug429,
	PostGwStitchWebApiAuthOrganizationCheckSlug500,
	PostGwStitchWebApiAuthOrganizationCheckSlugBody,
	PostGwStitchWebApiAuthOrganizationCreate400,
	PostGwStitchWebApiAuthOrganizationCreate401,
	PostGwStitchWebApiAuthOrganizationCreate403,
	PostGwStitchWebApiAuthOrganizationCreate404,
	PostGwStitchWebApiAuthOrganizationCreate429,
	PostGwStitchWebApiAuthOrganizationCreate500,
	PostGwStitchWebApiAuthOrganizationCreateBody,
	PostGwStitchWebApiAuthOrganizationDelete400,
	PostGwStitchWebApiAuthOrganizationDelete401,
	PostGwStitchWebApiAuthOrganizationDelete403,
	PostGwStitchWebApiAuthOrganizationDelete404,
	PostGwStitchWebApiAuthOrganizationDelete429,
	PostGwStitchWebApiAuthOrganizationDelete500,
	PostGwStitchWebApiAuthOrganizationDeleteBody,
	PostGwStitchWebApiAuthOrganizationHasPermission200,
	PostGwStitchWebApiAuthOrganizationHasPermission400,
	PostGwStitchWebApiAuthOrganizationHasPermission401,
	PostGwStitchWebApiAuthOrganizationHasPermission403,
	PostGwStitchWebApiAuthOrganizationHasPermission404,
	PostGwStitchWebApiAuthOrganizationHasPermission429,
	PostGwStitchWebApiAuthOrganizationHasPermission500,
	PostGwStitchWebApiAuthOrganizationHasPermissionBody,
	PostGwStitchWebApiAuthOrganizationLeave400,
	PostGwStitchWebApiAuthOrganizationLeave401,
	PostGwStitchWebApiAuthOrganizationLeave403,
	PostGwStitchWebApiAuthOrganizationLeave404,
	PostGwStitchWebApiAuthOrganizationLeave429,
	PostGwStitchWebApiAuthOrganizationLeave500,
	PostGwStitchWebApiAuthOrganizationLeaveBody,
	PostGwStitchWebApiAuthOrganizationRejectInvitation200,
	PostGwStitchWebApiAuthOrganizationRejectInvitation400,
	PostGwStitchWebApiAuthOrganizationRejectInvitation401,
	PostGwStitchWebApiAuthOrganizationRejectInvitation403,
	PostGwStitchWebApiAuthOrganizationRejectInvitation404,
	PostGwStitchWebApiAuthOrganizationRejectInvitation429,
	PostGwStitchWebApiAuthOrganizationRejectInvitation500,
	PostGwStitchWebApiAuthOrganizationRejectInvitationBody,
	PostGwStitchWebApiAuthOrganizationRemoveMember200,
	PostGwStitchWebApiAuthOrganizationRemoveMember400,
	PostGwStitchWebApiAuthOrganizationRemoveMember401,
	PostGwStitchWebApiAuthOrganizationRemoveMember403,
	PostGwStitchWebApiAuthOrganizationRemoveMember404,
	PostGwStitchWebApiAuthOrganizationRemoveMember429,
	PostGwStitchWebApiAuthOrganizationRemoveMember500,
	PostGwStitchWebApiAuthOrganizationRemoveMemberBody,
	PostGwStitchWebApiAuthOrganizationUpdate400,
	PostGwStitchWebApiAuthOrganizationUpdate401,
	PostGwStitchWebApiAuthOrganizationUpdate403,
	PostGwStitchWebApiAuthOrganizationUpdate404,
	PostGwStitchWebApiAuthOrganizationUpdate429,
	PostGwStitchWebApiAuthOrganizationUpdate500,
	PostGwStitchWebApiAuthOrganizationUpdateBody,
	PostGwStitchWebApiAuthRefreshToken200,
	PostGwStitchWebApiAuthRefreshToken401,
	PostGwStitchWebApiAuthRefreshToken403,
	PostGwStitchWebApiAuthRefreshToken404,
	PostGwStitchWebApiAuthRefreshToken429,
	PostGwStitchWebApiAuthRefreshToken500,
	PostGwStitchWebApiAuthRefreshTokenBody,
	PostGwStitchWebApiAuthRevokeOtherSessions200,
	PostGwStitchWebApiAuthRevokeOtherSessions400,
	PostGwStitchWebApiAuthRevokeOtherSessions401,
	PostGwStitchWebApiAuthRevokeOtherSessions403,
	PostGwStitchWebApiAuthRevokeOtherSessions404,
	PostGwStitchWebApiAuthRevokeOtherSessions429,
	PostGwStitchWebApiAuthRevokeOtherSessions500,
	PostGwStitchWebApiAuthRevokeOtherSessionsBody,
	PostGwStitchWebApiAuthRevokeSession200,
	PostGwStitchWebApiAuthRevokeSession400,
	PostGwStitchWebApiAuthRevokeSession401,
	PostGwStitchWebApiAuthRevokeSession403,
	PostGwStitchWebApiAuthRevokeSession404,
	PostGwStitchWebApiAuthRevokeSession429,
	PostGwStitchWebApiAuthRevokeSession500,
	PostGwStitchWebApiAuthRevokeSessionBody,
	PostGwStitchWebApiAuthRevokeSessions200,
	PostGwStitchWebApiAuthRevokeSessions400,
	PostGwStitchWebApiAuthRevokeSessions401,
	PostGwStitchWebApiAuthRevokeSessions403,
	PostGwStitchWebApiAuthRevokeSessions404,
	PostGwStitchWebApiAuthRevokeSessions429,
	PostGwStitchWebApiAuthRevokeSessions500,
	PostGwStitchWebApiAuthRevokeSessionsBody,
	PostGwStitchWebApiAuthSignInOauth2200,
	PostGwStitchWebApiAuthSignInOauth2400,
	PostGwStitchWebApiAuthSignInOauth2401,
	PostGwStitchWebApiAuthSignInOauth2403,
	PostGwStitchWebApiAuthSignInOauth2404,
	PostGwStitchWebApiAuthSignInOauth2429,
	PostGwStitchWebApiAuthSignInOauth2500,
	PostGwStitchWebApiAuthSignInOauth2Body,
	PostGwStitchWebApiAuthSignUpStitch400,
	PostGwStitchWebApiAuthSignUpStitch401,
	PostGwStitchWebApiAuthSignUpStitch403,
	PostGwStitchWebApiAuthSignUpStitch404,
	PostGwStitchWebApiAuthSignUpStitch429,
	PostGwStitchWebApiAuthSignUpStitch500,
	PostGwStitchWebApiAuthSignUpStitchBody,
	PostGwStitchWebApiAuthSignUpStitchComplete400,
	PostGwStitchWebApiAuthSignUpStitchComplete401,
	PostGwStitchWebApiAuthSignUpStitchComplete403,
	PostGwStitchWebApiAuthSignUpStitchComplete404,
	PostGwStitchWebApiAuthSignUpStitchComplete429,
	PostGwStitchWebApiAuthSignUpStitchComplete500,
	PostGwStitchWebApiAuthTwoFactorDisable200,
	PostGwStitchWebApiAuthTwoFactorDisable400,
	PostGwStitchWebApiAuthTwoFactorDisable401,
	PostGwStitchWebApiAuthTwoFactorDisable403,
	PostGwStitchWebApiAuthTwoFactorDisable404,
	PostGwStitchWebApiAuthTwoFactorDisable429,
	PostGwStitchWebApiAuthTwoFactorDisable500,
	PostGwStitchWebApiAuthTwoFactorDisableBody,
	PostGwStitchWebApiAuthTwoFactorEnable200,
	PostGwStitchWebApiAuthTwoFactorEnable400,
	PostGwStitchWebApiAuthTwoFactorEnable401,
	PostGwStitchWebApiAuthTwoFactorEnable403,
	PostGwStitchWebApiAuthTwoFactorEnable404,
	PostGwStitchWebApiAuthTwoFactorEnable429,
	PostGwStitchWebApiAuthTwoFactorEnable500,
	PostGwStitchWebApiAuthTwoFactorEnableBody,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes200,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes400,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes401,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes403,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes404,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes429,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes500,
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri200,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri400,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri401,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri403,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri404,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri429,
	PostGwStitchWebApiAuthTwoFactorGetTotpUri500,
	PostGwStitchWebApiAuthTwoFactorGetTotpUriBody,
	PostGwStitchWebApiAuthTwoFactorSendOtp200,
	PostGwStitchWebApiAuthTwoFactorSendOtp400,
	PostGwStitchWebApiAuthTwoFactorSendOtp401,
	PostGwStitchWebApiAuthTwoFactorSendOtp403,
	PostGwStitchWebApiAuthTwoFactorSendOtp404,
	PostGwStitchWebApiAuthTwoFactorSendOtp429,
	PostGwStitchWebApiAuthTwoFactorSendOtp500,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode200,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode400,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode401,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode403,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode404,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode429,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCode500,
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp200,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp400,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp401,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp403,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp404,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp429,
	PostGwStitchWebApiAuthTwoFactorVerifyOtp500,
	PostGwStitchWebApiAuthTwoFactorVerifyOtpBody,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp200,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp400,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp401,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp403,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp404,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp429,
	PostGwStitchWebApiAuthTwoFactorVerifyTotp500,
	PostGwStitchWebApiAuthTwoFactorVerifyTotpBody,
	PostGwStitchWebApiAuthUnlinkAccount200,
	PostGwStitchWebApiAuthUnlinkAccount400,
	PostGwStitchWebApiAuthUnlinkAccount401,
	PostGwStitchWebApiAuthUnlinkAccount403,
	PostGwStitchWebApiAuthUnlinkAccount404,
	PostGwStitchWebApiAuthUnlinkAccount429,
	PostGwStitchWebApiAuthUnlinkAccount500,
	PostGwStitchWebApiAuthUnlinkAccountBody,
	Practice,
	RedoxWebhook200,
	RedoxWebhookBody,
	ReorderAgendaItems401,
	ReorderAgendaItems403,
	ReorderAgendaItems404,
	ReorderAgendaItems500,
	ReorderAgendaItems503,
	ReorderAgendaItemsRequest,
	ReportMetadataResponse,
	ReprocessBulkUpload200,
	ReprocessBulkUpload404,
	ReprocessDocument200,
	ReprocessDocument404,
	ReprocessDocument409,
	RequestPasswordReset200,
	RequestPasswordReset400,
	RequestPasswordReset401,
	RequestPasswordReset403,
	RequestPasswordReset404,
	RequestPasswordReset429,
	RequestPasswordReset500,
	RequestPasswordResetBody,
	ResetPassword200,
	ResetPassword400,
	ResetPassword401,
	ResetPassword403,
	ResetPassword404,
	ResetPassword429,
	ResetPassword500,
	ResetPasswordBody,
	ResetPasswordCallback200,
	ResetPasswordCallback400,
	ResetPasswordCallback401,
	ResetPasswordCallback403,
	ResetPasswordCallback404,
	ResetPasswordCallback429,
	ResetPasswordCallback500,
	ResetPasswordCallbackParams,
	ScribingSessionLastOffsetResponse,
	SearchPatients401,
	SearchPatients403,
	SearchPatients404,
	SearchPatients500,
	SearchPatients503,
	SearchPatientsParams,
	SearchPhysiciansByNpiParams,
	SendVerificationEmail200,
	SendVerificationEmail400,
	SendVerificationEmail401,
	SendVerificationEmail403,
	SendVerificationEmail404,
	SendVerificationEmail429,
	SendVerificationEmail500,
	SendVerificationEmailBody,
	Session,
	SetActiveOrganization400,
	SetActiveOrganization401,
	SetActiveOrganization403,
	SetActiveOrganization404,
	SetActiveOrganization429,
	SetActiveOrganization500,
	SetActiveOrganizationBody,
	SignInEmail200,
	SignInEmail400,
	SignInEmail401,
	SignInEmail403,
	SignInEmail404,
	SignInEmail429,
	SignInEmail500,
	SignInEmailBody,
	SignOut200,
	SignOut400,
	SignOut401,
	SignOut403,
	SignOut404,
	SignOut429,
	SignOut500,
	SignOutBody,
	SignUpWithEmailAndPassword200,
	SignUpWithEmailAndPassword400,
	SignUpWithEmailAndPassword401,
	SignUpWithEmailAndPassword403,
	SignUpWithEmailAndPassword404,
	SignUpWithEmailAndPassword422,
	SignUpWithEmailAndPassword429,
	SignUpWithEmailAndPassword500,
	SignUpWithEmailAndPasswordBody,
	SocialSignIn200,
	SocialSignIn400,
	SocialSignIn401,
	SocialSignIn403,
	SocialSignIn404,
	SocialSignIn429,
	SocialSignIn500,
	SocialSignInBody,
	Staff,
	StaffNotFound,
	StatusSnapshot,
	StreamPhysicianEvents401,
	StreamPhysicianEvents403,
	StreamPhysicianEvents404,
	StreamPhysicianEvents500,
	StreamPhysicianEvents503,
	StreamPhysicianEventsParams,
	SyncPatientByEhr401,
	SyncPatientByEhr403,
	SyncPatientByEhr404,
	SyncPatientByEhr500,
	SyncPatientByEhr503,
	SyncPatientByEhrResponse,
	TranscribeAudio401,
	TranscribeAudio403,
	TranscribeAudio404,
	TranscribeAudio500,
	TranscribeAudio503,
	TranscribeErrorResponse,
	TranscribeRequest,
	TranscribeResponse,
	TranscriptionSessionResponse,
	UnmatchedPatientUploadsResponse,
	UpdateActionItemStatus401,
	UpdateActionItemStatus403,
	UpdateActionItemStatus404,
	UpdateActionItemStatus500,
	UpdateActionItemStatus503,
	UpdateActionItemStatusRequest,
	UpdateAgendaItem401,
	UpdateAgendaItem403,
	UpdateAgendaItem404,
	UpdateAgendaItem500,
	UpdateAgendaItem503,
	UpdateAgendaItemRequest,
	UpdateEncounterById401,
	UpdateEncounterById403,
	UpdateEncounterById404,
	UpdateEncounterById500,
	UpdateEncounterById503,
	UpdateEncounterNote401,
	UpdateEncounterNote403,
	UpdateEncounterNote404,
	UpdateEncounterNote500,
	UpdateEncounterNote503,
	UpdateEncounterNoteRequest,
	UpdateEncounterNoteResponse,
	UpdateEncounterRequest,
	UpdateMyPassword400,
	UpdateMyPassword401,
	UpdateMyPassword403,
	UpdateMyPassword404,
	UpdateMyPassword500,
	UpdateMyPassword503,
	UpdateOpportunityStatus401,
	UpdateOpportunityStatus403,
	UpdateOpportunityStatus404,
	UpdateOpportunityStatus500,
	UpdateOpportunityStatus503,
	UpdateOpportunityStatusRequest,
	UpdateOrganizationMemberRole200,
	UpdateOrganizationMemberRole400,
	UpdateOrganizationMemberRole401,
	UpdateOrganizationMemberRole403,
	UpdateOrganizationMemberRole404,
	UpdateOrganizationMemberRole429,
	UpdateOrganizationMemberRole500,
	UpdateOrganizationMemberRoleBody,
	UpdatePatient,
	UpdatePatient401,
	UpdatePatient403,
	UpdatePatient404,
	UpdatePatient500,
	UpdatePatient503,
	UpdatePhysician,
	UpdatePractice,
	UpdatePractice401,
	UpdatePractice403,
	UpdatePractice404,
	UpdatePractice500,
	UpdatePractice503,
	UpdateSession200,
	UpdateSession400,
	UpdateSession401,
	UpdateSession403,
	UpdateSession404,
	UpdateSession429,
	UpdateSession500,
	UpdateSessionBody,
	UpdateStaff,
	UpdateStaff500,
	UpdateUser200,
	UpdateUser400,
	UpdateUser401,
	UpdateUser403,
	UpdateUser404,
	UpdateUser429,
	UpdateUser500,
	UpdateUserBody,
	UploadUrlRequest,
	UploadUrlResponse,
	UuidString,
	VerifyPassword200,
	VerifyPassword400,
	VerifyPassword401,
	VerifyPassword403,
	VerifyPassword404,
	VerifyPassword429,
	VerifyPassword500,
	VerifyPasswordBody,
	VisitNoteJsonResponse,
} from './models';
import { customInstance } from '../core/customInstance';
import type { ErrorType } from '../core/customInstance';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getGwStitchWebOpenapiJson = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/stitch-web/openapi.json`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebOpenapiJsonQueryKey = () => {
	return [`/gw/stitch-web/openapi.json`] as const;
};

export const getGetGwStitchWebOpenapiJsonQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwStitchWebOpenapiJsonQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>
	> = ({ signal }) => getGwStitchWebOpenapiJson(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebOpenapiJsonQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>
>;
export type GetGwStitchWebOpenapiJsonQueryError = ErrorType<unknown>;

export const useGetGwStitchWebOpenapiJson = <
	TData = Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebOpenapiJson>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebOpenapiJsonQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getGwStitchWebDocs = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/docs`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebDocsQueryKey = () => {
	return [`/gw/stitch-web/docs`] as const;
};

export const getGetGwStitchWebDocsQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebDocs>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebDocs>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetGwStitchWebDocsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebDocs>>
	> = ({ signal }) => getGwStitchWebDocs(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebDocs>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebDocsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebDocs>>
>;
export type GetGwStitchWebDocsQueryError = ErrorType<unknown>;

export const useGetGwStitchWebDocs = <
	TData = Awaited<ReturnType<typeof getGwStitchWebDocs>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebDocs>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebDocsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getGwStitchWebAiEval = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/ai-eval`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebAiEvalQueryKey = () => {
	return [`/gw/stitch-web/ai-eval`] as const;
};

export const getGetGwStitchWebAiEvalQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebAiEval>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebAiEval>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetGwStitchWebAiEvalQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebAiEval>>
	> = ({ signal }) => getGwStitchWebAiEval(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebAiEval>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebAiEvalQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebAiEval>>
>;
export type GetGwStitchWebAiEvalQueryError = ErrorType<unknown>;

export const useGetGwStitchWebAiEval = <
	TData = Awaited<ReturnType<typeof getGwStitchWebAiEval>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebAiEval>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebAiEvalQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getGwStitchWebAiEvalPath = (
	path: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/stitch-web/ai-eval/${path}`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebAiEvalPathQueryKey = (path: string) => {
	return [`/gw/stitch-web/ai-eval/${path}`] as const;
};

export const getGetGwStitchWebAiEvalPathQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>,
	TError = ErrorType<unknown>,
>(
	path: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwStitchWebAiEvalPathQueryKey(path);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>
	> = ({ signal }) => getGwStitchWebAiEvalPath(path, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!path,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebAiEvalPathQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>
>;
export type GetGwStitchWebAiEvalPathQueryError = ErrorType<unknown>;

export const useGetGwStitchWebAiEvalPath = <
	TData = Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>,
	TError = ErrorType<unknown>,
>(
	path: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebAiEvalPath>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebAiEvalPathQueryOptions(path, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updateMyPassword = (
	authUpdatePasswordRequest: AuthUpdatePasswordRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<AuthUpdatePasswordResponse>(
		{
			url: `/gw/stitch-web/api/auth/me/password`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: authUpdatePasswordRequest,
		},
		options,
	);
};

export const getUpdateMyPasswordMutationOptions = <
	TError = ErrorType<
		| UpdateMyPassword400
		| UpdateMyPassword401
		| UpdateMyPassword403
		| UpdateMyPassword404
		| UpdateMyPassword500
		| UpdateMyPassword503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateMyPassword>>,
		TError,
		{ data: AuthUpdatePasswordRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateMyPassword>>,
	TError,
	{ data: AuthUpdatePasswordRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMyPassword>>,
		{ data: AuthUpdatePasswordRequest }
	> = (props) => {
		const { data } = props ?? {};

		return updateMyPassword(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMyPasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMyPassword>>
>;
export type UpdateMyPasswordMutationBody = AuthUpdatePasswordRequest;
export type UpdateMyPasswordMutationError = ErrorType<
	| UpdateMyPassword400
	| UpdateMyPassword401
	| UpdateMyPassword403
	| UpdateMyPassword404
	| UpdateMyPassword500
	| UpdateMyPassword503
>;

export const useUpdateMyPassword = <
	TError = ErrorType<
		| UpdateMyPassword400
		| UpdateMyPassword401
		| UpdateMyPassword403
		| UpdateMyPassword404
		| UpdateMyPassword500
		| UpdateMyPassword503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateMyPassword>>,
		TError,
		{ data: AuthUpdatePasswordRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateMyPassword>>,
	TError,
	{ data: AuthUpdatePasswordRequest },
	TContext
> => {
	const mutationOptions = getUpdateMyPasswordMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getMyProvisioningStatus = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<AuthProvisioningStatus>(
		{
			url: `/gw/stitch-web/api/auth/me/provisioning-status`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetMyProvisioningStatusQueryKey = () => {
	return [`/gw/stitch-web/api/auth/me/provisioning-status`] as const;
};

export const getGetMyProvisioningStatusQueryOptions = <
	TData = Awaited<ReturnType<typeof getMyProvisioningStatus>>,
	TError = ErrorType<
		| GetMyProvisioningStatus401
		| GetMyProvisioningStatus403
		| GetMyProvisioningStatus404
		| GetMyProvisioningStatus500
		| GetMyProvisioningStatus503
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getMyProvisioningStatus>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetMyProvisioningStatusQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getMyProvisioningStatus>>
	> = ({ signal }) => getMyProvisioningStatus(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getMyProvisioningStatus>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetMyProvisioningStatusQueryResult = NonNullable<
	Awaited<ReturnType<typeof getMyProvisioningStatus>>
>;
export type GetMyProvisioningStatusQueryError = ErrorType<
	| GetMyProvisioningStatus401
	| GetMyProvisioningStatus403
	| GetMyProvisioningStatus404
	| GetMyProvisioningStatus500
	| GetMyProvisioningStatus503
>;

export const useGetMyProvisioningStatus = <
	TData = Awaited<ReturnType<typeof getMyProvisioningStatus>>,
	TError = ErrorType<
		| GetMyProvisioningStatus401
		| GetMyProvisioningStatus403
		| GetMyProvisioningStatus404
		| GetMyProvisioningStatus500
		| GetMyProvisioningStatus503
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getMyProvisioningStatus>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetMyProvisioningStatusQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getMe = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<MeProfile>(
		{ url: `/gw/stitch-web/api/auth/me`, method: 'GET', signal },
		options,
	);
};

export const getGetMeQueryKey = () => {
	return [`/gw/stitch-web/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
	TData = Awaited<ReturnType<typeof getMe>>,
	TError = ErrorType<GetMe401 | GetMe403 | GetMe404 | GetMe500 | GetMe503>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
		signal,
	}) => getMe(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getMe>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<
	GetMe401 | GetMe403 | GetMe404 | GetMe500 | GetMe503
>;

export const useGetMe = <
	TData = Awaited<ReturnType<typeof getMe>>,
	TError = ErrorType<GetMe401 | GetMe403 | GetMe404 | GetMe500 | GetMe503>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetMeQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getStatus = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<StatusSnapshot>(
		{ url: `/gw/stitch-web/api/status`, method: 'GET', signal },
		options,
	);
};

export const getGetStatusQueryKey = () => {
	return [`/gw/stitch-web/api/status`] as const;
};

export const getGetStatusQueryOptions = <
	TData = Awaited<ReturnType<typeof getStatus>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetStatusQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatus>>> = ({
		signal,
	}) => getStatus(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getStatus>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetStatusQueryResult = NonNullable<
	Awaited<ReturnType<typeof getStatus>>
>;
export type GetStatusQueryError = ErrorType<unknown>;

export const useGetStatus = <
	TData = Awaited<ReturnType<typeof getStatus>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetStatusQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const redoxWebhook = (
	redoxWebhookBody: RedoxWebhookBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<RedoxWebhook200>(
		{
			url: `/gw/stitch-web/api/webhooks/redox`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: redoxWebhookBody,
		},
		options,
	);
};

export const getRedoxWebhookMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof redoxWebhook>>,
		TError,
		{ data: RedoxWebhookBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof redoxWebhook>>,
	TError,
	{ data: RedoxWebhookBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof redoxWebhook>>,
		{ data: RedoxWebhookBody }
	> = (props) => {
		const { data } = props ?? {};

		return redoxWebhook(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RedoxWebhookMutationResult = NonNullable<
	Awaited<ReturnType<typeof redoxWebhook>>
>;
export type RedoxWebhookMutationBody = RedoxWebhookBody;
export type RedoxWebhookMutationError = ErrorType<unknown>;

export const useRedoxWebhook = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof redoxWebhook>>,
		TError,
		{ data: RedoxWebhookBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof redoxWebhook>>,
	TError,
	{ data: RedoxWebhookBody },
	TContext
> => {
	const mutationOptions = getRedoxWebhookMutationOptions(options);

	return useMutation(mutationOptions);
};

export const createWaitlistEntry = (
	createWaitlistEntryBody: CreateWaitlistEntryBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CreateWaitlistEntry201>(
		{
			url: `/gw/stitch-web/api/marketing/waitlist`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createWaitlistEntryBody,
		},
		options,
	);
};

export const getCreateWaitlistEntryMutationOptions = <
	TError = ErrorType<CreateWaitlistEntry400 | CreateWaitlistEntry429>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createWaitlistEntry>>,
		TError,
		{ data: CreateWaitlistEntryBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createWaitlistEntry>>,
	TError,
	{ data: CreateWaitlistEntryBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createWaitlistEntry>>,
		{ data: CreateWaitlistEntryBody }
	> = (props) => {
		const { data } = props ?? {};

		return createWaitlistEntry(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateWaitlistEntryMutationResult = NonNullable<
	Awaited<ReturnType<typeof createWaitlistEntry>>
>;
export type CreateWaitlistEntryMutationBody = CreateWaitlistEntryBody;
export type CreateWaitlistEntryMutationError = ErrorType<
	CreateWaitlistEntry400 | CreateWaitlistEntry429
>;

export const useCreateWaitlistEntry = <
	TError = ErrorType<CreateWaitlistEntry400 | CreateWaitlistEntry429>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createWaitlistEntry>>,
		TError,
		{ data: CreateWaitlistEntryBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createWaitlistEntry>>,
	TError,
	{ data: CreateWaitlistEntryBody },
	TContext
> => {
	const mutationOptions = getCreateWaitlistEntryMutationOptions(options);

	return useMutation(mutationOptions);
};

export const integrationTestPrepareElationPatient = (
	integrationTestPrepareElationPatientBody: IntegrationTestPrepareElationPatientBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<IntegrationTestPrepareElationPatient200>(
		{
			url: `/gw/stitch-web/api/integration-tests/elation/prepare`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: integrationTestPrepareElationPatientBody,
		},
		options,
	);
};

export const getIntegrationTestPrepareElationPatientMutationOptions = <
	TError = ErrorType<
		| IntegrationTestPrepareElationPatient401
		| IntegrationTestPrepareElationPatient403
		| IntegrationTestPrepareElationPatient404
		| IntegrationTestPrepareElationPatient500
		| IntegrationTestPrepareElationPatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof integrationTestPrepareElationPatient>>,
		TError,
		{ data: IntegrationTestPrepareElationPatientBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof integrationTestPrepareElationPatient>>,
	TError,
	{ data: IntegrationTestPrepareElationPatientBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof integrationTestPrepareElationPatient>>,
		{ data: IntegrationTestPrepareElationPatientBody }
	> = (props) => {
		const { data } = props ?? {};

		return integrationTestPrepareElationPatient(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type IntegrationTestPrepareElationPatientMutationResult = NonNullable<
	Awaited<ReturnType<typeof integrationTestPrepareElationPatient>>
>;
export type IntegrationTestPrepareElationPatientMutationBody =
	IntegrationTestPrepareElationPatientBody;
export type IntegrationTestPrepareElationPatientMutationError = ErrorType<
	| IntegrationTestPrepareElationPatient401
	| IntegrationTestPrepareElationPatient403
	| IntegrationTestPrepareElationPatient404
	| IntegrationTestPrepareElationPatient500
	| IntegrationTestPrepareElationPatient503
>;

export const useIntegrationTestPrepareElationPatient = <
	TError = ErrorType<
		| IntegrationTestPrepareElationPatient401
		| IntegrationTestPrepareElationPatient403
		| IntegrationTestPrepareElationPatient404
		| IntegrationTestPrepareElationPatient500
		| IntegrationTestPrepareElationPatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof integrationTestPrepareElationPatient>>,
		TError,
		{ data: IntegrationTestPrepareElationPatientBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof integrationTestPrepareElationPatient>>,
	TError,
	{ data: IntegrationTestPrepareElationPatientBody },
	TContext
> => {
	const mutationOptions =
		getIntegrationTestPrepareElationPatientMutationOptions(options);

	return useMutation(mutationOptions);
};

export const integrationTestCleanupElationPatient = (
	params: IntegrationTestCleanupElationPatientParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<IntegrationTestCleanupElationPatient200>(
		{
			url: `/gw/stitch-web/api/integration-tests/elation/cleanup`,
			method: 'DELETE',
			params,
		},
		options,
	);
};

export const getIntegrationTestCleanupElationPatientMutationOptions = <
	TError = ErrorType<
		| IntegrationTestCleanupElationPatient401
		| IntegrationTestCleanupElationPatient403
		| IntegrationTestCleanupElationPatient404
		| IntegrationTestCleanupElationPatient500
		| IntegrationTestCleanupElationPatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof integrationTestCleanupElationPatient>>,
		TError,
		{ params: IntegrationTestCleanupElationPatientParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof integrationTestCleanupElationPatient>>,
	TError,
	{ params: IntegrationTestCleanupElationPatientParams },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof integrationTestCleanupElationPatient>>,
		{ params: IntegrationTestCleanupElationPatientParams }
	> = (props) => {
		const { params } = props ?? {};

		return integrationTestCleanupElationPatient(params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type IntegrationTestCleanupElationPatientMutationResult = NonNullable<
	Awaited<ReturnType<typeof integrationTestCleanupElationPatient>>
>;

export type IntegrationTestCleanupElationPatientMutationError = ErrorType<
	| IntegrationTestCleanupElationPatient401
	| IntegrationTestCleanupElationPatient403
	| IntegrationTestCleanupElationPatient404
	| IntegrationTestCleanupElationPatient500
	| IntegrationTestCleanupElationPatient503
>;

export const useIntegrationTestCleanupElationPatient = <
	TError = ErrorType<
		| IntegrationTestCleanupElationPatient401
		| IntegrationTestCleanupElationPatient403
		| IntegrationTestCleanupElationPatient404
		| IntegrationTestCleanupElationPatient500
		| IntegrationTestCleanupElationPatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof integrationTestCleanupElationPatient>>,
		TError,
		{ params: IntegrationTestCleanupElationPatientParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof integrationTestCleanupElationPatient>>,
	TError,
	{ params: IntegrationTestCleanupElationPatientParams },
	TContext
> => {
	const mutationOptions =
		getIntegrationTestCleanupElationPatientMutationOptions(options);

	return useMutation(mutationOptions);
};

export const cleanupIntegrationTestUser = (
	params: CleanupIntegrationTestUserParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<CleanupIntegrationTestUser200>(
		{
			url: `/gw/stitch-web/api/integration-tests/cleanup`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getCleanupIntegrationTestUserQueryKey = (
	params: CleanupIntegrationTestUserParams,
) => {
	return [
		`/gw/stitch-web/api/integration-tests/cleanup`,
		...(params ? [params] : []),
	] as const;
};

export const getCleanupIntegrationTestUserQueryOptions = <
	TData = Awaited<ReturnType<typeof cleanupIntegrationTestUser>>,
	TError = ErrorType<CleanupIntegrationTestUser404>,
>(
	params: CleanupIntegrationTestUserParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof cleanupIntegrationTestUser>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getCleanupIntegrationTestUserQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof cleanupIntegrationTestUser>>
	> = ({ signal }) =>
		cleanupIntegrationTestUser(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof cleanupIntegrationTestUser>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type CleanupIntegrationTestUserQueryResult = NonNullable<
	Awaited<ReturnType<typeof cleanupIntegrationTestUser>>
>;
export type CleanupIntegrationTestUserQueryError =
	ErrorType<CleanupIntegrationTestUser404>;

export const useCleanupIntegrationTestUser = <
	TData = Awaited<ReturnType<typeof cleanupIntegrationTestUser>>,
	TError = ErrorType<CleanupIntegrationTestUser404>,
>(
	params: CleanupIntegrationTestUserParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof cleanupIntegrationTestUser>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getCleanupIntegrationTestUserQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getLatestIntegrationTestEmail = (
	params: GetLatestIntegrationTestEmailParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetLatestIntegrationTestEmail200>(
		{
			url: `/gw/stitch-web/api/integration-tests/emails/latest`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetLatestIntegrationTestEmailQueryKey = (
	params: GetLatestIntegrationTestEmailParams,
) => {
	return [
		`/gw/stitch-web/api/integration-tests/emails/latest`,
		...(params ? [params] : []),
	] as const;
};

export const getGetLatestIntegrationTestEmailQueryOptions = <
	TData = Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>,
	TError = ErrorType<GetLatestIntegrationTestEmail404>,
>(
	params: GetLatestIntegrationTestEmailParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetLatestIntegrationTestEmailQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>
	> = ({ signal }) =>
		getLatestIntegrationTestEmail(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetLatestIntegrationTestEmailQueryResult = NonNullable<
	Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>
>;
export type GetLatestIntegrationTestEmailQueryError =
	ErrorType<GetLatestIntegrationTestEmail404>;

export const useGetLatestIntegrationTestEmail = <
	TData = Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>,
	TError = ErrorType<GetLatestIntegrationTestEmail404>,
>(
	params: GetLatestIntegrationTestEmailParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getLatestIntegrationTestEmail>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetLatestIntegrationTestEmailQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getLatestIntegrationTestInvitation = (
	params: GetLatestIntegrationTestInvitationParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetLatestIntegrationTestInvitation200>(
		{
			url: `/gw/stitch-web/api/integration-tests/invitations/latest`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetLatestIntegrationTestInvitationQueryKey = (
	params: GetLatestIntegrationTestInvitationParams,
) => {
	return [
		`/gw/stitch-web/api/integration-tests/invitations/latest`,
		...(params ? [params] : []),
	] as const;
};

export const getGetLatestIntegrationTestInvitationQueryOptions = <
	TData = Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>,
	TError = ErrorType<GetLatestIntegrationTestInvitation404>,
>(
	params: GetLatestIntegrationTestInvitationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetLatestIntegrationTestInvitationQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>
	> = ({ signal }) =>
		getLatestIntegrationTestInvitation(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetLatestIntegrationTestInvitationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>
>;
export type GetLatestIntegrationTestInvitationQueryError =
	ErrorType<GetLatestIntegrationTestInvitation404>;

export const useGetLatestIntegrationTestInvitation = <
	TData = Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>,
	TError = ErrorType<GetLatestIntegrationTestInvitation404>,
>(
	params: GetLatestIntegrationTestInvitationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getLatestIntegrationTestInvitation>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetLatestIntegrationTestInvitationQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getLatestIntegrationTestTwoFactorOtp = (
	params: GetLatestIntegrationTestTwoFactorOtpParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetLatestIntegrationTestTwoFactorOtp200>(
		{
			url: `/gw/stitch-web/api/integration-tests/two-factor/otp/latest`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetLatestIntegrationTestTwoFactorOtpQueryKey = (
	params: GetLatestIntegrationTestTwoFactorOtpParams,
) => {
	return [
		`/gw/stitch-web/api/integration-tests/two-factor/otp/latest`,
		...(params ? [params] : []),
	] as const;
};

export const getGetLatestIntegrationTestTwoFactorOtpQueryOptions = <
	TData = Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>,
	TError = ErrorType<GetLatestIntegrationTestTwoFactorOtp404>,
>(
	params: GetLatestIntegrationTestTwoFactorOtpParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetLatestIntegrationTestTwoFactorOtpQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>
	> = ({ signal }) =>
		getLatestIntegrationTestTwoFactorOtp(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetLatestIntegrationTestTwoFactorOtpQueryResult = NonNullable<
	Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>
>;
export type GetLatestIntegrationTestTwoFactorOtpQueryError =
	ErrorType<GetLatestIntegrationTestTwoFactorOtp404>;

export const useGetLatestIntegrationTestTwoFactorOtp = <
	TData = Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>,
	TError = ErrorType<GetLatestIntegrationTestTwoFactorOtp404>,
>(
	params: GetLatestIntegrationTestTwoFactorOtpParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getLatestIntegrationTestTwoFactorOtp>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetLatestIntegrationTestTwoFactorOtpQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getInvitation = (
	invitationId: UuidString,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetInvitationResponse>(
		{
			url: `/gw/stitch-web/api/invitations/${invitationId}`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetInvitationQueryKey = (invitationId: UuidString) => {
	return [`/gw/stitch-web/api/invitations/${invitationId}`] as const;
};

export const getGetInvitationQueryOptions = <
	TData = Awaited<ReturnType<typeof getInvitation>>,
	TError = ErrorType<InvitationInvalid | InvitationNotFound>,
>(
	invitationId: UuidString,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetInvitationQueryKey(invitationId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitation>>> = ({
		signal,
	}) => getInvitation(invitationId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!invitationId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getInvitation>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetInvitationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getInvitation>>
>;
export type GetInvitationQueryError = ErrorType<
	InvitationInvalid | InvitationNotFound
>;

export const useGetInvitation = <
	TData = Awaited<ReturnType<typeof getInvitation>>,
	TError = ErrorType<InvitationInvalid | InvitationNotFound>,
>(
	invitationId: UuidString,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetInvitationQueryOptions(invitationId, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const createInvitation = (
	createInvitation: CreateInvitation,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CreateInvitationResponse>(
		{
			url: `/gw/stitch-web/api/invitations`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createInvitation,
		},
		options,
	);
};

export const getCreateInvitationMutationOptions = <
	TError = ErrorType<
		| InvitationAlreadyExists
		| CreateInvitation401
		| CreateInvitation403
		| CreateInvitation404
		| CreateInvitation500
		| CreateInvitation503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createInvitation>>,
		TError,
		{ data: CreateInvitation },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createInvitation>>,
	TError,
	{ data: CreateInvitation },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createInvitation>>,
		{ data: CreateInvitation }
	> = (props) => {
		const { data } = props ?? {};

		return createInvitation(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateInvitationMutationResult = NonNullable<
	Awaited<ReturnType<typeof createInvitation>>
>;
export type CreateInvitationMutationBody = CreateInvitation;
export type CreateInvitationMutationError = ErrorType<
	| InvitationAlreadyExists
	| CreateInvitation401
	| CreateInvitation403
	| CreateInvitation404
	| CreateInvitation500
	| CreateInvitation503
>;

export const useCreateInvitation = <
	TError = ErrorType<
		| InvitationAlreadyExists
		| CreateInvitation401
		| CreateInvitation403
		| CreateInvitation404
		| CreateInvitation500
		| CreateInvitation503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createInvitation>>,
		TError,
		{ data: CreateInvitation },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createInvitation>>,
	TError,
	{ data: CreateInvitation },
	TContext
> => {
	const mutationOptions = getCreateInvitationMutationOptions(options);

	return useMutation(mutationOptions);
};

export const acceptInvitation = (
	invitationId: UuidString,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<AcceptInvitationResponse>(
		{
			url: `/gw/stitch-web/api/invitations/${invitationId}/accept`,
			method: 'POST',
		},
		options,
	);
};

export const getAcceptInvitationMutationOptions = <
	TError = ErrorType<
		| InvitationInvalid
		| AcceptInvitation401
		| AcceptInvitation403
		| AcceptInvitation404
		| AcceptInvitation500
		| AcceptInvitation503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof acceptInvitation>>,
		TError,
		{ invitationId: UuidString },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof acceptInvitation>>,
	TError,
	{ invitationId: UuidString },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof acceptInvitation>>,
		{ invitationId: UuidString }
	> = (props) => {
		const { invitationId } = props ?? {};

		return acceptInvitation(invitationId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AcceptInvitationMutationResult = NonNullable<
	Awaited<ReturnType<typeof acceptInvitation>>
>;

export type AcceptInvitationMutationError = ErrorType<
	| InvitationInvalid
	| AcceptInvitation401
	| AcceptInvitation403
	| AcceptInvitation404
	| AcceptInvitation500
	| AcceptInvitation503
>;

export const useAcceptInvitation = <
	TError = ErrorType<
		| InvitationInvalid
		| AcceptInvitation401
		| AcceptInvitation403
		| AcceptInvitation404
		| AcceptInvitation500
		| AcceptInvitation503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof acceptInvitation>>,
		TError,
		{ invitationId: UuidString },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof acceptInvitation>>,
	TError,
	{ invitationId: UuidString },
	TContext
> => {
	const mutationOptions = getAcceptInvitationMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getPracticeById = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Practice>(
		{ url: `/gw/stitch-web/api/practices/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetPracticeByIdQueryKey = (id: number) => {
	return [`/gw/stitch-web/api/practices/${id}`] as const;
};

export const getGetPracticeByIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getPracticeById>>,
	TError = ErrorType<
		| GetPracticeById401
		| GetPracticeById403
		| GetPracticeById404
		| GetPracticeById500
		| GetPracticeById503
	>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPracticeById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPracticeByIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeById>>> = ({
		signal,
	}) => getPracticeById(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPracticeById>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPracticeByIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPracticeById>>
>;
export type GetPracticeByIdQueryError = ErrorType<
	| GetPracticeById401
	| GetPracticeById403
	| GetPracticeById404
	| GetPracticeById500
	| GetPracticeById503
>;

export const useGetPracticeById = <
	TData = Awaited<ReturnType<typeof getPracticeById>>,
	TError = ErrorType<
		| GetPracticeById401
		| GetPracticeById403
		| GetPracticeById404
		| GetPracticeById500
		| GetPracticeById503
	>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPracticeById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPracticeByIdQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updatePractice = (
	id: number,
	updatePractice: UpdatePractice,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Practice>(
		{
			url: `/gw/stitch-web/api/practices/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updatePractice,
		},
		options,
	);
};

export const getUpdatePracticeMutationOptions = <
	TError = ErrorType<
		| UpdatePractice401
		| UpdatePractice403
		| UpdatePractice404
		| UpdatePractice500
		| UpdatePractice503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePractice>>,
		TError,
		{ id: number; data: UpdatePractice },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePractice>>,
	TError,
	{ id: number; data: UpdatePractice },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePractice>>,
		{ id: number; data: UpdatePractice }
	> = (props) => {
		const { id, data } = props ?? {};

		return updatePractice(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePracticeMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePractice>>
>;
export type UpdatePracticeMutationBody = UpdatePractice;
export type UpdatePracticeMutationError = ErrorType<
	| UpdatePractice401
	| UpdatePractice403
	| UpdatePractice404
	| UpdatePractice500
	| UpdatePractice503
>;

export const useUpdatePractice = <
	TError = ErrorType<
		| UpdatePractice401
		| UpdatePractice403
		| UpdatePractice404
		| UpdatePractice500
		| UpdatePractice503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePractice>>,
		TError,
		{ id: number; data: UpdatePractice },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updatePractice>>,
	TError,
	{ id: number; data: UpdatePractice },
	TContext
> => {
	const mutationOptions = getUpdatePracticeMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listPracticeMembers = (
	id: number,
	params?: ListPracticeMembersParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListPracticeMembersResponse>(
		{
			url: `/gw/stitch-web/api/practices/${id}/members`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getListPracticeMembersQueryKey = (
	id: number,
	params?: ListPracticeMembersParams,
) => {
	return [
		`/gw/stitch-web/api/practices/${id}/members`,
		...(params ? [params] : []),
	] as const;
};

export const getListPracticeMembersQueryOptions = <
	TData = Awaited<ReturnType<typeof listPracticeMembers>>,
	TError = ErrorType<
		| ListPracticeMembers401
		| ListPracticeMembers403
		| ListPracticeMembers404
		| ListPracticeMembers500
		| ListPracticeMembers503
	>,
>(
	id: number,
	params?: ListPracticeMembersParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listPracticeMembers>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListPracticeMembersQueryKey(id, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listPracticeMembers>>
	> = ({ signal }) => listPracticeMembers(id, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listPracticeMembers>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListPracticeMembersQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPracticeMembers>>
>;
export type ListPracticeMembersQueryError = ErrorType<
	| ListPracticeMembers401
	| ListPracticeMembers403
	| ListPracticeMembers404
	| ListPracticeMembers500
	| ListPracticeMembers503
>;

export const useListPracticeMembers = <
	TData = Awaited<ReturnType<typeof listPracticeMembers>>,
	TError = ErrorType<
		| ListPracticeMembers401
		| ListPracticeMembers403
		| ListPracticeMembers404
		| ListPracticeMembers500
		| ListPracticeMembers503
	>,
>(
	id: number,
	params?: ListPracticeMembersParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listPracticeMembers>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListPracticeMembersQueryOptions(id, params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getConnectorCapabilities = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetConnectorCapabilitiesResponse>(
		{
			url: `/gw/stitch-web/api/connectors/capabilities`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetConnectorCapabilitiesQueryKey = () => {
	return [`/gw/stitch-web/api/connectors/capabilities`] as const;
};

export const getGetConnectorCapabilitiesQueryOptions = <
	TData = Awaited<ReturnType<typeof getConnectorCapabilities>>,
	TError = ErrorType<
		| GetConnectorCapabilities401
		| GetConnectorCapabilities403
		| GetConnectorCapabilities404
		| GetConnectorCapabilities500
		| GetConnectorCapabilities503
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getConnectorCapabilities>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetConnectorCapabilitiesQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getConnectorCapabilities>>
	> = ({ signal }) => getConnectorCapabilities(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getConnectorCapabilities>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetConnectorCapabilitiesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getConnectorCapabilities>>
>;
export type GetConnectorCapabilitiesQueryError = ErrorType<
	| GetConnectorCapabilities401
	| GetConnectorCapabilities403
	| GetConnectorCapabilities404
	| GetConnectorCapabilities500
	| GetConnectorCapabilities503
>;

export const useGetConnectorCapabilities = <
	TData = Awaited<ReturnType<typeof getConnectorCapabilities>>,
	TError = ErrorType<
		| GetConnectorCapabilities401
		| GetConnectorCapabilities403
		| GetConnectorCapabilities404
		| GetConnectorCapabilities500
		| GetConnectorCapabilities503
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getConnectorCapabilities>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetConnectorCapabilitiesQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const searchPatients = (
	params?: SearchPatientsParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PatientSearchResult>(
		{ url: `/gw/stitch-web/api/patients`, method: 'GET', params, signal },
		options,
	);
};

export const getSearchPatientsQueryKey = (params?: SearchPatientsParams) => {
	return [`/gw/stitch-web/api/patients`, ...(params ? [params] : [])] as const;
};

export const getSearchPatientsQueryOptions = <
	TData = Awaited<ReturnType<typeof searchPatients>>,
	TError = ErrorType<
		| SearchPatients401
		| SearchPatients403
		| SearchPatients404
		| SearchPatients500
		| SearchPatients503
	>,
>(
	params?: SearchPatientsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof searchPatients>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getSearchPatientsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof searchPatients>>> = ({
		signal,
	}) => searchPatients(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof searchPatients>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type SearchPatientsQueryResult = NonNullable<
	Awaited<ReturnType<typeof searchPatients>>
>;
export type SearchPatientsQueryError = ErrorType<
	| SearchPatients401
	| SearchPatients403
	| SearchPatients404
	| SearchPatients500
	| SearchPatients503
>;

export const useSearchPatients = <
	TData = Awaited<ReturnType<typeof searchPatients>>,
	TError = ErrorType<
		| SearchPatients401
		| SearchPatients403
		| SearchPatients404
		| SearchPatients500
		| SearchPatients503
	>,
>(
	params?: SearchPatientsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof searchPatients>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getSearchPatientsQueryOptions(params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const createPatient = (
	createPatient: CreatePatient,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CreatePatientResponse>(
		{
			url: `/gw/stitch-web/api/patients`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createPatient,
		},
		options,
	);
};

export const getCreatePatientMutationOptions = <
	TError = ErrorType<
		| CreatePatient401
		| CreatePatient403
		| CreatePatient404
		| CreatePatient500
		| CreatePatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPatient>>,
		TError,
		{ data: CreatePatient },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createPatient>>,
	TError,
	{ data: CreatePatient },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createPatient>>,
		{ data: CreatePatient }
	> = (props) => {
		const { data } = props ?? {};

		return createPatient(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreatePatientMutationResult = NonNullable<
	Awaited<ReturnType<typeof createPatient>>
>;
export type CreatePatientMutationBody = CreatePatient;
export type CreatePatientMutationError = ErrorType<
	| CreatePatient401
	| CreatePatient403
	| CreatePatient404
	| CreatePatient500
	| CreatePatient503
>;

export const useCreatePatient = <
	TError = ErrorType<
		| CreatePatient401
		| CreatePatient403
		| CreatePatient404
		| CreatePatient500
		| CreatePatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPatient>>,
		TError,
		{ data: CreatePatient },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createPatient>>,
	TError,
	{ data: CreatePatient },
	TContext
> => {
	const mutationOptions = getCreatePatientMutationOptions(options);

	return useMutation(mutationOptions);
};

export const syncPatientByEhr = (
	ehr: EhrConnector,
	patientId: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<SyncPatientByEhrResponse>(
		{
			url: `/gw/stitch-web/api/patients/by-ehr/${ehr}/${patientId}/sync`,
			method: 'POST',
		},
		options,
	);
};

export const getSyncPatientByEhrMutationOptions = <
	TError = ErrorType<
		| SyncPatientByEhr401
		| SyncPatientByEhr403
		| SyncPatientByEhr404
		| SyncPatientByEhr500
		| SyncPatientByEhr503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof syncPatientByEhr>>,
		TError,
		{ ehr: EhrConnector; patientId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof syncPatientByEhr>>,
	TError,
	{ ehr: EhrConnector; patientId: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof syncPatientByEhr>>,
		{ ehr: EhrConnector; patientId: string }
	> = (props) => {
		const { ehr, patientId } = props ?? {};

		return syncPatientByEhr(ehr, patientId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SyncPatientByEhrMutationResult = NonNullable<
	Awaited<ReturnType<typeof syncPatientByEhr>>
>;

export type SyncPatientByEhrMutationError = ErrorType<
	| SyncPatientByEhr401
	| SyncPatientByEhr403
	| SyncPatientByEhr404
	| SyncPatientByEhr500
	| SyncPatientByEhr503
>;

export const useSyncPatientByEhr = <
	TError = ErrorType<
		| SyncPatientByEhr401
		| SyncPatientByEhr403
		| SyncPatientByEhr404
		| SyncPatientByEhr500
		| SyncPatientByEhr503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof syncPatientByEhr>>,
		TError,
		{ ehr: EhrConnector; patientId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof syncPatientByEhr>>,
	TError,
	{ ehr: EhrConnector; patientId: string },
	TContext
> => {
	const mutationOptions = getSyncPatientByEhrMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getPatientById = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Patient>(
		{ url: `/gw/stitch-web/api/patients/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetPatientByIdQueryKey = (id: number) => {
	return [`/gw/stitch-web/api/patients/${id}`] as const;
};

export const getGetPatientByIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getPatientById>>,
	TError = ErrorType<
		| GetPatientById401
		| GetPatientById403
		| GetPatientById404
		| GetPatientById500
		| GetPatientById503
	>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPatientByIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientById>>> = ({
		signal,
	}) => getPatientById(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPatientById>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPatientByIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPatientById>>
>;
export type GetPatientByIdQueryError = ErrorType<
	| GetPatientById401
	| GetPatientById403
	| GetPatientById404
	| GetPatientById500
	| GetPatientById503
>;

export const useGetPatientById = <
	TData = Awaited<ReturnType<typeof getPatientById>>,
	TError = ErrorType<
		| GetPatientById401
		| GetPatientById403
		| GetPatientById404
		| GetPatientById500
		| GetPatientById503
	>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPatientByIdQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updatePatient = (
	id: number,
	updatePatient: UpdatePatient,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Patient>(
		{
			url: `/gw/stitch-web/api/patients/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updatePatient,
		},
		options,
	);
};

export const getUpdatePatientMutationOptions = <
	TError = ErrorType<
		| UpdatePatient401
		| UpdatePatient403
		| UpdatePatient404
		| UpdatePatient500
		| UpdatePatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePatient>>,
		TError,
		{ id: number; data: UpdatePatient },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePatient>>,
	TError,
	{ id: number; data: UpdatePatient },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePatient>>,
		{ id: number; data: UpdatePatient }
	> = (props) => {
		const { id, data } = props ?? {};

		return updatePatient(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePatientMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePatient>>
>;
export type UpdatePatientMutationBody = UpdatePatient;
export type UpdatePatientMutationError = ErrorType<
	| UpdatePatient401
	| UpdatePatient403
	| UpdatePatient404
	| UpdatePatient500
	| UpdatePatient503
>;

export const useUpdatePatient = <
	TError = ErrorType<
		| UpdatePatient401
		| UpdatePatient403
		| UpdatePatient404
		| UpdatePatient500
		| UpdatePatient503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePatient>>,
		TError,
		{ id: number; data: UpdatePatient },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updatePatient>>,
	TError,
	{ id: number; data: UpdatePatient },
	TContext
> => {
	const mutationOptions = getUpdatePatientMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listHealthConcerns = (
	patientId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<HealthConcernWithOpportunities[]>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/health-concerns`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListHealthConcernsQueryKey = (patientId: number) => {
	return [`/gw/stitch-web/api/patients/${patientId}/health-concerns`] as const;
};

export const getListHealthConcernsQueryOptions = <
	TData = Awaited<ReturnType<typeof listHealthConcerns>>,
	TError = ErrorType<
		| ListHealthConcerns401
		| ListHealthConcerns403
		| ListHealthConcerns404
		| ListHealthConcerns500
		| ListHealthConcerns503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listHealthConcerns>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListHealthConcernsQueryKey(patientId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listHealthConcerns>>
	> = ({ signal }) => listHealthConcerns(patientId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!patientId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listHealthConcerns>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListHealthConcernsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listHealthConcerns>>
>;
export type ListHealthConcernsQueryError = ErrorType<
	| ListHealthConcerns401
	| ListHealthConcerns403
	| ListHealthConcerns404
	| ListHealthConcerns500
	| ListHealthConcerns503
>;

export const useListHealthConcerns = <
	TData = Awaited<ReturnType<typeof listHealthConcerns>>,
	TError = ErrorType<
		| ListHealthConcerns401
		| ListHealthConcerns403
		| ListHealthConcerns404
		| ListHealthConcerns500
		| ListHealthConcerns503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listHealthConcerns>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListHealthConcernsQueryOptions(patientId, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const createHealthConcern = (
	patientId: number,
	createHealthConcernRequest: CreateHealthConcernRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<HealthConcern>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/health-concerns`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createHealthConcernRequest,
		},
		options,
	);
};

export const getCreateHealthConcernMutationOptions = <
	TError = ErrorType<
		| CreateHealthConcern401
		| CreateHealthConcern403
		| CreateHealthConcern404
		| CreateHealthConcern500
		| CreateHealthConcern503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createHealthConcern>>,
		TError,
		{ patientId: number; data: CreateHealthConcernRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createHealthConcern>>,
	TError,
	{ patientId: number; data: CreateHealthConcernRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createHealthConcern>>,
		{ patientId: number; data: CreateHealthConcernRequest }
	> = (props) => {
		const { patientId, data } = props ?? {};

		return createHealthConcern(patientId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateHealthConcernMutationResult = NonNullable<
	Awaited<ReturnType<typeof createHealthConcern>>
>;
export type CreateHealthConcernMutationBody = CreateHealthConcernRequest;
export type CreateHealthConcernMutationError = ErrorType<
	| CreateHealthConcern401
	| CreateHealthConcern403
	| CreateHealthConcern404
	| CreateHealthConcern500
	| CreateHealthConcern503
>;

export const useCreateHealthConcern = <
	TError = ErrorType<
		| CreateHealthConcern401
		| CreateHealthConcern403
		| CreateHealthConcern404
		| CreateHealthConcern500
		| CreateHealthConcern503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createHealthConcern>>,
		TError,
		{ patientId: number; data: CreateHealthConcernRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createHealthConcern>>,
	TError,
	{ patientId: number; data: CreateHealthConcernRequest },
	TContext
> => {
	const mutationOptions = getCreateHealthConcernMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listPatientCareProtocolOpportunities = (
	patientId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PatientCareProtocolOpportunities>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/health-concerns/opportunities`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListPatientCareProtocolOpportunitiesQueryKey = (
	patientId: number,
) => {
	return [
		`/gw/stitch-web/api/patients/${patientId}/health-concerns/opportunities`,
	] as const;
};

export const getListPatientCareProtocolOpportunitiesQueryOptions = <
	TData = Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>,
	TError = ErrorType<
		| ListPatientCareProtocolOpportunities401
		| ListPatientCareProtocolOpportunities403
		| ListPatientCareProtocolOpportunities404
		| ListPatientCareProtocolOpportunities500
		| ListPatientCareProtocolOpportunities503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListPatientCareProtocolOpportunitiesQueryKey(patientId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>
	> = ({ signal }) =>
		listPatientCareProtocolOpportunities(patientId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!patientId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListPatientCareProtocolOpportunitiesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>
>;
export type ListPatientCareProtocolOpportunitiesQueryError = ErrorType<
	| ListPatientCareProtocolOpportunities401
	| ListPatientCareProtocolOpportunities403
	| ListPatientCareProtocolOpportunities404
	| ListPatientCareProtocolOpportunities500
	| ListPatientCareProtocolOpportunities503
>;

export const useListPatientCareProtocolOpportunities = <
	TData = Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>,
	TError = ErrorType<
		| ListPatientCareProtocolOpportunities401
		| ListPatientCareProtocolOpportunities403
		| ListPatientCareProtocolOpportunities404
		| ListPatientCareProtocolOpportunities500
		| ListPatientCareProtocolOpportunities503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listPatientCareProtocolOpportunities>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListPatientCareProtocolOpportunitiesQueryOptions(
		patientId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updateOpportunityStatus = (
	patientId: number,
	opportunityId: number,
	updateOpportunityStatusRequest: UpdateOpportunityStatusRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CareProtocolOpportunity>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/health-concerns/opportunities/${opportunityId}/status`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updateOpportunityStatusRequest,
		},
		options,
	);
};

export const getUpdateOpportunityStatusMutationOptions = <
	TError = ErrorType<
		| UpdateOpportunityStatus401
		| UpdateOpportunityStatus403
		| UpdateOpportunityStatus404
		| UpdateOpportunityStatus500
		| UpdateOpportunityStatus503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOpportunityStatus>>,
		TError,
		{
			patientId: number;
			opportunityId: number;
			data: UpdateOpportunityStatusRequest;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateOpportunityStatus>>,
	TError,
	{
		patientId: number;
		opportunityId: number;
		data: UpdateOpportunityStatusRequest;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateOpportunityStatus>>,
		{
			patientId: number;
			opportunityId: number;
			data: UpdateOpportunityStatusRequest;
		}
	> = (props) => {
		const { patientId, opportunityId, data } = props ?? {};

		return updateOpportunityStatus(
			patientId,
			opportunityId,
			data,
			requestOptions,
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateOpportunityStatusMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateOpportunityStatus>>
>;
export type UpdateOpportunityStatusMutationBody =
	UpdateOpportunityStatusRequest;
export type UpdateOpportunityStatusMutationError = ErrorType<
	| UpdateOpportunityStatus401
	| UpdateOpportunityStatus403
	| UpdateOpportunityStatus404
	| UpdateOpportunityStatus500
	| UpdateOpportunityStatus503
>;

export const useUpdateOpportunityStatus = <
	TError = ErrorType<
		| UpdateOpportunityStatus401
		| UpdateOpportunityStatus403
		| UpdateOpportunityStatus404
		| UpdateOpportunityStatus500
		| UpdateOpportunityStatus503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOpportunityStatus>>,
		TError,
		{
			patientId: number;
			opportunityId: number;
			data: UpdateOpportunityStatusRequest;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateOpportunityStatus>>,
	TError,
	{
		patientId: number;
		opportunityId: number;
		data: UpdateOpportunityStatusRequest;
	},
	TContext
> => {
	const mutationOptions = getUpdateOpportunityStatusMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listEncountersByPatient = (
	patientId: number,
	params?: ListEncountersByPatientParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListEncountersByPatientResponse>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/encounters`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getListEncountersByPatientQueryKey = (
	patientId: number,
	params?: ListEncountersByPatientParams,
) => {
	return [
		`/gw/stitch-web/api/patients/${patientId}/encounters`,
		...(params ? [params] : []),
	] as const;
};

export const getListEncountersByPatientQueryOptions = <
	TData = Awaited<ReturnType<typeof listEncountersByPatient>>,
	TError = ErrorType<
		| ListEncountersByPatient401
		| ListEncountersByPatient403
		| ListEncountersByPatient404
		| ListEncountersByPatient500
		| ListEncountersByPatient503
	>,
>(
	patientId: number,
	params?: ListEncountersByPatientParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listEncountersByPatient>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListEncountersByPatientQueryKey(patientId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listEncountersByPatient>>
	> = ({ signal }) =>
		listEncountersByPatient(patientId, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!patientId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listEncountersByPatient>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListEncountersByPatientQueryResult = NonNullable<
	Awaited<ReturnType<typeof listEncountersByPatient>>
>;
export type ListEncountersByPatientQueryError = ErrorType<
	| ListEncountersByPatient401
	| ListEncountersByPatient403
	| ListEncountersByPatient404
	| ListEncountersByPatient500
	| ListEncountersByPatient503
>;

export const useListEncountersByPatient = <
	TData = Awaited<ReturnType<typeof listEncountersByPatient>>,
	TError = ErrorType<
		| ListEncountersByPatient401
		| ListEncountersByPatient403
		| ListEncountersByPatient404
		| ListEncountersByPatient500
		| ListEncountersByPatient503
	>,
>(
	patientId: number,
	params?: ListEncountersByPatientParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listEncountersByPatient>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListEncountersByPatientQueryOptions(
		patientId,
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getPatientReportMetadata = (
	patientId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ReportMetadataResponse>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/reports/metadata`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetPatientReportMetadataQueryKey = (patientId: number) => {
	return [`/gw/stitch-web/api/patients/${patientId}/reports/metadata`] as const;
};

export const getGetPatientReportMetadataQueryOptions = <
	TData = Awaited<ReturnType<typeof getPatientReportMetadata>>,
	TError = ErrorType<
		| GetPatientReportMetadata401
		| GetPatientReportMetadata403
		| GetPatientReportMetadata404
		| GetPatientReportMetadata500
		| GetPatientReportMetadata503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPatientReportMetadata>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPatientReportMetadataQueryKey(patientId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPatientReportMetadata>>
	> = ({ signal }) =>
		getPatientReportMetadata(patientId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!patientId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPatientReportMetadata>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPatientReportMetadataQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPatientReportMetadata>>
>;
export type GetPatientReportMetadataQueryError = ErrorType<
	| GetPatientReportMetadata401
	| GetPatientReportMetadata403
	| GetPatientReportMetadata404
	| GetPatientReportMetadata500
	| GetPatientReportMetadata503
>;

export const useGetPatientReportMetadata = <
	TData = Awaited<ReturnType<typeof getPatientReportMetadata>>,
	TError = ErrorType<
		| GetPatientReportMetadata401
		| GetPatientReportMetadata403
		| GetPatientReportMetadata404
		| GetPatientReportMetadata500
		| GetPatientReportMetadata503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPatientReportMetadata>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPatientReportMetadataQueryOptions(
		patientId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getPatientReportHtml = (
	patientId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{
			url: `/gw/stitch-web/api/patients/${patientId}/reports/html`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetPatientReportHtmlQueryKey = (patientId: number) => {
	return [`/gw/stitch-web/api/patients/${patientId}/reports/html`] as const;
};

export const getGetPatientReportHtmlQueryOptions = <
	TData = Awaited<ReturnType<typeof getPatientReportHtml>>,
	TError = ErrorType<
		| GetPatientReportHtml401
		| GetPatientReportHtml403
		| GetPatientReportHtml404
		| GetPatientReportHtml500
		| GetPatientReportHtml503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPatientReportHtml>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPatientReportHtmlQueryKey(patientId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPatientReportHtml>>
	> = ({ signal }) => getPatientReportHtml(patientId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!patientId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPatientReportHtml>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPatientReportHtmlQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPatientReportHtml>>
>;
export type GetPatientReportHtmlQueryError = ErrorType<
	| GetPatientReportHtml401
	| GetPatientReportHtml403
	| GetPatientReportHtml404
	| GetPatientReportHtml500
	| GetPatientReportHtml503
>;

export const useGetPatientReportHtml = <
	TData = Awaited<ReturnType<typeof getPatientReportHtml>>,
	TError = ErrorType<
		| GetPatientReportHtml401
		| GetPatientReportHtml403
		| GetPatientReportHtml404
		| GetPatientReportHtml500
		| GetPatientReportHtml503
	>,
>(
	patientId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPatientReportHtml>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPatientReportHtmlQueryOptions(patientId, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const searchPhysiciansByNpi = (
	params?: SearchPhysiciansByNpiParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PhysicianNpiSearchResponse>(
		{
			url: `/gw/stitch-web/api/physicians/npi/search`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getSearchPhysiciansByNpiQueryKey = (
	params?: SearchPhysiciansByNpiParams,
) => {
	return [
		`/gw/stitch-web/api/physicians/npi/search`,
		...(params ? [params] : []),
	] as const;
};

export const getSearchPhysiciansByNpiQueryOptions = <
	TData = Awaited<ReturnType<typeof searchPhysiciansByNpi>>,
	TError = ErrorType<unknown>,
>(
	params?: SearchPhysiciansByNpiParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof searchPhysiciansByNpi>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getSearchPhysiciansByNpiQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof searchPhysiciansByNpi>>
	> = ({ signal }) => searchPhysiciansByNpi(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof searchPhysiciansByNpi>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type SearchPhysiciansByNpiQueryResult = NonNullable<
	Awaited<ReturnType<typeof searchPhysiciansByNpi>>
>;
export type SearchPhysiciansByNpiQueryError = ErrorType<unknown>;

export const useSearchPhysiciansByNpi = <
	TData = Awaited<ReturnType<typeof searchPhysiciansByNpi>>,
	TError = ErrorType<unknown>,
>(
	params?: SearchPhysiciansByNpiParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof searchPhysiciansByNpi>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getSearchPhysiciansByNpiQueryOptions(params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const verifyPhysicianNpi = (
	physicianNpiVerifyRequest: PhysicianNpiVerifyRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PhysicianNpiVerifyResponse>(
		{
			url: `/gw/stitch-web/api/physicians/npi/verify`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: physicianNpiVerifyRequest,
		},
		options,
	);
};

export const getVerifyPhysicianNpiMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof verifyPhysicianNpi>>,
		TError,
		{ data: PhysicianNpiVerifyRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof verifyPhysicianNpi>>,
	TError,
	{ data: PhysicianNpiVerifyRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof verifyPhysicianNpi>>,
		{ data: PhysicianNpiVerifyRequest }
	> = (props) => {
		const { data } = props ?? {};

		return verifyPhysicianNpi(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type VerifyPhysicianNpiMutationResult = NonNullable<
	Awaited<ReturnType<typeof verifyPhysicianNpi>>
>;
export type VerifyPhysicianNpiMutationBody = PhysicianNpiVerifyRequest;
export type VerifyPhysicianNpiMutationError = ErrorType<unknown>;

export const useVerifyPhysicianNpi = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof verifyPhysicianNpi>>,
		TError,
		{ data: PhysicianNpiVerifyRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof verifyPhysicianNpi>>,
	TError,
	{ data: PhysicianNpiVerifyRequest },
	TContext
> => {
	const mutationOptions = getVerifyPhysicianNpiMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getPhysicianById = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Physician>(
		{ url: `/gw/stitch-web/api/physicians/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetPhysicianByIdQueryKey = (id: number) => {
	return [`/gw/stitch-web/api/physicians/${id}`] as const;
};

export const getGetPhysicianByIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getPhysicianById>>,
	TError = ErrorType<PhysicianNotFound>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPhysicianById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPhysicianByIdQueryKey(id);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPhysicianById>>
	> = ({ signal }) => getPhysicianById(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPhysicianById>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPhysicianByIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPhysicianById>>
>;
export type GetPhysicianByIdQueryError = ErrorType<PhysicianNotFound>;

export const useGetPhysicianById = <
	TData = Awaited<ReturnType<typeof getPhysicianById>>,
	TError = ErrorType<PhysicianNotFound>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPhysicianById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPhysicianByIdQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updatePhysician = (
	id: number,
	updatePhysician: UpdatePhysician,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Physician>(
		{
			url: `/gw/stitch-web/api/physicians/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updatePhysician,
		},
		options,
	);
};

export const getUpdatePhysicianMutationOptions = <
	TError = ErrorType<PhysicianNotFound>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePhysician>>,
		TError,
		{ id: number; data: UpdatePhysician },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePhysician>>,
	TError,
	{ id: number; data: UpdatePhysician },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePhysician>>,
		{ id: number; data: UpdatePhysician }
	> = (props) => {
		const { id, data } = props ?? {};

		return updatePhysician(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePhysicianMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePhysician>>
>;
export type UpdatePhysicianMutationBody = UpdatePhysician;
export type UpdatePhysicianMutationError = ErrorType<PhysicianNotFound>;

export const useUpdatePhysician = <
	TError = ErrorType<PhysicianNotFound>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePhysician>>,
		TError,
		{ id: number; data: UpdatePhysician },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updatePhysician>>,
	TError,
	{ id: number; data: UpdatePhysician },
	TContext
> => {
	const mutationOptions = getUpdatePhysicianMutationOptions(options);

	return useMutation(mutationOptions);
};

export const updateStaff = (
	id: number,
	updateStaff: UpdateStaff,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Staff>(
		{
			url: `/gw/stitch-web/api/staff/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updateStaff,
		},
		options,
	);
};

export const getUpdateStaffMutationOptions = <
	TError = ErrorType<StaffNotFound | UpdateStaff500>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateStaff>>,
		TError,
		{ id: number; data: UpdateStaff },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateStaff>>,
	TError,
	{ id: number; data: UpdateStaff },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateStaff>>,
		{ id: number; data: UpdateStaff }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateStaff(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateStaffMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateStaff>>
>;
export type UpdateStaffMutationBody = UpdateStaff;
export type UpdateStaffMutationError = ErrorType<
	StaffNotFound | UpdateStaff500
>;

export const useUpdateStaff = <
	TError = ErrorType<StaffNotFound | UpdateStaff500>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateStaff>>,
		TError,
		{ id: number; data: UpdateStaff },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateStaff>>,
	TError,
	{ id: number; data: UpdateStaff },
	TContext
> => {
	const mutationOptions = getUpdateStaffMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listCareProtocolOpportunities = (
	params?: ListCareProtocolOpportunitiesParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListCareProtocolOpportunitiesResponse>(
		{
			url: `/gw/stitch-web/api/care-protocol-opportunities`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getListCareProtocolOpportunitiesQueryKey = (
	params?: ListCareProtocolOpportunitiesParams,
) => {
	return [
		`/gw/stitch-web/api/care-protocol-opportunities`,
		...(params ? [params] : []),
	] as const;
};

export const getListCareProtocolOpportunitiesQueryOptions = <
	TData = Awaited<ReturnType<typeof listCareProtocolOpportunities>>,
	TError = ErrorType<
		| ListCareProtocolOpportunities401
		| ListCareProtocolOpportunities403
		| ListCareProtocolOpportunities404
		| ListCareProtocolOpportunities500
		| ListCareProtocolOpportunities503
	>,
>(
	params?: ListCareProtocolOpportunitiesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listCareProtocolOpportunities>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListCareProtocolOpportunitiesQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listCareProtocolOpportunities>>
	> = ({ signal }) =>
		listCareProtocolOpportunities(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listCareProtocolOpportunities>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListCareProtocolOpportunitiesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listCareProtocolOpportunities>>
>;
export type ListCareProtocolOpportunitiesQueryError = ErrorType<
	| ListCareProtocolOpportunities401
	| ListCareProtocolOpportunities403
	| ListCareProtocolOpportunities404
	| ListCareProtocolOpportunities500
	| ListCareProtocolOpportunities503
>;

export const useListCareProtocolOpportunities = <
	TData = Awaited<ReturnType<typeof listCareProtocolOpportunities>>,
	TError = ErrorType<
		| ListCareProtocolOpportunities401
		| ListCareProtocolOpportunities403
		| ListCareProtocolOpportunities404
		| ListCareProtocolOpportunities500
		| ListCareProtocolOpportunities503
	>,
>(
	params?: ListCareProtocolOpportunitiesParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listCareProtocolOpportunities>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListCareProtocolOpportunitiesQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const dismissCareProtocolOpportunity = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<void>(
		{
			url: `/gw/stitch-web/api/care-protocol-opportunities/${id}`,
			method: 'DELETE',
		},
		options,
	);
};

export const getDismissCareProtocolOpportunityMutationOptions = <
	TError = ErrorType<
		| DismissCareProtocolOpportunity401
		| DismissCareProtocolOpportunity403
		| DismissCareProtocolOpportunity404
		| DismissCareProtocolOpportunity500
		| DismissCareProtocolOpportunity503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof dismissCareProtocolOpportunity>>,
		TError,
		{ id: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof dismissCareProtocolOpportunity>>,
	TError,
	{ id: number },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof dismissCareProtocolOpportunity>>,
		{ id: number }
	> = (props) => {
		const { id } = props ?? {};

		return dismissCareProtocolOpportunity(id, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DismissCareProtocolOpportunityMutationResult = NonNullable<
	Awaited<ReturnType<typeof dismissCareProtocolOpportunity>>
>;

export type DismissCareProtocolOpportunityMutationError = ErrorType<
	| DismissCareProtocolOpportunity401
	| DismissCareProtocolOpportunity403
	| DismissCareProtocolOpportunity404
	| DismissCareProtocolOpportunity500
	| DismissCareProtocolOpportunity503
>;

export const useDismissCareProtocolOpportunity = <
	TError = ErrorType<
		| DismissCareProtocolOpportunity401
		| DismissCareProtocolOpportunity403
		| DismissCareProtocolOpportunity404
		| DismissCareProtocolOpportunity500
		| DismissCareProtocolOpportunity503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof dismissCareProtocolOpportunity>>,
		TError,
		{ id: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof dismissCareProtocolOpportunity>>,
	TError,
	{ id: number },
	TContext
> => {
	const mutationOptions =
		getDismissCareProtocolOpportunityMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Opens a single `text/event-stream` connection for the authenticated physician or staff that multiplexes every per-feature SSE event (physician profile, encounter lifecycle, agenda items, transcript snapshots, …). Each SSE `data:` line is JSON whose shape matches AppSseEvent (discriminated on `type`).
 * @summary Subscribe to app events (SSE)
 */
export const streamPhysicianEvents = (
	params?: StreamPhysicianEventsParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<AppSseEvent>(
		{ url: `/gw/stitch-web/api/events`, method: 'GET', params, signal },
		options,
	);
};

export const getStreamPhysicianEventsQueryKey = (
	params?: StreamPhysicianEventsParams,
) => {
	return [`/gw/stitch-web/api/events`, ...(params ? [params] : [])] as const;
};

export const getStreamPhysicianEventsQueryOptions = <
	TData = Awaited<ReturnType<typeof streamPhysicianEvents>>,
	TError = ErrorType<
		| string
		| StreamPhysicianEvents401
		| StreamPhysicianEvents403
		| StreamPhysicianEvents404
		| StreamPhysicianEvents500
		| StreamPhysicianEvents503
	>,
>(
	params?: StreamPhysicianEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof streamPhysicianEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getStreamPhysicianEventsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof streamPhysicianEvents>>
	> = ({ signal }) => streamPhysicianEvents(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof streamPhysicianEvents>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type StreamPhysicianEventsQueryResult = NonNullable<
	Awaited<ReturnType<typeof streamPhysicianEvents>>
>;
export type StreamPhysicianEventsQueryError = ErrorType<
	| string
	| StreamPhysicianEvents401
	| StreamPhysicianEvents403
	| StreamPhysicianEvents404
	| StreamPhysicianEvents500
	| StreamPhysicianEvents503
>;

/**
 * @summary Subscribe to app events (SSE)
 */
export const useStreamPhysicianEvents = <
	TData = Awaited<ReturnType<typeof streamPhysicianEvents>>,
	TError = ErrorType<
		| string
		| StreamPhysicianEvents401
		| StreamPhysicianEvents403
		| StreamPhysicianEvents404
		| StreamPhysicianEvents500
		| StreamPhysicianEvents503
	>,
>(
	params?: StreamPhysicianEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof streamPhysicianEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getStreamPhysicianEventsQueryOptions(params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const transcribeAudio = (
	transcribeRequest: TranscribeRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	const formData = new FormData();
	formData.append('file', transcribeRequest.file);
	formData.append('metadata', transcribeRequest.metadata);
	if (transcribeRequest.contentType !== undefined) {
		formData.append('contentType', transcribeRequest.contentType);
	}

	return customInstance<TranscribeResponse>(
		{
			url: `/gw/stitch-web/api/transcribe`,
			method: 'POST',
			headers: { 'Content-Type': 'multipart/form-data' },
			data: formData,
		},
		options,
	);
};

export const getTranscribeAudioMutationOptions = <
	TError = ErrorType<
		| TranscribeErrorResponse
		| TranscribeAudio401
		| TranscribeAudio403
		| TranscribeAudio404
		| TranscribeAudio500
		| TranscribeAudio503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof transcribeAudio>>,
		TError,
		{ data: TranscribeRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof transcribeAudio>>,
	TError,
	{ data: TranscribeRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof transcribeAudio>>,
		{ data: TranscribeRequest }
	> = (props) => {
		const { data } = props ?? {};

		return transcribeAudio(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type TranscribeAudioMutationResult = NonNullable<
	Awaited<ReturnType<typeof transcribeAudio>>
>;
export type TranscribeAudioMutationBody = TranscribeRequest;
export type TranscribeAudioMutationError = ErrorType<
	| TranscribeErrorResponse
	| TranscribeAudio401
	| TranscribeAudio403
	| TranscribeAudio404
	| TranscribeAudio500
	| TranscribeAudio503
>;

export const useTranscribeAudio = <
	TError = ErrorType<
		| TranscribeErrorResponse
		| TranscribeAudio401
		| TranscribeAudio403
		| TranscribeAudio404
		| TranscribeAudio500
		| TranscribeAudio503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof transcribeAudio>>,
		TError,
		{ data: TranscribeRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof transcribeAudio>>,
	TError,
	{ data: TranscribeRequest },
	TContext
> => {
	const mutationOptions = getTranscribeAudioMutationOptions(options);

	return useMutation(mutationOptions);
};

export const requestDocumentUploadUrl = (
	uploadUrlRequest: UploadUrlRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UploadUrlResponse>(
		{
			url: `/gw/stitch-web/api/documents/upload-url`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: uploadUrlRequest,
		},
		options,
	);
};

export const getRequestDocumentUploadUrlMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestDocumentUploadUrl>>,
		TError,
		{ data: UploadUrlRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof requestDocumentUploadUrl>>,
	TError,
	{ data: UploadUrlRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof requestDocumentUploadUrl>>,
		{ data: UploadUrlRequest }
	> = (props) => {
		const { data } = props ?? {};

		return requestDocumentUploadUrl(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RequestDocumentUploadUrlMutationResult = NonNullable<
	Awaited<ReturnType<typeof requestDocumentUploadUrl>>
>;
export type RequestDocumentUploadUrlMutationBody = UploadUrlRequest;
export type RequestDocumentUploadUrlMutationError = ErrorType<unknown>;

export const useRequestDocumentUploadUrl = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestDocumentUploadUrl>>,
		TError,
		{ data: UploadUrlRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof requestDocumentUploadUrl>>,
	TError,
	{ data: UploadUrlRequest },
	TContext
> => {
	const mutationOptions = getRequestDocumentUploadUrlMutationOptions(options);

	return useMutation(mutationOptions);
};

export const requestBulkDocumentUploadUrls = (
	bulkUploadUrlsRequest: BulkUploadUrlsRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<BulkUploadUrlsResponse>(
		{
			url: `/gw/stitch-web/api/documents/bulk-upload-urls`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: bulkUploadUrlsRequest,
		},
		options,
	);
};

export const getRequestBulkDocumentUploadUrlsMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestBulkDocumentUploadUrls>>,
		TError,
		{ data: BulkUploadUrlsRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof requestBulkDocumentUploadUrls>>,
	TError,
	{ data: BulkUploadUrlsRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof requestBulkDocumentUploadUrls>>,
		{ data: BulkUploadUrlsRequest }
	> = (props) => {
		const { data } = props ?? {};

		return requestBulkDocumentUploadUrls(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RequestBulkDocumentUploadUrlsMutationResult = NonNullable<
	Awaited<ReturnType<typeof requestBulkDocumentUploadUrls>>
>;
export type RequestBulkDocumentUploadUrlsMutationBody = BulkUploadUrlsRequest;
export type RequestBulkDocumentUploadUrlsMutationError = ErrorType<unknown>;

export const useRequestBulkDocumentUploadUrls = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestBulkDocumentUploadUrls>>,
		TError,
		{ data: BulkUploadUrlsRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof requestBulkDocumentUploadUrls>>,
	TError,
	{ data: BulkUploadUrlsRequest },
	TContext
> => {
	const mutationOptions =
		getRequestBulkDocumentUploadUrlsMutationOptions(options);

	return useMutation(mutationOptions);
};

export const reprocessBulkUpload = (
	bulkUploadId: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<ReprocessBulkUpload200>(
		{
			url: `/gw/stitch-web/api/documents/bulk-uploads/${bulkUploadId}/reprocess`,
			method: 'POST',
		},
		options,
	);
};

export const getReprocessBulkUploadMutationOptions = <
	TError = ErrorType<ReprocessBulkUpload404>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reprocessBulkUpload>>,
		TError,
		{ bulkUploadId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof reprocessBulkUpload>>,
	TError,
	{ bulkUploadId: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reprocessBulkUpload>>,
		{ bulkUploadId: string }
	> = (props) => {
		const { bulkUploadId } = props ?? {};

		return reprocessBulkUpload(bulkUploadId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReprocessBulkUploadMutationResult = NonNullable<
	Awaited<ReturnType<typeof reprocessBulkUpload>>
>;

export type ReprocessBulkUploadMutationError =
	ErrorType<ReprocessBulkUpload404>;

export const useReprocessBulkUpload = <
	TError = ErrorType<ReprocessBulkUpload404>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reprocessBulkUpload>>,
		TError,
		{ bulkUploadId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof reprocessBulkUpload>>,
	TError,
	{ bulkUploadId: string },
	TContext
> => {
	const mutationOptions = getReprocessBulkUploadMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listCareGapUploadDocuments = (
	params: ListCareGapUploadDocumentsParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<CareGapUploadDocumentsResponse>(
		{
			url: `/gw/stitch-web/api/documents/care-gap-uploads`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getListCareGapUploadDocumentsQueryKey = (
	params: ListCareGapUploadDocumentsParams,
) => {
	return [
		`/gw/stitch-web/api/documents/care-gap-uploads`,
		...(params ? [params] : []),
	] as const;
};

export const getListCareGapUploadDocumentsQueryOptions = <
	TData = Awaited<ReturnType<typeof listCareGapUploadDocuments>>,
	TError = ErrorType<unknown>,
>(
	params: ListCareGapUploadDocumentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listCareGapUploadDocuments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListCareGapUploadDocumentsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listCareGapUploadDocuments>>
	> = ({ signal }) =>
		listCareGapUploadDocuments(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listCareGapUploadDocuments>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListCareGapUploadDocumentsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listCareGapUploadDocuments>>
>;
export type ListCareGapUploadDocumentsQueryError = ErrorType<unknown>;

export const useListCareGapUploadDocuments = <
	TData = Awaited<ReturnType<typeof listCareGapUploadDocuments>>,
	TError = ErrorType<unknown>,
>(
	params: ListCareGapUploadDocumentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listCareGapUploadDocuments>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListCareGapUploadDocumentsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const assignDocumentToPatient = (
	id: number,
	assignDocumentToPatientRequest: AssignDocumentToPatientRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Document>(
		{
			url: `/gw/stitch-web/api/documents/${id}/assign-patient`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: assignDocumentToPatientRequest,
		},
		options,
	);
};

export const getAssignDocumentToPatientMutationOptions = <
	TError = ErrorType<AssignDocumentToPatient404>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof assignDocumentToPatient>>,
		TError,
		{ id: number; data: AssignDocumentToPatientRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof assignDocumentToPatient>>,
	TError,
	{ id: number; data: AssignDocumentToPatientRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof assignDocumentToPatient>>,
		{ id: number; data: AssignDocumentToPatientRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return assignDocumentToPatient(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AssignDocumentToPatientMutationResult = NonNullable<
	Awaited<ReturnType<typeof assignDocumentToPatient>>
>;
export type AssignDocumentToPatientMutationBody =
	AssignDocumentToPatientRequest;
export type AssignDocumentToPatientMutationError =
	ErrorType<AssignDocumentToPatient404>;

export const useAssignDocumentToPatient = <
	TError = ErrorType<AssignDocumentToPatient404>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof assignDocumentToPatient>>,
		TError,
		{ id: number; data: AssignDocumentToPatientRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof assignDocumentToPatient>>,
	TError,
	{ id: number; data: AssignDocumentToPatientRequest },
	TContext
> => {
	const mutationOptions = getAssignDocumentToPatientMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listUnmatchedPatientUploads = (
	params?: ListUnmatchedPatientUploadsParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<UnmatchedPatientUploadsResponse>(
		{
			url: `/gw/stitch-web/api/documents/unmatched-patient-uploads`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getListUnmatchedPatientUploadsQueryKey = (
	params?: ListUnmatchedPatientUploadsParams,
) => {
	return [
		`/gw/stitch-web/api/documents/unmatched-patient-uploads`,
		...(params ? [params] : []),
	] as const;
};

export const getListUnmatchedPatientUploadsQueryOptions = <
	TData = Awaited<ReturnType<typeof listUnmatchedPatientUploads>>,
	TError = ErrorType<unknown>,
>(
	params?: ListUnmatchedPatientUploadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listUnmatchedPatientUploads>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListUnmatchedPatientUploadsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listUnmatchedPatientUploads>>
	> = ({ signal }) =>
		listUnmatchedPatientUploads(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listUnmatchedPatientUploads>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListUnmatchedPatientUploadsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listUnmatchedPatientUploads>>
>;
export type ListUnmatchedPatientUploadsQueryError = ErrorType<unknown>;

export const useListUnmatchedPatientUploads = <
	TData = Awaited<ReturnType<typeof listUnmatchedPatientUploads>>,
	TError = ErrorType<unknown>,
>(
	params?: ListUnmatchedPatientUploadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listUnmatchedPatientUploads>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListUnmatchedPatientUploadsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const countDocumentJobs = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<DocumentJobsCountResponse>(
		{ url: `/gw/stitch-web/api/documents/jobs/count`, method: 'GET', signal },
		options,
	);
};

export const getCountDocumentJobsQueryKey = () => {
	return [`/gw/stitch-web/api/documents/jobs/count`] as const;
};

export const getCountDocumentJobsQueryOptions = <
	TData = Awaited<ReturnType<typeof countDocumentJobs>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof countDocumentJobs>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getCountDocumentJobsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof countDocumentJobs>>
	> = ({ signal }) => countDocumentJobs(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof countDocumentJobs>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type CountDocumentJobsQueryResult = NonNullable<
	Awaited<ReturnType<typeof countDocumentJobs>>
>;
export type CountDocumentJobsQueryError = ErrorType<unknown>;

export const useCountDocumentJobs = <
	TData = Awaited<ReturnType<typeof countDocumentJobs>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof countDocumentJobs>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getCountDocumentJobsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getDocumentViewUrl = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<DocumentViewUrlResponse>(
		{
			url: `/gw/stitch-web/api/documents/${id}/view-url`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetDocumentViewUrlQueryKey = (id: number) => {
	return [`/gw/stitch-web/api/documents/${id}/view-url`] as const;
};

export const getGetDocumentViewUrlQueryOptions = <
	TData = Awaited<ReturnType<typeof getDocumentViewUrl>>,
	TError = ErrorType<GetDocumentViewUrl404>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getDocumentViewUrl>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDocumentViewUrlQueryKey(id);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getDocumentViewUrl>>
	> = ({ signal }) => getDocumentViewUrl(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getDocumentViewUrl>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetDocumentViewUrlQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDocumentViewUrl>>
>;
export type GetDocumentViewUrlQueryError = ErrorType<GetDocumentViewUrl404>;

export const useGetDocumentViewUrl = <
	TData = Awaited<ReturnType<typeof getDocumentViewUrl>>,
	TError = ErrorType<GetDocumentViewUrl404>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getDocumentViewUrl>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetDocumentViewUrlQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getDocumentById = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Document>(
		{ url: `/gw/stitch-web/api/documents/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetDocumentByIdQueryKey = (id: number) => {
	return [`/gw/stitch-web/api/documents/${id}`] as const;
};

export const getGetDocumentByIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getDocumentById>>,
	TError = ErrorType<GetDocumentById404>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getDocumentById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDocumentByIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentById>>> = ({
		signal,
	}) => getDocumentById(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getDocumentById>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetDocumentByIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDocumentById>>
>;
export type GetDocumentByIdQueryError = ErrorType<GetDocumentById404>;

export const useGetDocumentById = <
	TData = Awaited<ReturnType<typeof getDocumentById>>,
	TError = ErrorType<GetDocumentById404>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getDocumentById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetDocumentByIdQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const reprocessDocument = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<ReprocessDocument200>(
		{ url: `/gw/stitch-web/api/documents/${id}/reprocess`, method: 'POST' },
		options,
	);
};

export const getReprocessDocumentMutationOptions = <
	TError = ErrorType<ReprocessDocument404 | ReprocessDocument409>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reprocessDocument>>,
		TError,
		{ id: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof reprocessDocument>>,
	TError,
	{ id: number },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reprocessDocument>>,
		{ id: number }
	> = (props) => {
		const { id } = props ?? {};

		return reprocessDocument(id, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReprocessDocumentMutationResult = NonNullable<
	Awaited<ReturnType<typeof reprocessDocument>>
>;

export type ReprocessDocumentMutationError = ErrorType<
	ReprocessDocument404 | ReprocessDocument409
>;

export const useReprocessDocument = <
	TError = ErrorType<ReprocessDocument404 | ReprocessDocument409>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reprocessDocument>>,
		TError,
		{ id: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof reprocessDocument>>,
	TError,
	{ id: number },
	TContext
> => {
	const mutationOptions = getReprocessDocumentMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listEncounters = (
	params?: ListEncountersParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListEncountersResponse>(
		{ url: `/gw/stitch-web/api/encounters`, method: 'GET', params, signal },
		options,
	);
};

export const getListEncountersQueryKey = (params?: ListEncountersParams) => {
	return [
		`/gw/stitch-web/api/encounters`,
		...(params ? [params] : []),
	] as const;
};

export const getListEncountersQueryOptions = <
	TData = Awaited<ReturnType<typeof listEncounters>>,
	TError = ErrorType<
		| ListEncounters401
		| ListEncounters403
		| ListEncounters404
		| ListEncounters500
		| ListEncounters503
	>,
>(
	params?: ListEncountersParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listEncounters>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListEncountersQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listEncounters>>> = ({
		signal,
	}) => listEncounters(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listEncounters>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListEncountersQueryResult = NonNullable<
	Awaited<ReturnType<typeof listEncounters>>
>;
export type ListEncountersQueryError = ErrorType<
	| ListEncounters401
	| ListEncounters403
	| ListEncounters404
	| ListEncounters500
	| ListEncounters503
>;

export const useListEncounters = <
	TData = Awaited<ReturnType<typeof listEncounters>>,
	TError = ErrorType<
		| ListEncounters401
		| ListEncounters403
		| ListEncounters404
		| ListEncounters500
		| ListEncounters503
	>,
>(
	params?: ListEncountersParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listEncounters>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListEncountersQueryOptions(params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const createEncounter = (
	createEncounterRequest: CreateEncounterRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Encounter>(
		{
			url: `/gw/stitch-web/api/encounters`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createEncounterRequest,
		},
		options,
	);
};

export const getCreateEncounterMutationOptions = <
	TError = ErrorType<
		| CreateEncounter401
		| CreateEncounter403
		| CreateEncounter404
		| CreateEncounter500
		| CreateEncounter503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createEncounter>>,
		TError,
		{ data: CreateEncounterRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createEncounter>>,
	TError,
	{ data: CreateEncounterRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createEncounter>>,
		{ data: CreateEncounterRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createEncounter(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateEncounterMutationResult = NonNullable<
	Awaited<ReturnType<typeof createEncounter>>
>;
export type CreateEncounterMutationBody = CreateEncounterRequest;
export type CreateEncounterMutationError = ErrorType<
	| CreateEncounter401
	| CreateEncounter403
	| CreateEncounter404
	| CreateEncounter500
	| CreateEncounter503
>;

export const useCreateEncounter = <
	TError = ErrorType<
		| CreateEncounter401
		| CreateEncounter403
		| CreateEncounter404
		| CreateEncounter500
		| CreateEncounter503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createEncounter>>,
		TError,
		{ data: CreateEncounterRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createEncounter>>,
	TError,
	{ data: CreateEncounterRequest },
	TContext
> => {
	const mutationOptions = getCreateEncounterMutationOptions(options);

	return useMutation(mutationOptions);
};

export const updateEncounterById = (
	id: number,
	updateEncounterRequest: UpdateEncounterRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Encounter>(
		{
			url: `/gw/stitch-web/api/encounters/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updateEncounterRequest,
		},
		options,
	);
};

export const getUpdateEncounterByIdMutationOptions = <
	TError = ErrorType<
		| UpdateEncounterById401
		| UpdateEncounterById403
		| UpdateEncounterById404
		| UpdateEncounterById500
		| UpdateEncounterById503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateEncounterById>>,
		TError,
		{ id: number; data: UpdateEncounterRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateEncounterById>>,
	TError,
	{ id: number; data: UpdateEncounterRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateEncounterById>>,
		{ id: number; data: UpdateEncounterRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateEncounterById(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateEncounterByIdMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateEncounterById>>
>;
export type UpdateEncounterByIdMutationBody = UpdateEncounterRequest;
export type UpdateEncounterByIdMutationError = ErrorType<
	| UpdateEncounterById401
	| UpdateEncounterById403
	| UpdateEncounterById404
	| UpdateEncounterById500
	| UpdateEncounterById503
>;

export const useUpdateEncounterById = <
	TError = ErrorType<
		| UpdateEncounterById401
		| UpdateEncounterById403
		| UpdateEncounterById404
		| UpdateEncounterById500
		| UpdateEncounterById503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateEncounterById>>,
		TError,
		{ id: number; data: UpdateEncounterRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateEncounterById>>,
	TError,
	{ id: number; data: UpdateEncounterRequest },
	TContext
> => {
	const mutationOptions = getUpdateEncounterByIdMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getEncounterById = (
	id: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Encounter>(
		{ url: `/gw/stitch-web/api/encounters/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetEncounterByIdQueryKey = (id: number) => {
	return [`/gw/stitch-web/api/encounters/${id}`] as const;
};

export const getGetEncounterByIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getEncounterById>>,
	TError = ErrorType<
		| GetEncounterById401
		| GetEncounterById403
		| GetEncounterById404
		| GetEncounterById500
		| GetEncounterById503
	>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetEncounterByIdQueryKey(id);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getEncounterById>>
	> = ({ signal }) => getEncounterById(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getEncounterById>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetEncounterByIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getEncounterById>>
>;
export type GetEncounterByIdQueryError = ErrorType<
	| GetEncounterById401
	| GetEncounterById403
	| GetEncounterById404
	| GetEncounterById500
	| GetEncounterById503
>;

export const useGetEncounterById = <
	TData = Awaited<ReturnType<typeof getEncounterById>>,
	TError = ErrorType<
		| GetEncounterById401
		| GetEncounterById403
		| GetEncounterById404
		| GetEncounterById500
		| GetEncounterById503
	>,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterById>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetEncounterByIdQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updateEncounterNote = (
	id: number,
	updateEncounterNoteRequest: UpdateEncounterNoteRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UpdateEncounterNoteResponse>(
		{
			url: `/gw/stitch-web/api/encounters/${id}/note`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: updateEncounterNoteRequest,
		},
		options,
	);
};

export const getUpdateEncounterNoteMutationOptions = <
	TError = ErrorType<
		| UpdateEncounterNote401
		| UpdateEncounterNote403
		| UpdateEncounterNote404
		| UpdateEncounterNote500
		| UpdateEncounterNote503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateEncounterNote>>,
		TError,
		{ id: number; data: UpdateEncounterNoteRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateEncounterNote>>,
	TError,
	{ id: number; data: UpdateEncounterNoteRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateEncounterNote>>,
		{ id: number; data: UpdateEncounterNoteRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateEncounterNote(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateEncounterNoteMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateEncounterNote>>
>;
export type UpdateEncounterNoteMutationBody = UpdateEncounterNoteRequest;
export type UpdateEncounterNoteMutationError = ErrorType<
	| UpdateEncounterNote401
	| UpdateEncounterNote403
	| UpdateEncounterNote404
	| UpdateEncounterNote500
	| UpdateEncounterNote503
>;

export const useUpdateEncounterNote = <
	TError = ErrorType<
		| UpdateEncounterNote401
		| UpdateEncounterNote403
		| UpdateEncounterNote404
		| UpdateEncounterNote500
		| UpdateEncounterNote503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateEncounterNote>>,
		TError,
		{ id: number; data: UpdateEncounterNoteRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateEncounterNote>>,
	TError,
	{ id: number; data: UpdateEncounterNoteRequest },
	TContext
> => {
	const mutationOptions = getUpdateEncounterNoteMutationOptions(options);

	return useMutation(mutationOptions);
};

export const createTranscriptionSession = (
	createTranscriptionSessionRequest: CreateTranscriptionSessionRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<TranscriptionSessionResponse>(
		{
			url: `/gw/stitch-web/api/encounters/transcription-session`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createTranscriptionSessionRequest,
		},
		options,
	);
};

export const getCreateTranscriptionSessionMutationOptions = <
	TError = ErrorType<
		| CreateTranscriptionSession401
		| CreateTranscriptionSession403
		| CreateTranscriptionSession404
		| CreateTranscriptionSession500
		| CreateTranscriptionSession503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createTranscriptionSession>>,
		TError,
		{ data: CreateTranscriptionSessionRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createTranscriptionSession>>,
	TError,
	{ data: CreateTranscriptionSessionRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createTranscriptionSession>>,
		{ data: CreateTranscriptionSessionRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createTranscriptionSession(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateTranscriptionSessionMutationResult = NonNullable<
	Awaited<ReturnType<typeof createTranscriptionSession>>
>;
export type CreateTranscriptionSessionMutationBody =
	CreateTranscriptionSessionRequest;
export type CreateTranscriptionSessionMutationError = ErrorType<
	| CreateTranscriptionSession401
	| CreateTranscriptionSession403
	| CreateTranscriptionSession404
	| CreateTranscriptionSession500
	| CreateTranscriptionSession503
>;

export const useCreateTranscriptionSession = <
	TError = ErrorType<
		| CreateTranscriptionSession401
		| CreateTranscriptionSession403
		| CreateTranscriptionSession404
		| CreateTranscriptionSession500
		| CreateTranscriptionSession503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createTranscriptionSession>>,
		TError,
		{ data: CreateTranscriptionSessionRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createTranscriptionSession>>,
	TError,
	{ data: CreateTranscriptionSessionRequest },
	TContext
> => {
	const mutationOptions = getCreateTranscriptionSessionMutationOptions(options);

	return useMutation(mutationOptions);
};

export const createElationVisitNote = (
	createElationVisitNoteRequest: CreateElationVisitNoteRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CreateElationVisitNoteResponse>(
		{
			url: `/gw/stitch-web/api/encounters/elation/visit-note`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createElationVisitNoteRequest,
		},
		options,
	);
};

export const getCreateElationVisitNoteMutationOptions = <
	TError = ErrorType<
		| CreateElationVisitNote401
		| CreateElationVisitNote403
		| CreateElationVisitNote404
		| CreateElationVisitNote500
		| CreateElationVisitNote503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createElationVisitNote>>,
		TError,
		{ data: CreateElationVisitNoteRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createElationVisitNote>>,
	TError,
	{ data: CreateElationVisitNoteRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createElationVisitNote>>,
		{ data: CreateElationVisitNoteRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createElationVisitNote(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateElationVisitNoteMutationResult = NonNullable<
	Awaited<ReturnType<typeof createElationVisitNote>>
>;
export type CreateElationVisitNoteMutationBody = CreateElationVisitNoteRequest;
export type CreateElationVisitNoteMutationError = ErrorType<
	| CreateElationVisitNote401
	| CreateElationVisitNote403
	| CreateElationVisitNote404
	| CreateElationVisitNote500
	| CreateElationVisitNote503
>;

export const useCreateElationVisitNote = <
	TError = ErrorType<
		| CreateElationVisitNote401
		| CreateElationVisitNote403
		| CreateElationVisitNote404
		| CreateElationVisitNote500
		| CreateElationVisitNote503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createElationVisitNote>>,
		TError,
		{ data: CreateElationVisitNoteRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createElationVisitNote>>,
	TError,
	{ data: CreateElationVisitNoteRequest },
	TContext
> => {
	const mutationOptions = getCreateElationVisitNoteMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getEncounterVisitNoteJson = (
	encounterId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<VisitNoteJsonResponse>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/visit-note/json`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetEncounterVisitNoteJsonQueryKey = (encounterId: number) => {
	return [
		`/gw/stitch-web/api/encounters/${encounterId}/visit-note/json`,
	] as const;
};

export const getGetEncounterVisitNoteJsonQueryOptions = <
	TData = Awaited<ReturnType<typeof getEncounterVisitNoteJson>>,
	TError = ErrorType<
		| GetEncounterVisitNoteJson401
		| GetEncounterVisitNoteJson403
		| GetEncounterVisitNoteJson404
		| GetEncounterVisitNoteJson500
		| GetEncounterVisitNoteJson503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterVisitNoteJson>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetEncounterVisitNoteJsonQueryKey(encounterId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getEncounterVisitNoteJson>>
	> = ({ signal }) =>
		getEncounterVisitNoteJson(encounterId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!encounterId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getEncounterVisitNoteJson>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetEncounterVisitNoteJsonQueryResult = NonNullable<
	Awaited<ReturnType<typeof getEncounterVisitNoteJson>>
>;
export type GetEncounterVisitNoteJsonQueryError = ErrorType<
	| GetEncounterVisitNoteJson401
	| GetEncounterVisitNoteJson403
	| GetEncounterVisitNoteJson404
	| GetEncounterVisitNoteJson500
	| GetEncounterVisitNoteJson503
>;

export const useGetEncounterVisitNoteJson = <
	TData = Awaited<ReturnType<typeof getEncounterVisitNoteJson>>,
	TError = ErrorType<
		| GetEncounterVisitNoteJson401
		| GetEncounterVisitNoteJson403
		| GetEncounterVisitNoteJson404
		| GetEncounterVisitNoteJson500
		| GetEncounterVisitNoteJson503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterVisitNoteJson>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetEncounterVisitNoteJsonQueryOptions(
		encounterId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const listTranscriptItemsForEncounter = (
	encounterId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListTranscriptItemsResponse>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/transcript`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListTranscriptItemsForEncounterQueryKey = (
	encounterId: number,
) => {
	return [`/gw/stitch-web/api/encounters/${encounterId}/transcript`] as const;
};

export const getListTranscriptItemsForEncounterQueryOptions = <
	TData = Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>,
	TError = ErrorType<
		| ListTranscriptItemsForEncounter401
		| ListTranscriptItemsForEncounter403
		| ListTranscriptItemsForEncounter404
		| ListTranscriptItemsForEncounter500
		| ListTranscriptItemsForEncounter503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListTranscriptItemsForEncounterQueryKey(encounterId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>
	> = ({ signal }) =>
		listTranscriptItemsForEncounter(encounterId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!encounterId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListTranscriptItemsForEncounterQueryResult = NonNullable<
	Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>
>;
export type ListTranscriptItemsForEncounterQueryError = ErrorType<
	| ListTranscriptItemsForEncounter401
	| ListTranscriptItemsForEncounter403
	| ListTranscriptItemsForEncounter404
	| ListTranscriptItemsForEncounter500
	| ListTranscriptItemsForEncounter503
>;

export const useListTranscriptItemsForEncounter = <
	TData = Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>,
	TError = ErrorType<
		| ListTranscriptItemsForEncounter401
		| ListTranscriptItemsForEncounter403
		| ListTranscriptItemsForEncounter404
		| ListTranscriptItemsForEncounter500
		| ListTranscriptItemsForEncounter503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listTranscriptItemsForEncounter>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListTranscriptItemsForEncounterQueryOptions(
		encounterId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const listTranscriptItemsForScribingSession = (
	encounterId: number,
	scribingSessionId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListTranscriptItemsResponse>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/scribing-sessions/${scribingSessionId}/transcript-items`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListTranscriptItemsForScribingSessionQueryKey = (
	encounterId: number,
	scribingSessionId: string,
) => {
	return [
		`/gw/stitch-web/api/encounters/${encounterId}/scribing-sessions/${scribingSessionId}/transcript-items`,
	] as const;
};

export const getListTranscriptItemsForScribingSessionQueryOptions = <
	TData = Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>,
	TError = ErrorType<
		| ListTranscriptItemsForScribingSession401
		| ListTranscriptItemsForScribingSession403
		| ListTranscriptItemsForScribingSession404
		| ListTranscriptItemsForScribingSession500
		| ListTranscriptItemsForScribingSession503
	>,
>(
	encounterId: number,
	scribingSessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListTranscriptItemsForScribingSessionQueryKey(
			encounterId,
			scribingSessionId,
		);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>
	> = ({ signal }) =>
		listTranscriptItemsForScribingSession(
			encounterId,
			scribingSessionId,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: !!(encounterId && scribingSessionId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListTranscriptItemsForScribingSessionQueryResult = NonNullable<
	Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>
>;
export type ListTranscriptItemsForScribingSessionQueryError = ErrorType<
	| ListTranscriptItemsForScribingSession401
	| ListTranscriptItemsForScribingSession403
	| ListTranscriptItemsForScribingSession404
	| ListTranscriptItemsForScribingSession500
	| ListTranscriptItemsForScribingSession503
>;

export const useListTranscriptItemsForScribingSession = <
	TData = Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>,
	TError = ErrorType<
		| ListTranscriptItemsForScribingSession401
		| ListTranscriptItemsForScribingSession403
		| ListTranscriptItemsForScribingSession404
		| ListTranscriptItemsForScribingSession500
		| ListTranscriptItemsForScribingSession503
	>,
>(
	encounterId: number,
	scribingSessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listTranscriptItemsForScribingSession>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListTranscriptItemsForScribingSessionQueryOptions(
		encounterId,
		scribingSessionId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getEncounterTranscriptLastOffset = (
	encounterId: number,
	scribingSessionId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ScribingSessionLastOffsetResponse>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/scribing-sessions/${scribingSessionId}/transcript-items/last-offset`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetEncounterTranscriptLastOffsetQueryKey = (
	encounterId: number,
	scribingSessionId: string,
) => {
	return [
		`/gw/stitch-web/api/encounters/${encounterId}/scribing-sessions/${scribingSessionId}/transcript-items/last-offset`,
	] as const;
};

export const getGetEncounterTranscriptLastOffsetQueryOptions = <
	TData = Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>,
	TError = ErrorType<
		| GetEncounterTranscriptLastOffset401
		| GetEncounterTranscriptLastOffset403
		| GetEncounterTranscriptLastOffset404
		| GetEncounterTranscriptLastOffset500
		| GetEncounterTranscriptLastOffset503
	>,
>(
	encounterId: number,
	scribingSessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetEncounterTranscriptLastOffsetQueryKey(encounterId, scribingSessionId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>
	> = ({ signal }) =>
		getEncounterTranscriptLastOffset(
			encounterId,
			scribingSessionId,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: !!(encounterId && scribingSessionId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetEncounterTranscriptLastOffsetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>
>;
export type GetEncounterTranscriptLastOffsetQueryError = ErrorType<
	| GetEncounterTranscriptLastOffset401
	| GetEncounterTranscriptLastOffset403
	| GetEncounterTranscriptLastOffset404
	| GetEncounterTranscriptLastOffset500
	| GetEncounterTranscriptLastOffset503
>;

export const useGetEncounterTranscriptLastOffset = <
	TData = Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>,
	TError = ErrorType<
		| GetEncounterTranscriptLastOffset401
		| GetEncounterTranscriptLastOffset403
		| GetEncounterTranscriptLastOffset404
		| GetEncounterTranscriptLastOffset500
		| GetEncounterTranscriptLastOffset503
	>,
>(
	encounterId: number,
	scribingSessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterTranscriptLastOffset>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetEncounterTranscriptLastOffsetQueryOptions(
		encounterId,
		scribingSessionId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getEncounterReportPdf = (
	encounterId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Blob>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/report`,
			method: 'GET',
			responseType: 'blob',
			signal,
		},
		options,
	);
};

export const getGetEncounterReportPdfQueryKey = (encounterId: number) => {
	return [`/gw/stitch-web/api/encounters/${encounterId}/report`] as const;
};

export const getGetEncounterReportPdfQueryOptions = <
	TData = Awaited<ReturnType<typeof getEncounterReportPdf>>,
	TError = ErrorType<
		| GetEncounterReportPdf401
		| GetEncounterReportPdf403
		| GetEncounterReportPdf404
		| GetEncounterReportPdf500
		| GetEncounterReportPdf503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterReportPdf>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetEncounterReportPdfQueryKey(encounterId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getEncounterReportPdf>>
	> = ({ signal }) =>
		getEncounterReportPdf(encounterId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!encounterId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getEncounterReportPdf>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetEncounterReportPdfQueryResult = NonNullable<
	Awaited<ReturnType<typeof getEncounterReportPdf>>
>;
export type GetEncounterReportPdfQueryError = ErrorType<
	| GetEncounterReportPdf401
	| GetEncounterReportPdf403
	| GetEncounterReportPdf404
	| GetEncounterReportPdf500
	| GetEncounterReportPdf503
>;

export const useGetEncounterReportPdf = <
	TData = Awaited<ReturnType<typeof getEncounterReportPdf>>,
	TError = ErrorType<
		| GetEncounterReportPdf401
		| GetEncounterReportPdf403
		| GetEncounterReportPdf404
		| GetEncounterReportPdf500
		| GetEncounterReportPdf503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getEncounterReportPdf>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetEncounterReportPdfQueryOptions(
		encounterId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const listAgendaItems = (
	encounterId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<AgendaItemList>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/agenda-items`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListAgendaItemsQueryKey = (encounterId: number) => {
	return [`/gw/stitch-web/api/encounters/${encounterId}/agenda-items`] as const;
};

export const getListAgendaItemsQueryOptions = <
	TData = Awaited<ReturnType<typeof listAgendaItems>>,
	TError = ErrorType<
		| ListAgendaItems401
		| ListAgendaItems403
		| ListAgendaItems404
		| ListAgendaItems500
		| ListAgendaItems503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listAgendaItems>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListAgendaItemsQueryKey(encounterId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgendaItems>>> = ({
		signal,
	}) => listAgendaItems(encounterId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!encounterId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listAgendaItems>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListAgendaItemsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listAgendaItems>>
>;
export type ListAgendaItemsQueryError = ErrorType<
	| ListAgendaItems401
	| ListAgendaItems403
	| ListAgendaItems404
	| ListAgendaItems500
	| ListAgendaItems503
>;

export const useListAgendaItems = <
	TData = Awaited<ReturnType<typeof listAgendaItems>>,
	TError = ErrorType<
		| ListAgendaItems401
		| ListAgendaItems403
		| ListAgendaItems404
		| ListAgendaItems500
		| ListAgendaItems503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listAgendaItems>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListAgendaItemsQueryOptions(encounterId, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const createAgendaItem = (
	encounterId: number,
	createAgendaItemRequest: CreateAgendaItemRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<AgendaItem>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/agenda-items`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createAgendaItemRequest,
		},
		options,
	);
};

export const getCreateAgendaItemMutationOptions = <
	TError = ErrorType<
		| CreateAgendaItem401
		| CreateAgendaItem403
		| CreateAgendaItem404
		| CreateAgendaItem500
		| CreateAgendaItem503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createAgendaItem>>,
		TError,
		{ encounterId: number; data: CreateAgendaItemRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createAgendaItem>>,
	TError,
	{ encounterId: number; data: CreateAgendaItemRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createAgendaItem>>,
		{ encounterId: number; data: CreateAgendaItemRequest }
	> = (props) => {
		const { encounterId, data } = props ?? {};

		return createAgendaItem(encounterId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateAgendaItemMutationResult = NonNullable<
	Awaited<ReturnType<typeof createAgendaItem>>
>;
export type CreateAgendaItemMutationBody = CreateAgendaItemRequest;
export type CreateAgendaItemMutationError = ErrorType<
	| CreateAgendaItem401
	| CreateAgendaItem403
	| CreateAgendaItem404
	| CreateAgendaItem500
	| CreateAgendaItem503
>;

export const useCreateAgendaItem = <
	TError = ErrorType<
		| CreateAgendaItem401
		| CreateAgendaItem403
		| CreateAgendaItem404
		| CreateAgendaItem500
		| CreateAgendaItem503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createAgendaItem>>,
		TError,
		{ encounterId: number; data: CreateAgendaItemRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createAgendaItem>>,
	TError,
	{ encounterId: number; data: CreateAgendaItemRequest },
	TContext
> => {
	const mutationOptions = getCreateAgendaItemMutationOptions(options);

	return useMutation(mutationOptions);
};

export const updateAgendaItem = (
	encounterId: number,
	itemId: number,
	updateAgendaItemRequest: UpdateAgendaItemRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<AgendaItem>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/agenda-items/${itemId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updateAgendaItemRequest,
		},
		options,
	);
};

export const getUpdateAgendaItemMutationOptions = <
	TError = ErrorType<
		| UpdateAgendaItem401
		| UpdateAgendaItem403
		| UpdateAgendaItem404
		| UpdateAgendaItem500
		| UpdateAgendaItem503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateAgendaItem>>,
		TError,
		{ encounterId: number; itemId: number; data: UpdateAgendaItemRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateAgendaItem>>,
	TError,
	{ encounterId: number; itemId: number; data: UpdateAgendaItemRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateAgendaItem>>,
		{ encounterId: number; itemId: number; data: UpdateAgendaItemRequest }
	> = (props) => {
		const { encounterId, itemId, data } = props ?? {};

		return updateAgendaItem(encounterId, itemId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateAgendaItemMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateAgendaItem>>
>;
export type UpdateAgendaItemMutationBody = UpdateAgendaItemRequest;
export type UpdateAgendaItemMutationError = ErrorType<
	| UpdateAgendaItem401
	| UpdateAgendaItem403
	| UpdateAgendaItem404
	| UpdateAgendaItem500
	| UpdateAgendaItem503
>;

export const useUpdateAgendaItem = <
	TError = ErrorType<
		| UpdateAgendaItem401
		| UpdateAgendaItem403
		| UpdateAgendaItem404
		| UpdateAgendaItem500
		| UpdateAgendaItem503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateAgendaItem>>,
		TError,
		{ encounterId: number; itemId: number; data: UpdateAgendaItemRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateAgendaItem>>,
	TError,
	{ encounterId: number; itemId: number; data: UpdateAgendaItemRequest },
	TContext
> => {
	const mutationOptions = getUpdateAgendaItemMutationOptions(options);

	return useMutation(mutationOptions);
};

export const deleteAgendaItem = (
	encounterId: number,
	itemId: number,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<void>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/agenda-items/${itemId}`,
			method: 'DELETE',
		},
		options,
	);
};

export const getDeleteAgendaItemMutationOptions = <
	TError = ErrorType<
		| DeleteAgendaItem401
		| DeleteAgendaItem403
		| DeleteAgendaItem404
		| DeleteAgendaItem500
		| DeleteAgendaItem503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteAgendaItem>>,
		TError,
		{ encounterId: number; itemId: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteAgendaItem>>,
	TError,
	{ encounterId: number; itemId: number },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteAgendaItem>>,
		{ encounterId: number; itemId: number }
	> = (props) => {
		const { encounterId, itemId } = props ?? {};

		return deleteAgendaItem(encounterId, itemId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteAgendaItemMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteAgendaItem>>
>;

export type DeleteAgendaItemMutationError = ErrorType<
	| DeleteAgendaItem401
	| DeleteAgendaItem403
	| DeleteAgendaItem404
	| DeleteAgendaItem500
	| DeleteAgendaItem503
>;

export const useDeleteAgendaItem = <
	TError = ErrorType<
		| DeleteAgendaItem401
		| DeleteAgendaItem403
		| DeleteAgendaItem404
		| DeleteAgendaItem500
		| DeleteAgendaItem503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteAgendaItem>>,
		TError,
		{ encounterId: number; itemId: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof deleteAgendaItem>>,
	TError,
	{ encounterId: number; itemId: number },
	TContext
> => {
	const mutationOptions = getDeleteAgendaItemMutationOptions(options);

	return useMutation(mutationOptions);
};

export const reorderAgendaItems = (
	encounterId: number,
	reorderAgendaItemsRequest: ReorderAgendaItemsRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<AgendaItemList>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/agenda-items/reorder`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: reorderAgendaItemsRequest,
		},
		options,
	);
};

export const getReorderAgendaItemsMutationOptions = <
	TError = ErrorType<
		| ReorderAgendaItems401
		| ReorderAgendaItems403
		| ReorderAgendaItems404
		| ReorderAgendaItems500
		| ReorderAgendaItems503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reorderAgendaItems>>,
		TError,
		{ encounterId: number; data: ReorderAgendaItemsRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof reorderAgendaItems>>,
	TError,
	{ encounterId: number; data: ReorderAgendaItemsRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reorderAgendaItems>>,
		{ encounterId: number; data: ReorderAgendaItemsRequest }
	> = (props) => {
		const { encounterId, data } = props ?? {};

		return reorderAgendaItems(encounterId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReorderAgendaItemsMutationResult = NonNullable<
	Awaited<ReturnType<typeof reorderAgendaItems>>
>;
export type ReorderAgendaItemsMutationBody = ReorderAgendaItemsRequest;
export type ReorderAgendaItemsMutationError = ErrorType<
	| ReorderAgendaItems401
	| ReorderAgendaItems403
	| ReorderAgendaItems404
	| ReorderAgendaItems500
	| ReorderAgendaItems503
>;

export const useReorderAgendaItems = <
	TError = ErrorType<
		| ReorderAgendaItems401
		| ReorderAgendaItems403
		| ReorderAgendaItems404
		| ReorderAgendaItems500
		| ReorderAgendaItems503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reorderAgendaItems>>,
		TError,
		{ encounterId: number; data: ReorderAgendaItemsRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof reorderAgendaItems>>,
	TError,
	{ encounterId: number; data: ReorderAgendaItemsRequest },
	TContext
> => {
	const mutationOptions = getReorderAgendaItemsMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listActionItemsForEncounter = (
	encounterId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ActionItemList>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/action-items`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListActionItemsForEncounterQueryKey = (encounterId: number) => {
	return [`/gw/stitch-web/api/encounters/${encounterId}/action-items`] as const;
};

export const getListActionItemsForEncounterQueryOptions = <
	TData = Awaited<ReturnType<typeof listActionItemsForEncounter>>,
	TError = ErrorType<
		| ListActionItemsForEncounter401
		| ListActionItemsForEncounter403
		| ListActionItemsForEncounter404
		| ListActionItemsForEncounter500
		| ListActionItemsForEncounter503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listActionItemsForEncounter>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListActionItemsForEncounterQueryKey(encounterId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listActionItemsForEncounter>>
	> = ({ signal }) =>
		listActionItemsForEncounter(encounterId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!encounterId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listActionItemsForEncounter>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListActionItemsForEncounterQueryResult = NonNullable<
	Awaited<ReturnType<typeof listActionItemsForEncounter>>
>;
export type ListActionItemsForEncounterQueryError = ErrorType<
	| ListActionItemsForEncounter401
	| ListActionItemsForEncounter403
	| ListActionItemsForEncounter404
	| ListActionItemsForEncounter500
	| ListActionItemsForEncounter503
>;

export const useListActionItemsForEncounter = <
	TData = Awaited<ReturnType<typeof listActionItemsForEncounter>>,
	TError = ErrorType<
		| ListActionItemsForEncounter401
		| ListActionItemsForEncounter403
		| ListActionItemsForEncounter404
		| ListActionItemsForEncounter500
		| ListActionItemsForEncounter503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listActionItemsForEncounter>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListActionItemsForEncounterQueryOptions(
		encounterId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const updateActionItemStatus = (
	id: number,
	updateActionItemStatusRequest: UpdateActionItemStatusRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<ActionItem>(
		{
			url: `/gw/stitch-web/api/action-items/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updateActionItemStatusRequest,
		},
		options,
	);
};

export const getUpdateActionItemStatusMutationOptions = <
	TError = ErrorType<
		| UpdateActionItemStatus401
		| UpdateActionItemStatus403
		| UpdateActionItemStatus404
		| UpdateActionItemStatus500
		| UpdateActionItemStatus503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateActionItemStatus>>,
		TError,
		{ id: number; data: UpdateActionItemStatusRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateActionItemStatus>>,
	TError,
	{ id: number; data: UpdateActionItemStatusRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateActionItemStatus>>,
		{ id: number; data: UpdateActionItemStatusRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateActionItemStatus(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateActionItemStatusMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateActionItemStatus>>
>;
export type UpdateActionItemStatusMutationBody = UpdateActionItemStatusRequest;
export type UpdateActionItemStatusMutationError = ErrorType<
	| UpdateActionItemStatus401
	| UpdateActionItemStatus403
	| UpdateActionItemStatus404
	| UpdateActionItemStatus500
	| UpdateActionItemStatus503
>;

export const useUpdateActionItemStatus = <
	TError = ErrorType<
		| UpdateActionItemStatus401
		| UpdateActionItemStatus403
		| UpdateActionItemStatus404
		| UpdateActionItemStatus500
		| UpdateActionItemStatus503
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateActionItemStatus>>,
		TError,
		{ id: number; data: UpdateActionItemStatusRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateActionItemStatus>>,
	TError,
	{ id: number; data: UpdateActionItemStatusRequest },
	TContext
> => {
	const mutationOptions = getUpdateActionItemStatusMutationOptions(options);

	return useMutation(mutationOptions);
};

export const listMedicalCodesByEncounter = (
	encounterId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListMedicalCodesByEncounterResponse>(
		{
			url: `/gw/stitch-web/api/encounters/${encounterId}/medical-codes`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getListMedicalCodesByEncounterQueryKey = (encounterId: number) => {
	return [
		`/gw/stitch-web/api/encounters/${encounterId}/medical-codes`,
	] as const;
};

export const getListMedicalCodesByEncounterQueryOptions = <
	TData = Awaited<ReturnType<typeof listMedicalCodesByEncounter>>,
	TError = ErrorType<
		| ListMedicalCodesByEncounter401
		| ListMedicalCodesByEncounter403
		| ListMedicalCodesByEncounter404
		| ListMedicalCodesByEncounter500
		| ListMedicalCodesByEncounter503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMedicalCodesByEncounter>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListMedicalCodesByEncounterQueryKey(encounterId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMedicalCodesByEncounter>>
	> = ({ signal }) =>
		listMedicalCodesByEncounter(encounterId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!encounterId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listMedicalCodesByEncounter>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListMedicalCodesByEncounterQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMedicalCodesByEncounter>>
>;
export type ListMedicalCodesByEncounterQueryError = ErrorType<
	| ListMedicalCodesByEncounter401
	| ListMedicalCodesByEncounter403
	| ListMedicalCodesByEncounter404
	| ListMedicalCodesByEncounter500
	| ListMedicalCodesByEncounter503
>;

export const useListMedicalCodesByEncounter = <
	TData = Awaited<ReturnType<typeof listMedicalCodesByEncounter>>,
	TError = ErrorType<
		| ListMedicalCodesByEncounter401
		| ListMedicalCodesByEncounter403
		| ListMedicalCodesByEncounter404
		| ListMedicalCodesByEncounter500
		| ListMedicalCodesByEncounter503
	>,
>(
	encounterId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMedicalCodesByEncounter>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListMedicalCodesByEncounterQueryOptions(
		encounterId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getJobById = (
	id: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<JobUnion>(
		{ url: `/gw/stitch-web/api/jobs/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetJobByIdQueryKey = (id: string) => {
	return [`/gw/stitch-web/api/jobs/${id}`] as const;
};

export const getGetJobByIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getJobById>>,
	TError = ErrorType<GetJobById404>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getJobById>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetJobByIdQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobById>>> = ({
		signal,
	}) => getJobById(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getJobById>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetJobByIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getJobById>>
>;
export type GetJobByIdQueryError = ErrorType<GetJobById404>;

export const useGetJobById = <
	TData = Awaited<ReturnType<typeof getJobById>>,
	TError = ErrorType<GetJobById404>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getJobById>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetJobByIdQueryOptions(id, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Sign in with a social provider
 */
export const socialSignIn = (
	socialSignInBody: SocialSignInBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<SocialSignIn200>(
		{
			url: `/gw/stitch-web/api/auth/sign-in/social`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: socialSignInBody,
		},
		options,
	);
};

export const getSocialSignInMutationOptions = <
	TError = ErrorType<
		| SocialSignIn400
		| SocialSignIn401
		| SocialSignIn403
		| SocialSignIn404
		| SocialSignIn429
		| SocialSignIn500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof socialSignIn>>,
		TError,
		{ data: SocialSignInBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof socialSignIn>>,
	TError,
	{ data: SocialSignInBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof socialSignIn>>,
		{ data: SocialSignInBody }
	> = (props) => {
		const { data } = props ?? {};

		return socialSignIn(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SocialSignInMutationResult = NonNullable<
	Awaited<ReturnType<typeof socialSignIn>>
>;
export type SocialSignInMutationBody = SocialSignInBody;
export type SocialSignInMutationError = ErrorType<
	| SocialSignIn400
	| SocialSignIn401
	| SocialSignIn403
	| SocialSignIn404
	| SocialSignIn429
	| SocialSignIn500
>;

export const useSocialSignIn = <
	TError = ErrorType<
		| SocialSignIn400
		| SocialSignIn401
		| SocialSignIn403
		| SocialSignIn404
		| SocialSignIn429
		| SocialSignIn500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof socialSignIn>>,
		TError,
		{ data: SocialSignInBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof socialSignIn>>,
	TError,
	{ data: SocialSignInBody },
	TContext
> => {
	const mutationOptions = getSocialSignInMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getGwStitchWebApiAuthCallbackId = (
	id: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{ url: `/gw/stitch-web/api/auth/callback/${id}`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebApiAuthCallbackIdQueryKey = (id: string) => {
	return [`/gw/stitch-web/api/auth/callback/${id}`] as const;
};

export const getGetGwStitchWebApiAuthCallbackIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthCallbackId400
		| GetGwStitchWebApiAuthCallbackId401
		| GetGwStitchWebApiAuthCallbackId403
		| GetGwStitchWebApiAuthCallbackId404
		| GetGwStitchWebApiAuthCallbackId429
		| GetGwStitchWebApiAuthCallbackId500
	>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwStitchWebApiAuthCallbackIdQueryKey(id);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthCallbackId(id, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthCallbackIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>
>;
export type GetGwStitchWebApiAuthCallbackIdQueryError = ErrorType<
	| GetGwStitchWebApiAuthCallbackId400
	| GetGwStitchWebApiAuthCallbackId401
	| GetGwStitchWebApiAuthCallbackId403
	| GetGwStitchWebApiAuthCallbackId404
	| GetGwStitchWebApiAuthCallbackId429
	| GetGwStitchWebApiAuthCallbackId500
>;

export const useGetGwStitchWebApiAuthCallbackId = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthCallbackId400
		| GetGwStitchWebApiAuthCallbackId401
		| GetGwStitchWebApiAuthCallbackId403
		| GetGwStitchWebApiAuthCallbackId404
		| GetGwStitchWebApiAuthCallbackId429
		| GetGwStitchWebApiAuthCallbackId500
	>,
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebApiAuthCallbackId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebApiAuthCallbackIdQueryOptions(
		id,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const postGwStitchWebApiAuthCallbackId = (
	id: string,
	postGwStitchWebApiAuthCallbackIdBody: PostGwStitchWebApiAuthCallbackIdBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/callback/${id}`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthCallbackIdBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthCallbackIdMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthCallbackId400
		| PostGwStitchWebApiAuthCallbackId401
		| PostGwStitchWebApiAuthCallbackId403
		| PostGwStitchWebApiAuthCallbackId404
		| PostGwStitchWebApiAuthCallbackId429
		| PostGwStitchWebApiAuthCallbackId500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthCallbackId>>,
		TError,
		{ id: string; data: PostGwStitchWebApiAuthCallbackIdBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthCallbackId>>,
	TError,
	{ id: string; data: PostGwStitchWebApiAuthCallbackIdBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthCallbackId>>,
		{ id: string; data: PostGwStitchWebApiAuthCallbackIdBody }
	> = (props) => {
		const { id, data } = props ?? {};

		return postGwStitchWebApiAuthCallbackId(id, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthCallbackIdMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthCallbackId>>
>;
export type PostGwStitchWebApiAuthCallbackIdMutationBody =
	PostGwStitchWebApiAuthCallbackIdBody;
export type PostGwStitchWebApiAuthCallbackIdMutationError = ErrorType<
	| PostGwStitchWebApiAuthCallbackId400
	| PostGwStitchWebApiAuthCallbackId401
	| PostGwStitchWebApiAuthCallbackId403
	| PostGwStitchWebApiAuthCallbackId404
	| PostGwStitchWebApiAuthCallbackId429
	| PostGwStitchWebApiAuthCallbackId500
>;

export const usePostGwStitchWebApiAuthCallbackId = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthCallbackId400
		| PostGwStitchWebApiAuthCallbackId401
		| PostGwStitchWebApiAuthCallbackId403
		| PostGwStitchWebApiAuthCallbackId404
		| PostGwStitchWebApiAuthCallbackId429
		| PostGwStitchWebApiAuthCallbackId500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthCallbackId>>,
		TError,
		{ id: string; data: PostGwStitchWebApiAuthCallbackIdBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthCallbackId>>,
	TError,
	{ id: string; data: PostGwStitchWebApiAuthCallbackIdBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthCallbackIdMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Get the current session
 */
export const getSessionGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetSessionGet200>(
		{ url: `/gw/stitch-web/api/auth/get-session`, method: 'GET', signal },
		options,
	);
};

export const getGetSessionGetQueryKey = () => {
	return [`/gw/stitch-web/api/auth/get-session`] as const;
};

export const getGetSessionGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getSessionGet>>,
	TError = ErrorType<
		| GetSessionGet400
		| GetSessionGet401
		| GetSessionGet403
		| GetSessionGet404
		| GetSessionGet429
		| GetSessionGet500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getSessionGet>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSessionGetQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionGet>>> = ({
		signal,
	}) => getSessionGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSessionGet>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetSessionGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getSessionGet>>
>;
export type GetSessionGetQueryError = ErrorType<
	| GetSessionGet400
	| GetSessionGet401
	| GetSessionGet403
	| GetSessionGet404
	| GetSessionGet429
	| GetSessionGet500
>;

export const useGetSessionGet = <
	TData = Awaited<ReturnType<typeof getSessionGet>>,
	TError = ErrorType<
		| GetSessionGet400
		| GetSessionGet401
		| GetSessionGet403
		| GetSessionGet404
		| GetSessionGet429
		| GetSessionGet500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getSessionGet>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetSessionGetQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Get the current session
 */
export const getSessionPost = (
	getSessionPostBody: GetSessionPostBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<GetSessionPost200>(
		{
			url: `/gw/stitch-web/api/auth/get-session`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: getSessionPostBody,
		},
		options,
	);
};

export const getGetSessionPostMutationOptions = <
	TError = ErrorType<
		| GetSessionPost400
		| GetSessionPost401
		| GetSessionPost403
		| GetSessionPost404
		| GetSessionPost429
		| GetSessionPost500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof getSessionPost>>,
		TError,
		{ data: GetSessionPostBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof getSessionPost>>,
	TError,
	{ data: GetSessionPostBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof getSessionPost>>,
		{ data: GetSessionPostBody }
	> = (props) => {
		const { data } = props ?? {};

		return getSessionPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type GetSessionPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof getSessionPost>>
>;
export type GetSessionPostMutationBody = GetSessionPostBody;
export type GetSessionPostMutationError = ErrorType<
	| GetSessionPost400
	| GetSessionPost401
	| GetSessionPost403
	| GetSessionPost404
	| GetSessionPost429
	| GetSessionPost500
>;

export const useGetSessionPost = <
	TError = ErrorType<
		| GetSessionPost400
		| GetSessionPost401
		| GetSessionPost403
		| GetSessionPost404
		| GetSessionPost429
		| GetSessionPost500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof getSessionPost>>,
		TError,
		{ data: GetSessionPostBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof getSessionPost>>,
	TError,
	{ data: GetSessionPostBody },
	TContext
> => {
	const mutationOptions = getGetSessionPostMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Sign out the current user
 */
export const signOut = (
	signOutBody: SignOutBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<SignOut200>(
		{
			url: `/gw/stitch-web/api/auth/sign-out`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: signOutBody,
		},
		options,
	);
};

export const getSignOutMutationOptions = <
	TError = ErrorType<
		SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signOut>>,
		TError,
		{ data: SignOutBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof signOut>>,
	TError,
	{ data: SignOutBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof signOut>>,
		{ data: SignOutBody }
	> = (props) => {
		const { data } = props ?? {};

		return signOut(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SignOutMutationResult = NonNullable<
	Awaited<ReturnType<typeof signOut>>
>;
export type SignOutMutationBody = SignOutBody;
export type SignOutMutationError = ErrorType<
	SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500
>;

export const useSignOut = <
	TError = ErrorType<
		SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signOut>>,
		TError,
		{ data: SignOutBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof signOut>>,
	TError,
	{ data: SignOutBody },
	TContext
> => {
	const mutationOptions = getSignOutMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Sign up a user using email and password
 */
export const signUpWithEmailAndPassword = (
	signUpWithEmailAndPasswordBody: SignUpWithEmailAndPasswordBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<SignUpWithEmailAndPassword200>(
		{
			url: `/gw/stitch-web/api/auth/sign-up/email`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: signUpWithEmailAndPasswordBody,
		},
		options,
	);
};

export const getSignUpWithEmailAndPasswordMutationOptions = <
	TError = ErrorType<
		| SignUpWithEmailAndPassword400
		| SignUpWithEmailAndPassword401
		| SignUpWithEmailAndPassword403
		| SignUpWithEmailAndPassword404
		| SignUpWithEmailAndPassword422
		| SignUpWithEmailAndPassword429
		| SignUpWithEmailAndPassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signUpWithEmailAndPassword>>,
		TError,
		{ data: SignUpWithEmailAndPasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof signUpWithEmailAndPassword>>,
	TError,
	{ data: SignUpWithEmailAndPasswordBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof signUpWithEmailAndPassword>>,
		{ data: SignUpWithEmailAndPasswordBody }
	> = (props) => {
		const { data } = props ?? {};

		return signUpWithEmailAndPassword(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SignUpWithEmailAndPasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof signUpWithEmailAndPassword>>
>;
export type SignUpWithEmailAndPasswordMutationBody =
	SignUpWithEmailAndPasswordBody;
export type SignUpWithEmailAndPasswordMutationError = ErrorType<
	| SignUpWithEmailAndPassword400
	| SignUpWithEmailAndPassword401
	| SignUpWithEmailAndPassword403
	| SignUpWithEmailAndPassword404
	| SignUpWithEmailAndPassword422
	| SignUpWithEmailAndPassword429
	| SignUpWithEmailAndPassword500
>;

export const useSignUpWithEmailAndPassword = <
	TError = ErrorType<
		| SignUpWithEmailAndPassword400
		| SignUpWithEmailAndPassword401
		| SignUpWithEmailAndPassword403
		| SignUpWithEmailAndPassword404
		| SignUpWithEmailAndPassword422
		| SignUpWithEmailAndPassword429
		| SignUpWithEmailAndPassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signUpWithEmailAndPassword>>,
		TError,
		{ data: SignUpWithEmailAndPasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof signUpWithEmailAndPassword>>,
	TError,
	{ data: SignUpWithEmailAndPasswordBody },
	TContext
> => {
	const mutationOptions = getSignUpWithEmailAndPasswordMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Sign in with email and password
 */
export const signInEmail = (
	signInEmailBody: SignInEmailBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<SignInEmail200>(
		{
			url: `/gw/stitch-web/api/auth/sign-in/email`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: signInEmailBody,
		},
		options,
	);
};

export const getSignInEmailMutationOptions = <
	TError = ErrorType<
		| SignInEmail400
		| SignInEmail401
		| SignInEmail403
		| SignInEmail404
		| SignInEmail429
		| SignInEmail500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signInEmail>>,
		TError,
		{ data: SignInEmailBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof signInEmail>>,
	TError,
	{ data: SignInEmailBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof signInEmail>>,
		{ data: SignInEmailBody }
	> = (props) => {
		const { data } = props ?? {};

		return signInEmail(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SignInEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof signInEmail>>
>;
export type SignInEmailMutationBody = SignInEmailBody;
export type SignInEmailMutationError = ErrorType<
	| SignInEmail400
	| SignInEmail401
	| SignInEmail403
	| SignInEmail404
	| SignInEmail429
	| SignInEmail500
>;

export const useSignInEmail = <
	TError = ErrorType<
		| SignInEmail400
		| SignInEmail401
		| SignInEmail403
		| SignInEmail404
		| SignInEmail429
		| SignInEmail500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signInEmail>>,
		TError,
		{ data: SignInEmailBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof signInEmail>>,
	TError,
	{ data: SignInEmailBody },
	TContext
> => {
	const mutationOptions = getSignInEmailMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Reset the password for a user
 */
export const resetPassword = (
	resetPasswordBody: ResetPasswordBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<ResetPassword200>(
		{
			url: `/gw/stitch-web/api/auth/reset-password`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: resetPasswordBody,
		},
		options,
	);
};

export const getResetPasswordMutationOptions = <
	TError = ErrorType<
		| ResetPassword400
		| ResetPassword401
		| ResetPassword403
		| ResetPassword404
		| ResetPassword429
		| ResetPassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof resetPassword>>,
		TError,
		{ data: ResetPasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof resetPassword>>,
	TError,
	{ data: ResetPasswordBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof resetPassword>>,
		{ data: ResetPasswordBody }
	> = (props) => {
		const { data } = props ?? {};

		return resetPassword(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof resetPassword>>
>;
export type ResetPasswordMutationBody = ResetPasswordBody;
export type ResetPasswordMutationError = ErrorType<
	| ResetPassword400
	| ResetPassword401
	| ResetPassword403
	| ResetPassword404
	| ResetPassword429
	| ResetPassword500
>;

export const useResetPassword = <
	TError = ErrorType<
		| ResetPassword400
		| ResetPassword401
		| ResetPassword403
		| ResetPassword404
		| ResetPassword429
		| ResetPassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof resetPassword>>,
		TError,
		{ data: ResetPasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof resetPassword>>,
	TError,
	{ data: ResetPasswordBody },
	TContext
> => {
	const mutationOptions = getResetPasswordMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Verify the current user's password
 */
export const verifyPassword = (
	verifyPasswordBody: VerifyPasswordBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<VerifyPassword200>(
		{
			url: `/gw/stitch-web/api/auth/verify-password`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: verifyPasswordBody,
		},
		options,
	);
};

export const getVerifyPasswordMutationOptions = <
	TError = ErrorType<
		| VerifyPassword400
		| VerifyPassword401
		| VerifyPassword403
		| VerifyPassword404
		| VerifyPassword429
		| VerifyPassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof verifyPassword>>,
		TError,
		{ data: VerifyPasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof verifyPassword>>,
	TError,
	{ data: VerifyPasswordBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof verifyPassword>>,
		{ data: VerifyPasswordBody }
	> = (props) => {
		const { data } = props ?? {};

		return verifyPassword(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type VerifyPasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof verifyPassword>>
>;
export type VerifyPasswordMutationBody = VerifyPasswordBody;
export type VerifyPasswordMutationError = ErrorType<
	| VerifyPassword400
	| VerifyPassword401
	| VerifyPassword403
	| VerifyPassword404
	| VerifyPassword429
	| VerifyPassword500
>;

export const useVerifyPassword = <
	TError = ErrorType<
		| VerifyPassword400
		| VerifyPassword401
		| VerifyPassword403
		| VerifyPassword404
		| VerifyPassword429
		| VerifyPassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof verifyPassword>>,
		TError,
		{ data: VerifyPasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof verifyPassword>>,
	TError,
	{ data: VerifyPasswordBody },
	TContext
> => {
	const mutationOptions = getVerifyPasswordMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Verify the email of the user
 */
export const getGwStitchWebApiAuthVerifyEmail = (
	params: GetGwStitchWebApiAuthVerifyEmailParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthVerifyEmail200>(
		{
			url: `/gw/stitch-web/api/auth/verify-email`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthVerifyEmailQueryKey = (
	params: GetGwStitchWebApiAuthVerifyEmailParams,
) => {
	return [
		`/gw/stitch-web/api/auth/verify-email`,
		...(params ? [params] : []),
	] as const;
};

export const getGetGwStitchWebApiAuthVerifyEmailQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthVerifyEmail400
		| GetGwStitchWebApiAuthVerifyEmail401
		| GetGwStitchWebApiAuthVerifyEmail403
		| GetGwStitchWebApiAuthVerifyEmail404
		| GetGwStitchWebApiAuthVerifyEmail429
		| GetGwStitchWebApiAuthVerifyEmail500
	>,
>(
	params: GetGwStitchWebApiAuthVerifyEmailParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthVerifyEmailQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthVerifyEmail(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthVerifyEmailQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>
>;
export type GetGwStitchWebApiAuthVerifyEmailQueryError = ErrorType<
	| GetGwStitchWebApiAuthVerifyEmail400
	| GetGwStitchWebApiAuthVerifyEmail401
	| GetGwStitchWebApiAuthVerifyEmail403
	| GetGwStitchWebApiAuthVerifyEmail404
	| GetGwStitchWebApiAuthVerifyEmail429
	| GetGwStitchWebApiAuthVerifyEmail500
>;

export const useGetGwStitchWebApiAuthVerifyEmail = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthVerifyEmail400
		| GetGwStitchWebApiAuthVerifyEmail401
		| GetGwStitchWebApiAuthVerifyEmail403
		| GetGwStitchWebApiAuthVerifyEmail404
		| GetGwStitchWebApiAuthVerifyEmail429
		| GetGwStitchWebApiAuthVerifyEmail500
	>,
>(
	params: GetGwStitchWebApiAuthVerifyEmailParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebApiAuthVerifyEmail>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebApiAuthVerifyEmailQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Send a verification email to the user
 */
export const sendVerificationEmail = (
	sendVerificationEmailBody: SendVerificationEmailBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<SendVerificationEmail200>(
		{
			url: `/gw/stitch-web/api/auth/send-verification-email`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: sendVerificationEmailBody,
		},
		options,
	);
};

export const getSendVerificationEmailMutationOptions = <
	TError = ErrorType<
		| SendVerificationEmail400
		| SendVerificationEmail401
		| SendVerificationEmail403
		| SendVerificationEmail404
		| SendVerificationEmail429
		| SendVerificationEmail500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof sendVerificationEmail>>,
		TError,
		{ data: SendVerificationEmailBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof sendVerificationEmail>>,
	TError,
	{ data: SendVerificationEmailBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof sendVerificationEmail>>,
		{ data: SendVerificationEmailBody }
	> = (props) => {
		const { data } = props ?? {};

		return sendVerificationEmail(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SendVerificationEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof sendVerificationEmail>>
>;
export type SendVerificationEmailMutationBody = SendVerificationEmailBody;
export type SendVerificationEmailMutationError = ErrorType<
	| SendVerificationEmail400
	| SendVerificationEmail401
	| SendVerificationEmail403
	| SendVerificationEmail404
	| SendVerificationEmail429
	| SendVerificationEmail500
>;

export const useSendVerificationEmail = <
	TError = ErrorType<
		| SendVerificationEmail400
		| SendVerificationEmail401
		| SendVerificationEmail403
		| SendVerificationEmail404
		| SendVerificationEmail429
		| SendVerificationEmail500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof sendVerificationEmail>>,
		TError,
		{ data: SendVerificationEmailBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof sendVerificationEmail>>,
	TError,
	{ data: SendVerificationEmailBody },
	TContext
> => {
	const mutationOptions = getSendVerificationEmailMutationOptions(options);

	return useMutation(mutationOptions);
};

export const changeEmail = (
	changeEmailBody: ChangeEmailBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<ChangeEmail200>(
		{
			url: `/gw/stitch-web/api/auth/change-email`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: changeEmailBody,
		},
		options,
	);
};

export const getChangeEmailMutationOptions = <
	TError = ErrorType<
		| ChangeEmail400
		| ChangeEmail401
		| ChangeEmail403
		| ChangeEmail404
		| ChangeEmail429
		| ChangeEmail500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof changeEmail>>,
		TError,
		{ data: ChangeEmailBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof changeEmail>>,
	TError,
	{ data: ChangeEmailBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof changeEmail>>,
		{ data: ChangeEmailBody }
	> = (props) => {
		const { data } = props ?? {};

		return changeEmail(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ChangeEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof changeEmail>>
>;
export type ChangeEmailMutationBody = ChangeEmailBody;
export type ChangeEmailMutationError = ErrorType<
	| ChangeEmail400
	| ChangeEmail401
	| ChangeEmail403
	| ChangeEmail404
	| ChangeEmail429
	| ChangeEmail500
>;

export const useChangeEmail = <
	TError = ErrorType<
		| ChangeEmail400
		| ChangeEmail401
		| ChangeEmail403
		| ChangeEmail404
		| ChangeEmail429
		| ChangeEmail500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof changeEmail>>,
		TError,
		{ data: ChangeEmailBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof changeEmail>>,
	TError,
	{ data: ChangeEmailBody },
	TContext
> => {
	const mutationOptions = getChangeEmailMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Change the password of the user
 */
export const changePassword = (
	changePasswordBody: ChangePasswordBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<ChangePassword200>(
		{
			url: `/gw/stitch-web/api/auth/change-password`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: changePasswordBody,
		},
		options,
	);
};

export const getChangePasswordMutationOptions = <
	TError = ErrorType<
		| ChangePassword400
		| ChangePassword401
		| ChangePassword403
		| ChangePassword404
		| ChangePassword429
		| ChangePassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof changePassword>>,
		TError,
		{ data: ChangePasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof changePassword>>,
	TError,
	{ data: ChangePasswordBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof changePassword>>,
		{ data: ChangePasswordBody }
	> = (props) => {
		const { data } = props ?? {};

		return changePassword(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = ChangePasswordBody;
export type ChangePasswordMutationError = ErrorType<
	| ChangePassword400
	| ChangePassword401
	| ChangePassword403
	| ChangePassword404
	| ChangePassword429
	| ChangePassword500
>;

export const useChangePassword = <
	TError = ErrorType<
		| ChangePassword400
		| ChangePassword401
		| ChangePassword403
		| ChangePassword404
		| ChangePassword429
		| ChangePassword500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof changePassword>>,
		TError,
		{ data: ChangePasswordBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof changePassword>>,
	TError,
	{ data: ChangePasswordBody },
	TContext
> => {
	const mutationOptions = getChangePasswordMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Update the current session
 */
export const updateSession = (
	updateSessionBody: UpdateSessionBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UpdateSession200>(
		{
			url: `/gw/stitch-web/api/auth/update-session`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: updateSessionBody,
		},
		options,
	);
};

export const getUpdateSessionMutationOptions = <
	TError = ErrorType<
		| UpdateSession400
		| UpdateSession401
		| UpdateSession403
		| UpdateSession404
		| UpdateSession429
		| UpdateSession500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateSession>>,
		TError,
		{ data: UpdateSessionBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateSession>>,
	TError,
	{ data: UpdateSessionBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateSession>>,
		{ data: UpdateSessionBody }
	> = (props) => {
		const { data } = props ?? {};

		return updateSession(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateSessionMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateSession>>
>;
export type UpdateSessionMutationBody = UpdateSessionBody;
export type UpdateSessionMutationError = ErrorType<
	| UpdateSession400
	| UpdateSession401
	| UpdateSession403
	| UpdateSession404
	| UpdateSession429
	| UpdateSession500
>;

export const useUpdateSession = <
	TError = ErrorType<
		| UpdateSession400
		| UpdateSession401
		| UpdateSession403
		| UpdateSession404
		| UpdateSession429
		| UpdateSession500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateSession>>,
		TError,
		{ data: UpdateSessionBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateSession>>,
	TError,
	{ data: UpdateSessionBody },
	TContext
> => {
	const mutationOptions = getUpdateSessionMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Update the current user
 */
export const updateUser = (
	updateUserBody: UpdateUserBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UpdateUser200>(
		{
			url: `/gw/stitch-web/api/auth/update-user`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: updateUserBody,
		},
		options,
	);
};

export const getUpdateUserMutationOptions = <
	TError = ErrorType<
		| UpdateUser400
		| UpdateUser401
		| UpdateUser403
		| UpdateUser404
		| UpdateUser429
		| UpdateUser500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateUser>>,
		TError,
		{ data: UpdateUserBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateUser>>,
	TError,
	{ data: UpdateUserBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateUser>>,
		{ data: UpdateUserBody }
	> = (props) => {
		const { data } = props ?? {};

		return updateUser(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateUser>>
>;
export type UpdateUserMutationBody = UpdateUserBody;
export type UpdateUserMutationError = ErrorType<
	| UpdateUser400
	| UpdateUser401
	| UpdateUser403
	| UpdateUser404
	| UpdateUser429
	| UpdateUser500
>;

export const useUpdateUser = <
	TError = ErrorType<
		| UpdateUser400
		| UpdateUser401
		| UpdateUser403
		| UpdateUser404
		| UpdateUser429
		| UpdateUser500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateUser>>,
		TError,
		{ data: UpdateUserBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateUser>>,
	TError,
	{ data: UpdateUserBody },
	TContext
> => {
	const mutationOptions = getUpdateUserMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Delete the user
 */
export const deleteUser = (
	deleteUserBody: DeleteUserBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<DeleteUser200>(
		{
			url: `/gw/stitch-web/api/auth/delete-user`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: deleteUserBody,
		},
		options,
	);
};

export const getDeleteUserMutationOptions = <
	TError = ErrorType<
		| DeleteUser400
		| DeleteUser401
		| DeleteUser403
		| DeleteUser404
		| DeleteUser429
		| DeleteUser500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteUser>>,
		TError,
		{ data: DeleteUserBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteUser>>,
	TError,
	{ data: DeleteUserBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteUser>>,
		{ data: DeleteUserBody }
	> = (props) => {
		const { data } = props ?? {};

		return deleteUser(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteUser>>
>;
export type DeleteUserMutationBody = DeleteUserBody;
export type DeleteUserMutationError = ErrorType<
	| DeleteUser400
	| DeleteUser401
	| DeleteUser403
	| DeleteUser404
	| DeleteUser429
	| DeleteUser500
>;

export const useDeleteUser = <
	TError = ErrorType<
		| DeleteUser400
		| DeleteUser401
		| DeleteUser403
		| DeleteUser404
		| DeleteUser429
		| DeleteUser500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteUser>>,
		TError,
		{ data: DeleteUserBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof deleteUser>>,
	TError,
	{ data: DeleteUserBody },
	TContext
> => {
	const mutationOptions = getDeleteUserMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Send a password reset email to the user
 */
export const requestPasswordReset = (
	requestPasswordResetBody: RequestPasswordResetBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<RequestPasswordReset200>(
		{
			url: `/gw/stitch-web/api/auth/request-password-reset`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: requestPasswordResetBody,
		},
		options,
	);
};

export const getRequestPasswordResetMutationOptions = <
	TError = ErrorType<
		| RequestPasswordReset400
		| RequestPasswordReset401
		| RequestPasswordReset403
		| RequestPasswordReset404
		| RequestPasswordReset429
		| RequestPasswordReset500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestPasswordReset>>,
		TError,
		{ data: RequestPasswordResetBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof requestPasswordReset>>,
	TError,
	{ data: RequestPasswordResetBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof requestPasswordReset>>,
		{ data: RequestPasswordResetBody }
	> = (props) => {
		const { data } = props ?? {};

		return requestPasswordReset(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
	Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody = RequestPasswordResetBody;
export type RequestPasswordResetMutationError = ErrorType<
	| RequestPasswordReset400
	| RequestPasswordReset401
	| RequestPasswordReset403
	| RequestPasswordReset404
	| RequestPasswordReset429
	| RequestPasswordReset500
>;

export const useRequestPasswordReset = <
	TError = ErrorType<
		| RequestPasswordReset400
		| RequestPasswordReset401
		| RequestPasswordReset403
		| RequestPasswordReset404
		| RequestPasswordReset429
		| RequestPasswordReset500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof requestPasswordReset>>,
		TError,
		{ data: RequestPasswordResetBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof requestPasswordReset>>,
	TError,
	{ data: RequestPasswordResetBody },
	TContext
> => {
	const mutationOptions = getRequestPasswordResetMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Redirects the user to the callback URL with the token
 */
export const resetPasswordCallback = (
	token: string,
	params: ResetPasswordCallbackParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ResetPasswordCallback200>(
		{
			url: `/gw/stitch-web/api/auth/reset-password/${token}`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getResetPasswordCallbackQueryKey = (
	token: string,
	params: ResetPasswordCallbackParams,
) => {
	return [
		`/gw/stitch-web/api/auth/reset-password/${token}`,
		...(params ? [params] : []),
	] as const;
};

export const getResetPasswordCallbackQueryOptions = <
	TData = Awaited<ReturnType<typeof resetPasswordCallback>>,
	TError = ErrorType<
		| ResetPasswordCallback400
		| ResetPasswordCallback401
		| ResetPasswordCallback403
		| ResetPasswordCallback404
		| ResetPasswordCallback429
		| ResetPasswordCallback500
	>,
>(
	token: string,
	params: ResetPasswordCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof resetPasswordCallback>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getResetPasswordCallbackQueryKey(token, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof resetPasswordCallback>>
	> = ({ signal }) =>
		resetPasswordCallback(token, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!token,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof resetPasswordCallback>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ResetPasswordCallbackQueryResult = NonNullable<
	Awaited<ReturnType<typeof resetPasswordCallback>>
>;
export type ResetPasswordCallbackQueryError = ErrorType<
	| ResetPasswordCallback400
	| ResetPasswordCallback401
	| ResetPasswordCallback403
	| ResetPasswordCallback404
	| ResetPasswordCallback429
	| ResetPasswordCallback500
>;

export const useResetPasswordCallback = <
	TData = Awaited<ReturnType<typeof resetPasswordCallback>>,
	TError = ErrorType<
		| ResetPasswordCallback400
		| ResetPasswordCallback401
		| ResetPasswordCallback403
		| ResetPasswordCallback404
		| ResetPasswordCallback429
		| ResetPasswordCallback500
	>,
>(
	token: string,
	params: ResetPasswordCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof resetPasswordCallback>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getResetPasswordCallbackQueryOptions(
		token,
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * List all active sessions for the user
 */
export const listUserSessions = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Session[]>(
		{ url: `/gw/stitch-web/api/auth/list-sessions`, method: 'GET', signal },
		options,
	);
};

export const getListUserSessionsQueryKey = () => {
	return [`/gw/stitch-web/api/auth/list-sessions`] as const;
};

export const getListUserSessionsQueryOptions = <
	TData = Awaited<ReturnType<typeof listUserSessions>>,
	TError = ErrorType<
		| ListUserSessions400
		| ListUserSessions401
		| ListUserSessions403
		| ListUserSessions404
		| ListUserSessions429
		| ListUserSessions500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListUserSessionsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listUserSessions>>
	> = ({ signal }) => listUserSessions(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listUserSessions>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListUserSessionsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listUserSessions>>
>;
export type ListUserSessionsQueryError = ErrorType<
	| ListUserSessions400
	| ListUserSessions401
	| ListUserSessions403
	| ListUserSessions404
	| ListUserSessions429
	| ListUserSessions500
>;

export const useListUserSessions = <
	TData = Awaited<ReturnType<typeof listUserSessions>>,
	TError = ErrorType<
		| ListUserSessions400
		| ListUserSessions401
		| ListUserSessions403
		| ListUserSessions404
		| ListUserSessions429
		| ListUserSessions500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListUserSessionsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Revoke a single session
 */
export const postGwStitchWebApiAuthRevokeSession = (
	postGwStitchWebApiAuthRevokeSessionBody: PostGwStitchWebApiAuthRevokeSessionBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthRevokeSession200>(
		{
			url: `/gw/stitch-web/api/auth/revoke-session`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthRevokeSessionBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthRevokeSessionMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthRevokeSession400
		| PostGwStitchWebApiAuthRevokeSession401
		| PostGwStitchWebApiAuthRevokeSession403
		| PostGwStitchWebApiAuthRevokeSession404
		| PostGwStitchWebApiAuthRevokeSession429
		| PostGwStitchWebApiAuthRevokeSession500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSession>>,
		TError,
		{ data: PostGwStitchWebApiAuthRevokeSessionBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSession>>,
	TError,
	{ data: PostGwStitchWebApiAuthRevokeSessionBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSession>>,
		{ data: PostGwStitchWebApiAuthRevokeSessionBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthRevokeSession(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthRevokeSessionMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSession>>
>;
export type PostGwStitchWebApiAuthRevokeSessionMutationBody =
	PostGwStitchWebApiAuthRevokeSessionBody;
export type PostGwStitchWebApiAuthRevokeSessionMutationError = ErrorType<
	| PostGwStitchWebApiAuthRevokeSession400
	| PostGwStitchWebApiAuthRevokeSession401
	| PostGwStitchWebApiAuthRevokeSession403
	| PostGwStitchWebApiAuthRevokeSession404
	| PostGwStitchWebApiAuthRevokeSession429
	| PostGwStitchWebApiAuthRevokeSession500
>;

export const usePostGwStitchWebApiAuthRevokeSession = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthRevokeSession400
		| PostGwStitchWebApiAuthRevokeSession401
		| PostGwStitchWebApiAuthRevokeSession403
		| PostGwStitchWebApiAuthRevokeSession404
		| PostGwStitchWebApiAuthRevokeSession429
		| PostGwStitchWebApiAuthRevokeSession500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSession>>,
		TError,
		{ data: PostGwStitchWebApiAuthRevokeSessionBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSession>>,
	TError,
	{ data: PostGwStitchWebApiAuthRevokeSessionBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthRevokeSessionMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Revoke all sessions for the user
 */
export const postGwStitchWebApiAuthRevokeSessions = (
	postGwStitchWebApiAuthRevokeSessionsBody: PostGwStitchWebApiAuthRevokeSessionsBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthRevokeSessions200>(
		{
			url: `/gw/stitch-web/api/auth/revoke-sessions`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthRevokeSessionsBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthRevokeSessionsMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthRevokeSessions400
		| PostGwStitchWebApiAuthRevokeSessions401
		| PostGwStitchWebApiAuthRevokeSessions403
		| PostGwStitchWebApiAuthRevokeSessions404
		| PostGwStitchWebApiAuthRevokeSessions429
		| PostGwStitchWebApiAuthRevokeSessions500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSessions>>,
		TError,
		{ data: PostGwStitchWebApiAuthRevokeSessionsBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSessions>>,
	TError,
	{ data: PostGwStitchWebApiAuthRevokeSessionsBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSessions>>,
		{ data: PostGwStitchWebApiAuthRevokeSessionsBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthRevokeSessions(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthRevokeSessionsMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSessions>>
>;
export type PostGwStitchWebApiAuthRevokeSessionsMutationBody =
	PostGwStitchWebApiAuthRevokeSessionsBody;
export type PostGwStitchWebApiAuthRevokeSessionsMutationError = ErrorType<
	| PostGwStitchWebApiAuthRevokeSessions400
	| PostGwStitchWebApiAuthRevokeSessions401
	| PostGwStitchWebApiAuthRevokeSessions403
	| PostGwStitchWebApiAuthRevokeSessions404
	| PostGwStitchWebApiAuthRevokeSessions429
	| PostGwStitchWebApiAuthRevokeSessions500
>;

export const usePostGwStitchWebApiAuthRevokeSessions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthRevokeSessions400
		| PostGwStitchWebApiAuthRevokeSessions401
		| PostGwStitchWebApiAuthRevokeSessions403
		| PostGwStitchWebApiAuthRevokeSessions404
		| PostGwStitchWebApiAuthRevokeSessions429
		| PostGwStitchWebApiAuthRevokeSessions500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSessions>>,
		TError,
		{ data: PostGwStitchWebApiAuthRevokeSessionsBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeSessions>>,
	TError,
	{ data: PostGwStitchWebApiAuthRevokeSessionsBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthRevokeSessionsMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Revoke all other sessions for the user except the current one
 */
export const postGwStitchWebApiAuthRevokeOtherSessions = (
	postGwStitchWebApiAuthRevokeOtherSessionsBody: PostGwStitchWebApiAuthRevokeOtherSessionsBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthRevokeOtherSessions200>(
		{
			url: `/gw/stitch-web/api/auth/revoke-other-sessions`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthRevokeOtherSessionsBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthRevokeOtherSessionsMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthRevokeOtherSessions400
		| PostGwStitchWebApiAuthRevokeOtherSessions401
		| PostGwStitchWebApiAuthRevokeOtherSessions403
		| PostGwStitchWebApiAuthRevokeOtherSessions404
		| PostGwStitchWebApiAuthRevokeOtherSessions429
		| PostGwStitchWebApiAuthRevokeOtherSessions500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeOtherSessions>>,
		TError,
		{ data: PostGwStitchWebApiAuthRevokeOtherSessionsBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeOtherSessions>>,
	TError,
	{ data: PostGwStitchWebApiAuthRevokeOtherSessionsBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeOtherSessions>>,
		{ data: PostGwStitchWebApiAuthRevokeOtherSessionsBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthRevokeOtherSessions(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthRevokeOtherSessionsMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeOtherSessions>>
	>;
export type PostGwStitchWebApiAuthRevokeOtherSessionsMutationBody =
	PostGwStitchWebApiAuthRevokeOtherSessionsBody;
export type PostGwStitchWebApiAuthRevokeOtherSessionsMutationError = ErrorType<
	| PostGwStitchWebApiAuthRevokeOtherSessions400
	| PostGwStitchWebApiAuthRevokeOtherSessions401
	| PostGwStitchWebApiAuthRevokeOtherSessions403
	| PostGwStitchWebApiAuthRevokeOtherSessions404
	| PostGwStitchWebApiAuthRevokeOtherSessions429
	| PostGwStitchWebApiAuthRevokeOtherSessions500
>;

export const usePostGwStitchWebApiAuthRevokeOtherSessions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthRevokeOtherSessions400
		| PostGwStitchWebApiAuthRevokeOtherSessions401
		| PostGwStitchWebApiAuthRevokeOtherSessions403
		| PostGwStitchWebApiAuthRevokeOtherSessions404
		| PostGwStitchWebApiAuthRevokeOtherSessions429
		| PostGwStitchWebApiAuthRevokeOtherSessions500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeOtherSessions>>,
		TError,
		{ data: PostGwStitchWebApiAuthRevokeOtherSessionsBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRevokeOtherSessions>>,
	TError,
	{ data: PostGwStitchWebApiAuthRevokeOtherSessionsBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthRevokeOtherSessionsMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Link a social account to the user
 */
export const linkSocialAccount = (
	linkSocialAccountBody: LinkSocialAccountBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<LinkSocialAccount200>(
		{
			url: `/gw/stitch-web/api/auth/link-social`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: linkSocialAccountBody,
		},
		options,
	);
};

export const getLinkSocialAccountMutationOptions = <
	TError = ErrorType<
		| LinkSocialAccount400
		| LinkSocialAccount401
		| LinkSocialAccount403
		| LinkSocialAccount404
		| LinkSocialAccount429
		| LinkSocialAccount500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof linkSocialAccount>>,
		TError,
		{ data: LinkSocialAccountBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof linkSocialAccount>>,
	TError,
	{ data: LinkSocialAccountBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof linkSocialAccount>>,
		{ data: LinkSocialAccountBody }
	> = (props) => {
		const { data } = props ?? {};

		return linkSocialAccount(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type LinkSocialAccountMutationResult = NonNullable<
	Awaited<ReturnType<typeof linkSocialAccount>>
>;
export type LinkSocialAccountMutationBody = LinkSocialAccountBody;
export type LinkSocialAccountMutationError = ErrorType<
	| LinkSocialAccount400
	| LinkSocialAccount401
	| LinkSocialAccount403
	| LinkSocialAccount404
	| LinkSocialAccount429
	| LinkSocialAccount500
>;

export const useLinkSocialAccount = <
	TError = ErrorType<
		| LinkSocialAccount400
		| LinkSocialAccount401
		| LinkSocialAccount403
		| LinkSocialAccount404
		| LinkSocialAccount429
		| LinkSocialAccount500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof linkSocialAccount>>,
		TError,
		{ data: LinkSocialAccountBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof linkSocialAccount>>,
	TError,
	{ data: LinkSocialAccountBody },
	TContext
> => {
	const mutationOptions = getLinkSocialAccountMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * List all accounts linked to the user
 */
export const listUserAccounts = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ListUserAccounts200Item[]>(
		{ url: `/gw/stitch-web/api/auth/list-accounts`, method: 'GET', signal },
		options,
	);
};

export const getListUserAccountsQueryKey = () => {
	return [`/gw/stitch-web/api/auth/list-accounts`] as const;
};

export const getListUserAccountsQueryOptions = <
	TData = Awaited<ReturnType<typeof listUserAccounts>>,
	TError = ErrorType<
		| ListUserAccounts400
		| ListUserAccounts401
		| ListUserAccounts403
		| ListUserAccounts404
		| ListUserAccounts429
		| ListUserAccounts500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listUserAccounts>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListUserAccountsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listUserAccounts>>
	> = ({ signal }) => listUserAccounts(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listUserAccounts>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ListUserAccountsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listUserAccounts>>
>;
export type ListUserAccountsQueryError = ErrorType<
	| ListUserAccounts400
	| ListUserAccounts401
	| ListUserAccounts403
	| ListUserAccounts404
	| ListUserAccounts429
	| ListUserAccounts500
>;

export const useListUserAccounts = <
	TData = Awaited<ReturnType<typeof listUserAccounts>>,
	TError = ErrorType<
		| ListUserAccounts400
		| ListUserAccounts401
		| ListUserAccounts403
		| ListUserAccounts404
		| ListUserAccounts429
		| ListUserAccounts500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listUserAccounts>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getListUserAccountsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Callback to complete user deletion with verification token
 */
export const getGwStitchWebApiAuthDeleteUserCallback = (
	params?: GetGwStitchWebApiAuthDeleteUserCallbackParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthDeleteUserCallback200>(
		{
			url: `/gw/stitch-web/api/auth/delete-user/callback`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthDeleteUserCallbackQueryKey = (
	params?: GetGwStitchWebApiAuthDeleteUserCallbackParams,
) => {
	return [
		`/gw/stitch-web/api/auth/delete-user/callback`,
		...(params ? [params] : []),
	] as const;
};

export const getGetGwStitchWebApiAuthDeleteUserCallbackQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthDeleteUserCallback400
		| GetGwStitchWebApiAuthDeleteUserCallback401
		| GetGwStitchWebApiAuthDeleteUserCallback403
		| GetGwStitchWebApiAuthDeleteUserCallback404
		| GetGwStitchWebApiAuthDeleteUserCallback429
		| GetGwStitchWebApiAuthDeleteUserCallback500
	>,
>(
	params?: GetGwStitchWebApiAuthDeleteUserCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthDeleteUserCallbackQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthDeleteUserCallback(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthDeleteUserCallbackQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>
>;
export type GetGwStitchWebApiAuthDeleteUserCallbackQueryError = ErrorType<
	| GetGwStitchWebApiAuthDeleteUserCallback400
	| GetGwStitchWebApiAuthDeleteUserCallback401
	| GetGwStitchWebApiAuthDeleteUserCallback403
	| GetGwStitchWebApiAuthDeleteUserCallback404
	| GetGwStitchWebApiAuthDeleteUserCallback429
	| GetGwStitchWebApiAuthDeleteUserCallback500
>;

export const useGetGwStitchWebApiAuthDeleteUserCallback = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthDeleteUserCallback400
		| GetGwStitchWebApiAuthDeleteUserCallback401
		| GetGwStitchWebApiAuthDeleteUserCallback403
		| GetGwStitchWebApiAuthDeleteUserCallback404
		| GetGwStitchWebApiAuthDeleteUserCallback429
		| GetGwStitchWebApiAuthDeleteUserCallback500
	>,
>(
	params?: GetGwStitchWebApiAuthDeleteUserCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getGwStitchWebApiAuthDeleteUserCallback>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebApiAuthDeleteUserCallbackQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Unlink an account
 */
export const postGwStitchWebApiAuthUnlinkAccount = (
	postGwStitchWebApiAuthUnlinkAccountBody: PostGwStitchWebApiAuthUnlinkAccountBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthUnlinkAccount200>(
		{
			url: `/gw/stitch-web/api/auth/unlink-account`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthUnlinkAccountBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthUnlinkAccountMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthUnlinkAccount400
		| PostGwStitchWebApiAuthUnlinkAccount401
		| PostGwStitchWebApiAuthUnlinkAccount403
		| PostGwStitchWebApiAuthUnlinkAccount404
		| PostGwStitchWebApiAuthUnlinkAccount429
		| PostGwStitchWebApiAuthUnlinkAccount500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthUnlinkAccount>>,
		TError,
		{ data: PostGwStitchWebApiAuthUnlinkAccountBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthUnlinkAccount>>,
	TError,
	{ data: PostGwStitchWebApiAuthUnlinkAccountBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthUnlinkAccount>>,
		{ data: PostGwStitchWebApiAuthUnlinkAccountBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthUnlinkAccount(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthUnlinkAccountMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthUnlinkAccount>>
>;
export type PostGwStitchWebApiAuthUnlinkAccountMutationBody =
	PostGwStitchWebApiAuthUnlinkAccountBody;
export type PostGwStitchWebApiAuthUnlinkAccountMutationError = ErrorType<
	| PostGwStitchWebApiAuthUnlinkAccount400
	| PostGwStitchWebApiAuthUnlinkAccount401
	| PostGwStitchWebApiAuthUnlinkAccount403
	| PostGwStitchWebApiAuthUnlinkAccount404
	| PostGwStitchWebApiAuthUnlinkAccount429
	| PostGwStitchWebApiAuthUnlinkAccount500
>;

export const usePostGwStitchWebApiAuthUnlinkAccount = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthUnlinkAccount400
		| PostGwStitchWebApiAuthUnlinkAccount401
		| PostGwStitchWebApiAuthUnlinkAccount403
		| PostGwStitchWebApiAuthUnlinkAccount404
		| PostGwStitchWebApiAuthUnlinkAccount429
		| PostGwStitchWebApiAuthUnlinkAccount500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthUnlinkAccount>>,
		TError,
		{ data: PostGwStitchWebApiAuthUnlinkAccountBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthUnlinkAccount>>,
	TError,
	{ data: PostGwStitchWebApiAuthUnlinkAccountBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthUnlinkAccountMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Refresh the access token using a refresh token
 */
export const postGwStitchWebApiAuthRefreshToken = (
	postGwStitchWebApiAuthRefreshTokenBody: PostGwStitchWebApiAuthRefreshTokenBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthRefreshToken200>(
		{
			url: `/gw/stitch-web/api/auth/refresh-token`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthRefreshTokenBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthRefreshTokenMutationOptions = <
	TError = ErrorType<
		| void
		| PostGwStitchWebApiAuthRefreshToken401
		| PostGwStitchWebApiAuthRefreshToken403
		| PostGwStitchWebApiAuthRefreshToken404
		| PostGwStitchWebApiAuthRefreshToken429
		| PostGwStitchWebApiAuthRefreshToken500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRefreshToken>>,
		TError,
		{ data: PostGwStitchWebApiAuthRefreshTokenBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRefreshToken>>,
	TError,
	{ data: PostGwStitchWebApiAuthRefreshTokenBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRefreshToken>>,
		{ data: PostGwStitchWebApiAuthRefreshTokenBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthRefreshToken(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthRefreshTokenMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRefreshToken>>
>;
export type PostGwStitchWebApiAuthRefreshTokenMutationBody =
	PostGwStitchWebApiAuthRefreshTokenBody;
export type PostGwStitchWebApiAuthRefreshTokenMutationError = ErrorType<
	| void
	| PostGwStitchWebApiAuthRefreshToken401
	| PostGwStitchWebApiAuthRefreshToken403
	| PostGwStitchWebApiAuthRefreshToken404
	| PostGwStitchWebApiAuthRefreshToken429
	| PostGwStitchWebApiAuthRefreshToken500
>;

export const usePostGwStitchWebApiAuthRefreshToken = <
	TError = ErrorType<
		| void
		| PostGwStitchWebApiAuthRefreshToken401
		| PostGwStitchWebApiAuthRefreshToken403
		| PostGwStitchWebApiAuthRefreshToken404
		| PostGwStitchWebApiAuthRefreshToken429
		| PostGwStitchWebApiAuthRefreshToken500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthRefreshToken>>,
		TError,
		{ data: PostGwStitchWebApiAuthRefreshTokenBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthRefreshToken>>,
	TError,
	{ data: PostGwStitchWebApiAuthRefreshTokenBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthRefreshTokenMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Get a valid access token, doing a refresh if needed
 */
export const postGwStitchWebApiAuthGetAccessToken = (
	postGwStitchWebApiAuthGetAccessTokenBody: PostGwStitchWebApiAuthGetAccessTokenBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthGetAccessToken200>(
		{
			url: `/gw/stitch-web/api/auth/get-access-token`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthGetAccessTokenBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthGetAccessTokenMutationOptions = <
	TError = ErrorType<
		| void
		| PostGwStitchWebApiAuthGetAccessToken401
		| PostGwStitchWebApiAuthGetAccessToken403
		| PostGwStitchWebApiAuthGetAccessToken404
		| PostGwStitchWebApiAuthGetAccessToken429
		| PostGwStitchWebApiAuthGetAccessToken500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthGetAccessToken>>,
		TError,
		{ data: PostGwStitchWebApiAuthGetAccessTokenBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthGetAccessToken>>,
	TError,
	{ data: PostGwStitchWebApiAuthGetAccessTokenBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthGetAccessToken>>,
		{ data: PostGwStitchWebApiAuthGetAccessTokenBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthGetAccessToken(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthGetAccessTokenMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthGetAccessToken>>
>;
export type PostGwStitchWebApiAuthGetAccessTokenMutationBody =
	PostGwStitchWebApiAuthGetAccessTokenBody;
export type PostGwStitchWebApiAuthGetAccessTokenMutationError = ErrorType<
	| void
	| PostGwStitchWebApiAuthGetAccessToken401
	| PostGwStitchWebApiAuthGetAccessToken403
	| PostGwStitchWebApiAuthGetAccessToken404
	| PostGwStitchWebApiAuthGetAccessToken429
	| PostGwStitchWebApiAuthGetAccessToken500
>;

export const usePostGwStitchWebApiAuthGetAccessToken = <
	TError = ErrorType<
		| void
		| PostGwStitchWebApiAuthGetAccessToken401
		| PostGwStitchWebApiAuthGetAccessToken403
		| PostGwStitchWebApiAuthGetAccessToken404
		| PostGwStitchWebApiAuthGetAccessToken429
		| PostGwStitchWebApiAuthGetAccessToken500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthGetAccessToken>>,
		TError,
		{ data: PostGwStitchWebApiAuthGetAccessTokenBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthGetAccessToken>>,
	TError,
	{ data: PostGwStitchWebApiAuthGetAccessTokenBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthGetAccessTokenMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Get the account info provided by the provider
 */
export const getGwStitchWebApiAuthAccountInfo = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthAccountInfo200>(
		{ url: `/gw/stitch-web/api/auth/account-info`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebApiAuthAccountInfoQueryKey = () => {
	return [`/gw/stitch-web/api/auth/account-info`] as const;
};

export const getGetGwStitchWebApiAuthAccountInfoQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthAccountInfo400
		| GetGwStitchWebApiAuthAccountInfo401
		| GetGwStitchWebApiAuthAccountInfo403
		| GetGwStitchWebApiAuthAccountInfo404
		| GetGwStitchWebApiAuthAccountInfo429
		| GetGwStitchWebApiAuthAccountInfo500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwStitchWebApiAuthAccountInfoQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>
	> = ({ signal }) => getGwStitchWebApiAuthAccountInfo(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthAccountInfoQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>
>;
export type GetGwStitchWebApiAuthAccountInfoQueryError = ErrorType<
	| GetGwStitchWebApiAuthAccountInfo400
	| GetGwStitchWebApiAuthAccountInfo401
	| GetGwStitchWebApiAuthAccountInfo403
	| GetGwStitchWebApiAuthAccountInfo404
	| GetGwStitchWebApiAuthAccountInfo429
	| GetGwStitchWebApiAuthAccountInfo500
>;

export const useGetGwStitchWebApiAuthAccountInfo = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthAccountInfo400
		| GetGwStitchWebApiAuthAccountInfo401
		| GetGwStitchWebApiAuthAccountInfo403
		| GetGwStitchWebApiAuthAccountInfo404
		| GetGwStitchWebApiAuthAccountInfo429
		| GetGwStitchWebApiAuthAccountInfo500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthAccountInfo>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebApiAuthAccountInfoQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Check if the API is working
 */
export const getGwStitchWebApiAuthOk = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthOk200>(
		{ url: `/gw/stitch-web/api/auth/ok`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebApiAuthOkQueryKey = () => {
	return [`/gw/stitch-web/api/auth/ok`] as const;
};

export const getGetGwStitchWebApiAuthOkQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOk400
		| GetGwStitchWebApiAuthOk401
		| GetGwStitchWebApiAuthOk403
		| GetGwStitchWebApiAuthOk404
		| GetGwStitchWebApiAuthOk429
		| GetGwStitchWebApiAuthOk500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwStitchWebApiAuthOkQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>
	> = ({ signal }) => getGwStitchWebApiAuthOk(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOkQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>
>;
export type GetGwStitchWebApiAuthOkQueryError = ErrorType<
	| GetGwStitchWebApiAuthOk400
	| GetGwStitchWebApiAuthOk401
	| GetGwStitchWebApiAuthOk403
	| GetGwStitchWebApiAuthOk404
	| GetGwStitchWebApiAuthOk429
	| GetGwStitchWebApiAuthOk500
>;

export const useGetGwStitchWebApiAuthOk = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOk400
		| GetGwStitchWebApiAuthOk401
		| GetGwStitchWebApiAuthOk403
		| GetGwStitchWebApiAuthOk404
		| GetGwStitchWebApiAuthOk429
		| GetGwStitchWebApiAuthOk500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthOk>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebApiAuthOkQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Displays an error page
 */
export const getGwStitchWebApiAuthError = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/api/auth/error`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebApiAuthErrorQueryKey = () => {
	return [`/gw/stitch-web/api/auth/error`] as const;
};

export const getGetGwStitchWebApiAuthErrorQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthError400
		| GetGwStitchWebApiAuthError401
		| GetGwStitchWebApiAuthError403
		| GetGwStitchWebApiAuthError404
		| GetGwStitchWebApiAuthError429
		| GetGwStitchWebApiAuthError500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwStitchWebApiAuthErrorQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>
	> = ({ signal }) => getGwStitchWebApiAuthError(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthErrorQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>
>;
export type GetGwStitchWebApiAuthErrorQueryError = ErrorType<
	| GetGwStitchWebApiAuthError400
	| GetGwStitchWebApiAuthError401
	| GetGwStitchWebApiAuthError403
	| GetGwStitchWebApiAuthError404
	| GetGwStitchWebApiAuthError429
	| GetGwStitchWebApiAuthError500
>;

export const useGetGwStitchWebApiAuthError = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthError400
		| GetGwStitchWebApiAuthError401
		| GetGwStitchWebApiAuthError403
		| GetGwStitchWebApiAuthError404
		| GetGwStitchWebApiAuthError429
		| GetGwStitchWebApiAuthError500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthError>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwStitchWebApiAuthErrorQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Sign in with OAuth2
 */
export const postGwStitchWebApiAuthSignInOauth2 = (
	postGwStitchWebApiAuthSignInOauth2Body: PostGwStitchWebApiAuthSignInOauth2Body,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthSignInOauth2200>(
		{
			url: `/gw/stitch-web/api/auth/sign-in/oauth2`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthSignInOauth2Body,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthSignInOauth2MutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthSignInOauth2400
		| PostGwStitchWebApiAuthSignInOauth2401
		| PostGwStitchWebApiAuthSignInOauth2403
		| PostGwStitchWebApiAuthSignInOauth2404
		| PostGwStitchWebApiAuthSignInOauth2429
		| PostGwStitchWebApiAuthSignInOauth2500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignInOauth2>>,
		TError,
		{ data: PostGwStitchWebApiAuthSignInOauth2Body },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignInOauth2>>,
	TError,
	{ data: PostGwStitchWebApiAuthSignInOauth2Body },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignInOauth2>>,
		{ data: PostGwStitchWebApiAuthSignInOauth2Body }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthSignInOauth2(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthSignInOauth2MutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignInOauth2>>
>;
export type PostGwStitchWebApiAuthSignInOauth2MutationBody =
	PostGwStitchWebApiAuthSignInOauth2Body;
export type PostGwStitchWebApiAuthSignInOauth2MutationError = ErrorType<
	| PostGwStitchWebApiAuthSignInOauth2400
	| PostGwStitchWebApiAuthSignInOauth2401
	| PostGwStitchWebApiAuthSignInOauth2403
	| PostGwStitchWebApiAuthSignInOauth2404
	| PostGwStitchWebApiAuthSignInOauth2429
	| PostGwStitchWebApiAuthSignInOauth2500
>;

export const usePostGwStitchWebApiAuthSignInOauth2 = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthSignInOauth2400
		| PostGwStitchWebApiAuthSignInOauth2401
		| PostGwStitchWebApiAuthSignInOauth2403
		| PostGwStitchWebApiAuthSignInOauth2404
		| PostGwStitchWebApiAuthSignInOauth2429
		| PostGwStitchWebApiAuthSignInOauth2500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignInOauth2>>,
		TError,
		{ data: PostGwStitchWebApiAuthSignInOauth2Body },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignInOauth2>>,
	TError,
	{ data: PostGwStitchWebApiAuthSignInOauth2Body },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthSignInOauth2MutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * OAuth2 callback
 */
export const getGwStitchWebApiAuthOauth2CallbackProviderId = (
	providerId: string,
	params?: GetGwStitchWebApiAuthOauth2CallbackProviderIdParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthOauth2CallbackProviderId200>(
		{
			url: `/gw/stitch-web/api/auth/oauth2/callback/${providerId}`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOauth2CallbackProviderIdQueryKey = (
	providerId: string,
	params?: GetGwStitchWebApiAuthOauth2CallbackProviderIdParams,
) => {
	return [
		`/gw/stitch-web/api/auth/oauth2/callback/${providerId}`,
		...(params ? [params] : []),
	] as const;
};

export const getGetGwStitchWebApiAuthOauth2CallbackProviderIdQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOauth2CallbackProviderId400
		| GetGwStitchWebApiAuthOauth2CallbackProviderId401
		| GetGwStitchWebApiAuthOauth2CallbackProviderId403
		| GetGwStitchWebApiAuthOauth2CallbackProviderId404
		| GetGwStitchWebApiAuthOauth2CallbackProviderId429
		| GetGwStitchWebApiAuthOauth2CallbackProviderId500
	>,
>(
	providerId: string,
	params?: GetGwStitchWebApiAuthOauth2CallbackProviderIdParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthOauth2CallbackProviderIdQueryKey(
			providerId,
			params,
		);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthOauth2CallbackProviderId(
			providerId,
			params,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: !!providerId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOauth2CallbackProviderIdQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>>
	>;
export type GetGwStitchWebApiAuthOauth2CallbackProviderIdQueryError = ErrorType<
	| GetGwStitchWebApiAuthOauth2CallbackProviderId400
	| GetGwStitchWebApiAuthOauth2CallbackProviderId401
	| GetGwStitchWebApiAuthOauth2CallbackProviderId403
	| GetGwStitchWebApiAuthOauth2CallbackProviderId404
	| GetGwStitchWebApiAuthOauth2CallbackProviderId429
	| GetGwStitchWebApiAuthOauth2CallbackProviderId500
>;

export const useGetGwStitchWebApiAuthOauth2CallbackProviderId = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOauth2CallbackProviderId400
		| GetGwStitchWebApiAuthOauth2CallbackProviderId401
		| GetGwStitchWebApiAuthOauth2CallbackProviderId403
		| GetGwStitchWebApiAuthOauth2CallbackProviderId404
		| GetGwStitchWebApiAuthOauth2CallbackProviderId429
		| GetGwStitchWebApiAuthOauth2CallbackProviderId500
	>,
>(
	providerId: string,
	params?: GetGwStitchWebApiAuthOauth2CallbackProviderIdParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getGwStitchWebApiAuthOauth2CallbackProviderId>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOauth2CallbackProviderIdQueryOptions(
			providerId,
			params,
			options,
		);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Link an OAuth2 account to the current user session
 */
export const postGwStitchWebApiAuthOauth2Link = (
	postGwStitchWebApiAuthOauth2LinkBody: PostGwStitchWebApiAuthOauth2LinkBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthOauth2Link200>(
		{
			url: `/gw/stitch-web/api/auth/oauth2/link`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOauth2LinkBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOauth2LinkMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOauth2Link400
		| PostGwStitchWebApiAuthOauth2Link401
		| PostGwStitchWebApiAuthOauth2Link403
		| PostGwStitchWebApiAuthOauth2Link404
		| PostGwStitchWebApiAuthOauth2Link429
		| PostGwStitchWebApiAuthOauth2Link500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOauth2Link>>,
		TError,
		{ data: PostGwStitchWebApiAuthOauth2LinkBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOauth2Link>>,
	TError,
	{ data: PostGwStitchWebApiAuthOauth2LinkBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOauth2Link>>,
		{ data: PostGwStitchWebApiAuthOauth2LinkBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthOauth2Link(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthOauth2LinkMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOauth2Link>>
>;
export type PostGwStitchWebApiAuthOauth2LinkMutationBody =
	PostGwStitchWebApiAuthOauth2LinkBody;
export type PostGwStitchWebApiAuthOauth2LinkMutationError = ErrorType<
	| PostGwStitchWebApiAuthOauth2Link400
	| PostGwStitchWebApiAuthOauth2Link401
	| PostGwStitchWebApiAuthOauth2Link403
	| PostGwStitchWebApiAuthOauth2Link404
	| PostGwStitchWebApiAuthOauth2Link429
	| PostGwStitchWebApiAuthOauth2Link500
>;

export const usePostGwStitchWebApiAuthOauth2Link = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOauth2Link400
		| PostGwStitchWebApiAuthOauth2Link401
		| PostGwStitchWebApiAuthOauth2Link403
		| PostGwStitchWebApiAuthOauth2Link404
		| PostGwStitchWebApiAuthOauth2Link429
		| PostGwStitchWebApiAuthOauth2Link500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOauth2Link>>,
		TError,
		{ data: PostGwStitchWebApiAuthOauth2LinkBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOauth2Link>>,
	TError,
	{ data: PostGwStitchWebApiAuthOauth2LinkBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOauth2LinkMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Start the mobile Okta SSO handoff. Must be opened directly in the system browser (not fetched from the app's WebView) so the OAuth state cookie lands in the same cookie jar the callback arrives in.
 */
export const getGwStitchWebApiAuthMobileOauthHandoffStart = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/mobile-oauth-handoff/start`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthMobileOauthHandoffStartQueryKey = () => {
	return [`/gw/stitch-web/api/auth/mobile-oauth-handoff/start`] as const;
};

export const getGetGwStitchWebApiAuthMobileOauthHandoffStartQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>
	>,
	TError = ErrorType<
		| void
		| GetGwStitchWebApiAuthMobileOauthHandoffStart400
		| GetGwStitchWebApiAuthMobileOauthHandoffStart401
		| GetGwStitchWebApiAuthMobileOauthHandoffStart403
		| GetGwStitchWebApiAuthMobileOauthHandoffStart404
		| GetGwStitchWebApiAuthMobileOauthHandoffStart429
		| GetGwStitchWebApiAuthMobileOauthHandoffStart500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthMobileOauthHandoffStartQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthMobileOauthHandoffStart(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthMobileOauthHandoffStartQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>>
	>;
export type GetGwStitchWebApiAuthMobileOauthHandoffStartQueryError = ErrorType<
	| void
	| GetGwStitchWebApiAuthMobileOauthHandoffStart400
	| GetGwStitchWebApiAuthMobileOauthHandoffStart401
	| GetGwStitchWebApiAuthMobileOauthHandoffStart403
	| GetGwStitchWebApiAuthMobileOauthHandoffStart404
	| GetGwStitchWebApiAuthMobileOauthHandoffStart429
	| GetGwStitchWebApiAuthMobileOauthHandoffStart500
>;

export const useGetGwStitchWebApiAuthMobileOauthHandoffStart = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>
	>,
	TError = ErrorType<
		| void
		| GetGwStitchWebApiAuthMobileOauthHandoffStart400
		| GetGwStitchWebApiAuthMobileOauthHandoffStart401
		| GetGwStitchWebApiAuthMobileOauthHandoffStart403
		| GetGwStitchWebApiAuthMobileOauthHandoffStart404
		| GetGwStitchWebApiAuthMobileOauthHandoffStart429
		| GetGwStitchWebApiAuthMobileOauthHandoffStart500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthMobileOauthHandoffStart>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthMobileOauthHandoffStartQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Exchange a one-time mobile OAuth handoff code for the bearer token issued by the preceding Okta login.
 */
export const postGwStitchWebApiAuthMobileOauthHandoffExchange = (
	postGwStitchWebApiAuthMobileOauthHandoffExchangeBody: PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthMobileOauthHandoffExchange200>(
		{
			url: `/gw/stitch-web/api/auth/mobile-oauth-handoff/exchange`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthMobileOauthHandoffExchangeBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthMobileOauthHandoffExchangeMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthMobileOauthHandoffExchange400
			| PostGwStitchWebApiAuthMobileOauthHandoffExchange401
			| PostGwStitchWebApiAuthMobileOauthHandoffExchange403
			| PostGwStitchWebApiAuthMobileOauthHandoffExchange404
			| PostGwStitchWebApiAuthMobileOauthHandoffExchange429
			| PostGwStitchWebApiAuthMobileOauthHandoffExchange500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthMobileOauthHandoffExchange>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthMobileOauthHandoffExchange>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthMobileOauthHandoffExchange>
			>,
			{ data: PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthMobileOauthHandoffExchange(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthMobileOauthHandoffExchangeMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthMobileOauthHandoffExchange>>
	>;
export type PostGwStitchWebApiAuthMobileOauthHandoffExchangeMutationBody =
	PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody;
export type PostGwStitchWebApiAuthMobileOauthHandoffExchangeMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange400
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange401
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange403
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange404
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange429
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange500
	>;

export const usePostGwStitchWebApiAuthMobileOauthHandoffExchange = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange400
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange401
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange403
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange404
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange429
		| PostGwStitchWebApiAuthMobileOauthHandoffExchange500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthMobileOauthHandoffExchange>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthMobileOauthHandoffExchange>>,
	TError,
	{ data: PostGwStitchWebApiAuthMobileOauthHandoffExchangeBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthMobileOauthHandoffExchangeMutationOptions(options);

	return useMutation(mutationOptions);
};

export const postGwStitchWebApiAuthExchangeElationJwt = (
	postGwStitchWebApiAuthExchangeElationJwtBody: PostGwStitchWebApiAuthExchangeElationJwtBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthExchangeElationJwt200>(
		{
			url: `/gw/stitch-web/api/auth/exchange/elation/jwt`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthExchangeElationJwtBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthExchangeElationJwtMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthExchangeElationJwt400
		| PostGwStitchWebApiAuthExchangeElationJwt401
		| PostGwStitchWebApiAuthExchangeElationJwt403
		| PostGwStitchWebApiAuthExchangeElationJwt404
		| PostGwStitchWebApiAuthExchangeElationJwt429
		| PostGwStitchWebApiAuthExchangeElationJwt500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthExchangeElationJwt>>,
		TError,
		{ data: PostGwStitchWebApiAuthExchangeElationJwtBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthExchangeElationJwt>>,
	TError,
	{ data: PostGwStitchWebApiAuthExchangeElationJwtBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthExchangeElationJwt>>,
		{ data: PostGwStitchWebApiAuthExchangeElationJwtBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthExchangeElationJwt(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthExchangeElationJwtMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthExchangeElationJwt>>
	>;
export type PostGwStitchWebApiAuthExchangeElationJwtMutationBody =
	PostGwStitchWebApiAuthExchangeElationJwtBody;
export type PostGwStitchWebApiAuthExchangeElationJwtMutationError = ErrorType<
	| PostGwStitchWebApiAuthExchangeElationJwt400
	| PostGwStitchWebApiAuthExchangeElationJwt401
	| PostGwStitchWebApiAuthExchangeElationJwt403
	| PostGwStitchWebApiAuthExchangeElationJwt404
	| PostGwStitchWebApiAuthExchangeElationJwt429
	| PostGwStitchWebApiAuthExchangeElationJwt500
>;

export const usePostGwStitchWebApiAuthExchangeElationJwt = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthExchangeElationJwt400
		| PostGwStitchWebApiAuthExchangeElationJwt401
		| PostGwStitchWebApiAuthExchangeElationJwt403
		| PostGwStitchWebApiAuthExchangeElationJwt404
		| PostGwStitchWebApiAuthExchangeElationJwt429
		| PostGwStitchWebApiAuthExchangeElationJwt500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthExchangeElationJwt>>,
		TError,
		{ data: PostGwStitchWebApiAuthExchangeElationJwtBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthExchangeElationJwt>>,
	TError,
	{ data: PostGwStitchWebApiAuthExchangeElationJwtBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthExchangeElationJwtMutationOptions(options);

	return useMutation(mutationOptions);
};

export const postGwStitchWebApiAuthSignUpStitch = (
	postGwStitchWebApiAuthSignUpStitchBody: PostGwStitchWebApiAuthSignUpStitchBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/sign-up/stitch`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthSignUpStitchBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthSignUpStitchMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthSignUpStitch400
		| PostGwStitchWebApiAuthSignUpStitch401
		| PostGwStitchWebApiAuthSignUpStitch403
		| PostGwStitchWebApiAuthSignUpStitch404
		| PostGwStitchWebApiAuthSignUpStitch429
		| PostGwStitchWebApiAuthSignUpStitch500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitch>>,
		TError,
		{ data: PostGwStitchWebApiAuthSignUpStitchBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitch>>,
	TError,
	{ data: PostGwStitchWebApiAuthSignUpStitchBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitch>>,
		{ data: PostGwStitchWebApiAuthSignUpStitchBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthSignUpStitch(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthSignUpStitchMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitch>>
>;
export type PostGwStitchWebApiAuthSignUpStitchMutationBody =
	PostGwStitchWebApiAuthSignUpStitchBody;
export type PostGwStitchWebApiAuthSignUpStitchMutationError = ErrorType<
	| PostGwStitchWebApiAuthSignUpStitch400
	| PostGwStitchWebApiAuthSignUpStitch401
	| PostGwStitchWebApiAuthSignUpStitch403
	| PostGwStitchWebApiAuthSignUpStitch404
	| PostGwStitchWebApiAuthSignUpStitch429
	| PostGwStitchWebApiAuthSignUpStitch500
>;

export const usePostGwStitchWebApiAuthSignUpStitch = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthSignUpStitch400
		| PostGwStitchWebApiAuthSignUpStitch401
		| PostGwStitchWebApiAuthSignUpStitch403
		| PostGwStitchWebApiAuthSignUpStitch404
		| PostGwStitchWebApiAuthSignUpStitch429
		| PostGwStitchWebApiAuthSignUpStitch500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitch>>,
		TError,
		{ data: PostGwStitchWebApiAuthSignUpStitchBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitch>>,
	TError,
	{ data: PostGwStitchWebApiAuthSignUpStitchBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthSignUpStitchMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getGwStitchWebApiAuthSignUpStitchStatus = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/sign-up/stitch/status`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthSignUpStitchStatusQueryKey = () => {
	return [`/gw/stitch-web/api/auth/sign-up/stitch/status`] as const;
};

export const getGetGwStitchWebApiAuthSignUpStitchStatusQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthSignUpStitchStatus400
		| GetGwStitchWebApiAuthSignUpStitchStatus401
		| GetGwStitchWebApiAuthSignUpStitchStatus403
		| GetGwStitchWebApiAuthSignUpStitchStatus404
		| GetGwStitchWebApiAuthSignUpStitchStatus429
		| GetGwStitchWebApiAuthSignUpStitchStatus500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthSignUpStitchStatusQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthSignUpStitchStatus(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthSignUpStitchStatusQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>
>;
export type GetGwStitchWebApiAuthSignUpStitchStatusQueryError = ErrorType<
	| GetGwStitchWebApiAuthSignUpStitchStatus400
	| GetGwStitchWebApiAuthSignUpStitchStatus401
	| GetGwStitchWebApiAuthSignUpStitchStatus403
	| GetGwStitchWebApiAuthSignUpStitchStatus404
	| GetGwStitchWebApiAuthSignUpStitchStatus429
	| GetGwStitchWebApiAuthSignUpStitchStatus500
>;

export const useGetGwStitchWebApiAuthSignUpStitchStatus = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthSignUpStitchStatus400
		| GetGwStitchWebApiAuthSignUpStitchStatus401
		| GetGwStitchWebApiAuthSignUpStitchStatus403
		| GetGwStitchWebApiAuthSignUpStitchStatus404
		| GetGwStitchWebApiAuthSignUpStitchStatus429
		| GetGwStitchWebApiAuthSignUpStitchStatus500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthSignUpStitchStatus>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthSignUpStitchStatusQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const postGwStitchWebApiAuthSignUpStitchComplete = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{ url: `/gw/stitch-web/api/auth/sign-up/stitch/complete`, method: 'POST' },
		options,
	);
};

export const getPostGwStitchWebApiAuthSignUpStitchCompleteMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthSignUpStitchComplete400
		| PostGwStitchWebApiAuthSignUpStitchComplete401
		| PostGwStitchWebApiAuthSignUpStitchComplete403
		| PostGwStitchWebApiAuthSignUpStitchComplete404
		| PostGwStitchWebApiAuthSignUpStitchComplete429
		| PostGwStitchWebApiAuthSignUpStitchComplete500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitchComplete>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitchComplete>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitchComplete>>,
		void
	> = () => {
		return postGwStitchWebApiAuthSignUpStitchComplete(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthSignUpStitchCompleteMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitchComplete>>
	>;

export type PostGwStitchWebApiAuthSignUpStitchCompleteMutationError = ErrorType<
	| PostGwStitchWebApiAuthSignUpStitchComplete400
	| PostGwStitchWebApiAuthSignUpStitchComplete401
	| PostGwStitchWebApiAuthSignUpStitchComplete403
	| PostGwStitchWebApiAuthSignUpStitchComplete404
	| PostGwStitchWebApiAuthSignUpStitchComplete429
	| PostGwStitchWebApiAuthSignUpStitchComplete500
>;

export const usePostGwStitchWebApiAuthSignUpStitchComplete = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthSignUpStitchComplete400
		| PostGwStitchWebApiAuthSignUpStitchComplete401
		| PostGwStitchWebApiAuthSignUpStitchComplete403
		| PostGwStitchWebApiAuthSignUpStitchComplete404
		| PostGwStitchWebApiAuthSignUpStitchComplete429
		| PostGwStitchWebApiAuthSignUpStitchComplete500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitchComplete>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthSignUpStitchComplete>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthSignUpStitchCompleteMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Use this endpoint to get the TOTP URI
 */
export const postGwStitchWebApiAuthTwoFactorGetTotpUri = (
	postGwStitchWebApiAuthTwoFactorGetTotpUriBody: PostGwStitchWebApiAuthTwoFactorGetTotpUriBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorGetTotpUri200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/get-totp-uri`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorGetTotpUriBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorGetTotpUriMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri400
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri401
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri403
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri404
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri429
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorGetTotpUri>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorGetTotpUriBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorGetTotpUri>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorGetTotpUriBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorGetTotpUri>>,
		{ data: PostGwStitchWebApiAuthTwoFactorGetTotpUriBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthTwoFactorGetTotpUri(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthTwoFactorGetTotpUriMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorGetTotpUri>>
	>;
export type PostGwStitchWebApiAuthTwoFactorGetTotpUriMutationBody =
	PostGwStitchWebApiAuthTwoFactorGetTotpUriBody;
export type PostGwStitchWebApiAuthTwoFactorGetTotpUriMutationError = ErrorType<
	| PostGwStitchWebApiAuthTwoFactorGetTotpUri400
	| PostGwStitchWebApiAuthTwoFactorGetTotpUri401
	| PostGwStitchWebApiAuthTwoFactorGetTotpUri403
	| PostGwStitchWebApiAuthTwoFactorGetTotpUri404
	| PostGwStitchWebApiAuthTwoFactorGetTotpUri429
	| PostGwStitchWebApiAuthTwoFactorGetTotpUri500
>;

export const usePostGwStitchWebApiAuthTwoFactorGetTotpUri = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri400
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri401
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri403
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri404
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri429
		| PostGwStitchWebApiAuthTwoFactorGetTotpUri500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorGetTotpUri>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorGetTotpUriBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorGetTotpUri>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorGetTotpUriBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorGetTotpUriMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Verify two factor TOTP
 */
export const postGwStitchWebApiAuthTwoFactorVerifyTotp = (
	postGwStitchWebApiAuthTwoFactorVerifyTotpBody: PostGwStitchWebApiAuthTwoFactorVerifyTotpBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorVerifyTotp200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/verify-totp`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorVerifyTotpBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorVerifyTotpMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp400
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp401
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp403
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp404
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp429
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyTotp>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyTotpBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyTotp>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorVerifyTotpBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyTotp>>,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyTotpBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthTwoFactorVerifyTotp(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthTwoFactorVerifyTotpMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyTotp>>
	>;
export type PostGwStitchWebApiAuthTwoFactorVerifyTotpMutationBody =
	PostGwStitchWebApiAuthTwoFactorVerifyTotpBody;
export type PostGwStitchWebApiAuthTwoFactorVerifyTotpMutationError = ErrorType<
	| PostGwStitchWebApiAuthTwoFactorVerifyTotp400
	| PostGwStitchWebApiAuthTwoFactorVerifyTotp401
	| PostGwStitchWebApiAuthTwoFactorVerifyTotp403
	| PostGwStitchWebApiAuthTwoFactorVerifyTotp404
	| PostGwStitchWebApiAuthTwoFactorVerifyTotp429
	| PostGwStitchWebApiAuthTwoFactorVerifyTotp500
>;

export const usePostGwStitchWebApiAuthTwoFactorVerifyTotp = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp400
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp401
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp403
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp404
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp429
		| PostGwStitchWebApiAuthTwoFactorVerifyTotp500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyTotp>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyTotpBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyTotp>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorVerifyTotpBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorVerifyTotpMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Send two factor OTP to the user
 */
export const postGwStitchWebApiAuthTwoFactorSendOtp = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorSendOtp200>(
		{ url: `/gw/stitch-web/api/auth/two-factor/send-otp`, method: 'POST' },
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorSendOtpMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorSendOtp400
		| PostGwStitchWebApiAuthTwoFactorSendOtp401
		| PostGwStitchWebApiAuthTwoFactorSendOtp403
		| PostGwStitchWebApiAuthTwoFactorSendOtp404
		| PostGwStitchWebApiAuthTwoFactorSendOtp429
		| PostGwStitchWebApiAuthTwoFactorSendOtp500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorSendOtp>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorSendOtp>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorSendOtp>>,
		void
	> = () => {
		return postGwStitchWebApiAuthTwoFactorSendOtp(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthTwoFactorSendOtpMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorSendOtp>>
>;

export type PostGwStitchWebApiAuthTwoFactorSendOtpMutationError = ErrorType<
	| PostGwStitchWebApiAuthTwoFactorSendOtp400
	| PostGwStitchWebApiAuthTwoFactorSendOtp401
	| PostGwStitchWebApiAuthTwoFactorSendOtp403
	| PostGwStitchWebApiAuthTwoFactorSendOtp404
	| PostGwStitchWebApiAuthTwoFactorSendOtp429
	| PostGwStitchWebApiAuthTwoFactorSendOtp500
>;

export const usePostGwStitchWebApiAuthTwoFactorSendOtp = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorSendOtp400
		| PostGwStitchWebApiAuthTwoFactorSendOtp401
		| PostGwStitchWebApiAuthTwoFactorSendOtp403
		| PostGwStitchWebApiAuthTwoFactorSendOtp404
		| PostGwStitchWebApiAuthTwoFactorSendOtp429
		| PostGwStitchWebApiAuthTwoFactorSendOtp500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorSendOtp>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorSendOtp>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorSendOtpMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Verify two factor OTP
 */
export const postGwStitchWebApiAuthTwoFactorVerifyOtp = (
	postGwStitchWebApiAuthTwoFactorVerifyOtpBody: PostGwStitchWebApiAuthTwoFactorVerifyOtpBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorVerifyOtp200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/verify-otp`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorVerifyOtpBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorVerifyOtpMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp400
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp401
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp403
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp404
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp429
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyOtp>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyOtpBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyOtp>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorVerifyOtpBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyOtp>>,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyOtpBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthTwoFactorVerifyOtp(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthTwoFactorVerifyOtpMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyOtp>>
	>;
export type PostGwStitchWebApiAuthTwoFactorVerifyOtpMutationBody =
	PostGwStitchWebApiAuthTwoFactorVerifyOtpBody;
export type PostGwStitchWebApiAuthTwoFactorVerifyOtpMutationError = ErrorType<
	| PostGwStitchWebApiAuthTwoFactorVerifyOtp400
	| PostGwStitchWebApiAuthTwoFactorVerifyOtp401
	| PostGwStitchWebApiAuthTwoFactorVerifyOtp403
	| PostGwStitchWebApiAuthTwoFactorVerifyOtp404
	| PostGwStitchWebApiAuthTwoFactorVerifyOtp429
	| PostGwStitchWebApiAuthTwoFactorVerifyOtp500
>;

export const usePostGwStitchWebApiAuthTwoFactorVerifyOtp = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp400
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp401
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp403
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp404
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp429
		| PostGwStitchWebApiAuthTwoFactorVerifyOtp500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyOtp>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyOtpBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyOtp>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorVerifyOtpBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorVerifyOtpMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Verify a backup code for two-factor authentication
 */
export const postGwStitchWebApiAuthTwoFactorVerifyBackupCode = (
	postGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody: PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorVerifyBackupCode200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/verify-backup-code`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorVerifyBackupCodeMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode400
			| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode401
			| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode403
			| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode404
			| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode429
			| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyBackupCode>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyBackupCode>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyBackupCode>
			>,
			{ data: PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthTwoFactorVerifyBackupCode(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyBackupCode>>
	>;
export type PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeMutationBody =
	PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody;
export type PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode400
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode401
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode403
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode404
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode429
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode500
	>;

export const usePostGwStitchWebApiAuthTwoFactorVerifyBackupCode = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode400
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode401
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode403
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode404
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode429
		| PostGwStitchWebApiAuthTwoFactorVerifyBackupCode500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyBackupCode>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorVerifyBackupCode>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorVerifyBackupCodeBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorVerifyBackupCodeMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Generate new backup codes for two-factor authentication
 */
export const postGwStitchWebApiAuthTwoFactorGenerateBackupCodes = (
	postGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody: PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/generate-backup-codes`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorGenerateBackupCodesMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes400
			| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes401
			| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes403
			| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes404
			| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes429
			| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthTwoFactorGenerateBackupCodes>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthTwoFactorGenerateBackupCodes>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthTwoFactorGenerateBackupCodes>
			>,
			{ data: PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthTwoFactorGenerateBackupCodes(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthTwoFactorGenerateBackupCodes>
		>
	>;
export type PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesMutationBody =
	PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody;
export type PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes400
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes401
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes403
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes404
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes429
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes500
	>;

export const usePostGwStitchWebApiAuthTwoFactorGenerateBackupCodes = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes400
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes401
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes403
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes404
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes429
		| PostGwStitchWebApiAuthTwoFactorGenerateBackupCodes500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthTwoFactorGenerateBackupCodes>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<
		ReturnType<typeof postGwStitchWebApiAuthTwoFactorGenerateBackupCodes>
	>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorGenerateBackupCodesBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorGenerateBackupCodesMutationOptions(
			options,
		);

	return useMutation(mutationOptions);
};

/**
 * Use this endpoint to enable two factor authentication. This will generate a TOTP URI and backup codes. Once the user verifies the TOTP URI, the two factor authentication will be enabled.
 */
export const postGwStitchWebApiAuthTwoFactorEnable = (
	postGwStitchWebApiAuthTwoFactorEnableBody: PostGwStitchWebApiAuthTwoFactorEnableBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorEnable200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/enable`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorEnableBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorEnableMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorEnable400
		| PostGwStitchWebApiAuthTwoFactorEnable401
		| PostGwStitchWebApiAuthTwoFactorEnable403
		| PostGwStitchWebApiAuthTwoFactorEnable404
		| PostGwStitchWebApiAuthTwoFactorEnable429
		| PostGwStitchWebApiAuthTwoFactorEnable500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorEnable>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorEnableBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorEnable>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorEnableBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorEnable>>,
		{ data: PostGwStitchWebApiAuthTwoFactorEnableBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthTwoFactorEnable(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthTwoFactorEnableMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorEnable>>
>;
export type PostGwStitchWebApiAuthTwoFactorEnableMutationBody =
	PostGwStitchWebApiAuthTwoFactorEnableBody;
export type PostGwStitchWebApiAuthTwoFactorEnableMutationError = ErrorType<
	| PostGwStitchWebApiAuthTwoFactorEnable400
	| PostGwStitchWebApiAuthTwoFactorEnable401
	| PostGwStitchWebApiAuthTwoFactorEnable403
	| PostGwStitchWebApiAuthTwoFactorEnable404
	| PostGwStitchWebApiAuthTwoFactorEnable429
	| PostGwStitchWebApiAuthTwoFactorEnable500
>;

export const usePostGwStitchWebApiAuthTwoFactorEnable = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorEnable400
		| PostGwStitchWebApiAuthTwoFactorEnable401
		| PostGwStitchWebApiAuthTwoFactorEnable403
		| PostGwStitchWebApiAuthTwoFactorEnable404
		| PostGwStitchWebApiAuthTwoFactorEnable429
		| PostGwStitchWebApiAuthTwoFactorEnable500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorEnable>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorEnableBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorEnable>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorEnableBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorEnableMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Use this endpoint to disable two factor authentication.
 */
export const postGwStitchWebApiAuthTwoFactorDisable = (
	postGwStitchWebApiAuthTwoFactorDisableBody: PostGwStitchWebApiAuthTwoFactorDisableBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthTwoFactorDisable200>(
		{
			url: `/gw/stitch-web/api/auth/two-factor/disable`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthTwoFactorDisableBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthTwoFactorDisableMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorDisable400
		| PostGwStitchWebApiAuthTwoFactorDisable401
		| PostGwStitchWebApiAuthTwoFactorDisable403
		| PostGwStitchWebApiAuthTwoFactorDisable404
		| PostGwStitchWebApiAuthTwoFactorDisable429
		| PostGwStitchWebApiAuthTwoFactorDisable500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorDisable>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorDisableBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorDisable>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorDisableBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorDisable>>,
		{ data: PostGwStitchWebApiAuthTwoFactorDisableBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthTwoFactorDisable(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthTwoFactorDisableMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorDisable>>
>;
export type PostGwStitchWebApiAuthTwoFactorDisableMutationBody =
	PostGwStitchWebApiAuthTwoFactorDisableBody;
export type PostGwStitchWebApiAuthTwoFactorDisableMutationError = ErrorType<
	| PostGwStitchWebApiAuthTwoFactorDisable400
	| PostGwStitchWebApiAuthTwoFactorDisable401
	| PostGwStitchWebApiAuthTwoFactorDisable403
	| PostGwStitchWebApiAuthTwoFactorDisable404
	| PostGwStitchWebApiAuthTwoFactorDisable429
	| PostGwStitchWebApiAuthTwoFactorDisable500
>;

export const usePostGwStitchWebApiAuthTwoFactorDisable = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthTwoFactorDisable400
		| PostGwStitchWebApiAuthTwoFactorDisable401
		| PostGwStitchWebApiAuthTwoFactorDisable403
		| PostGwStitchWebApiAuthTwoFactorDisable404
		| PostGwStitchWebApiAuthTwoFactorDisable429
		| PostGwStitchWebApiAuthTwoFactorDisable500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorDisable>>,
		TError,
		{ data: PostGwStitchWebApiAuthTwoFactorDisableBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthTwoFactorDisable>>,
	TError,
	{ data: PostGwStitchWebApiAuthTwoFactorDisableBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthTwoFactorDisableMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Create an organization
 */
export const postGwStitchWebApiAuthOrganizationCreate = (
	postGwStitchWebApiAuthOrganizationCreateBody: PostGwStitchWebApiAuthOrganizationCreateBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Organization>(
		{
			url: `/gw/stitch-web/api/auth/organization/create`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationCreateBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationCreateMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationCreate400
		| PostGwStitchWebApiAuthOrganizationCreate401
		| PostGwStitchWebApiAuthOrganizationCreate403
		| PostGwStitchWebApiAuthOrganizationCreate404
		| PostGwStitchWebApiAuthOrganizationCreate429
		| PostGwStitchWebApiAuthOrganizationCreate500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCreate>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationCreateBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCreate>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationCreateBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCreate>>,
		{ data: PostGwStitchWebApiAuthOrganizationCreateBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthOrganizationCreate(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthOrganizationCreateMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCreate>>
	>;
export type PostGwStitchWebApiAuthOrganizationCreateMutationBody =
	PostGwStitchWebApiAuthOrganizationCreateBody;
export type PostGwStitchWebApiAuthOrganizationCreateMutationError = ErrorType<
	| PostGwStitchWebApiAuthOrganizationCreate400
	| PostGwStitchWebApiAuthOrganizationCreate401
	| PostGwStitchWebApiAuthOrganizationCreate403
	| PostGwStitchWebApiAuthOrganizationCreate404
	| PostGwStitchWebApiAuthOrganizationCreate429
	| PostGwStitchWebApiAuthOrganizationCreate500
>;

export const usePostGwStitchWebApiAuthOrganizationCreate = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationCreate400
		| PostGwStitchWebApiAuthOrganizationCreate401
		| PostGwStitchWebApiAuthOrganizationCreate403
		| PostGwStitchWebApiAuthOrganizationCreate404
		| PostGwStitchWebApiAuthOrganizationCreate429
		| PostGwStitchWebApiAuthOrganizationCreate500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCreate>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationCreateBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCreate>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationCreateBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationCreateMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Update an organization
 */
export const postGwStitchWebApiAuthOrganizationUpdate = (
	postGwStitchWebApiAuthOrganizationUpdateBody: PostGwStitchWebApiAuthOrganizationUpdateBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Organization>(
		{
			url: `/gw/stitch-web/api/auth/organization/update`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationUpdateBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationUpdateMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationUpdate400
		| PostGwStitchWebApiAuthOrganizationUpdate401
		| PostGwStitchWebApiAuthOrganizationUpdate403
		| PostGwStitchWebApiAuthOrganizationUpdate404
		| PostGwStitchWebApiAuthOrganizationUpdate429
		| PostGwStitchWebApiAuthOrganizationUpdate500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationUpdate>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationUpdateBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationUpdate>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationUpdateBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationUpdate>>,
		{ data: PostGwStitchWebApiAuthOrganizationUpdateBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthOrganizationUpdate(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthOrganizationUpdateMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationUpdate>>
	>;
export type PostGwStitchWebApiAuthOrganizationUpdateMutationBody =
	PostGwStitchWebApiAuthOrganizationUpdateBody;
export type PostGwStitchWebApiAuthOrganizationUpdateMutationError = ErrorType<
	| PostGwStitchWebApiAuthOrganizationUpdate400
	| PostGwStitchWebApiAuthOrganizationUpdate401
	| PostGwStitchWebApiAuthOrganizationUpdate403
	| PostGwStitchWebApiAuthOrganizationUpdate404
	| PostGwStitchWebApiAuthOrganizationUpdate429
	| PostGwStitchWebApiAuthOrganizationUpdate500
>;

export const usePostGwStitchWebApiAuthOrganizationUpdate = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationUpdate400
		| PostGwStitchWebApiAuthOrganizationUpdate401
		| PostGwStitchWebApiAuthOrganizationUpdate403
		| PostGwStitchWebApiAuthOrganizationUpdate404
		| PostGwStitchWebApiAuthOrganizationUpdate429
		| PostGwStitchWebApiAuthOrganizationUpdate500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationUpdate>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationUpdateBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationUpdate>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationUpdateBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationUpdateMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Delete an organization
 */
export const postGwStitchWebApiAuthOrganizationDelete = (
	postGwStitchWebApiAuthOrganizationDeleteBody: PostGwStitchWebApiAuthOrganizationDeleteBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<string>(
		{
			url: `/gw/stitch-web/api/auth/organization/delete`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationDeleteBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationDeleteMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationDelete400
		| PostGwStitchWebApiAuthOrganizationDelete401
		| PostGwStitchWebApiAuthOrganizationDelete403
		| PostGwStitchWebApiAuthOrganizationDelete404
		| PostGwStitchWebApiAuthOrganizationDelete429
		| PostGwStitchWebApiAuthOrganizationDelete500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationDelete>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationDeleteBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationDelete>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationDeleteBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationDelete>>,
		{ data: PostGwStitchWebApiAuthOrganizationDeleteBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthOrganizationDelete(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthOrganizationDeleteMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationDelete>>
	>;
export type PostGwStitchWebApiAuthOrganizationDeleteMutationBody =
	PostGwStitchWebApiAuthOrganizationDeleteBody;
export type PostGwStitchWebApiAuthOrganizationDeleteMutationError = ErrorType<
	| PostGwStitchWebApiAuthOrganizationDelete400
	| PostGwStitchWebApiAuthOrganizationDelete401
	| PostGwStitchWebApiAuthOrganizationDelete403
	| PostGwStitchWebApiAuthOrganizationDelete404
	| PostGwStitchWebApiAuthOrganizationDelete429
	| PostGwStitchWebApiAuthOrganizationDelete500
>;

export const usePostGwStitchWebApiAuthOrganizationDelete = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationDelete400
		| PostGwStitchWebApiAuthOrganizationDelete401
		| PostGwStitchWebApiAuthOrganizationDelete403
		| PostGwStitchWebApiAuthOrganizationDelete404
		| PostGwStitchWebApiAuthOrganizationDelete429
		| PostGwStitchWebApiAuthOrganizationDelete500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationDelete>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationDeleteBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationDelete>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationDeleteBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationDeleteMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Set the active organization
 */
export const setActiveOrganization = (
	setActiveOrganizationBody: SetActiveOrganizationBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<Organization>(
		{
			url: `/gw/stitch-web/api/auth/organization/set-active`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: setActiveOrganizationBody,
		},
		options,
	);
};

export const getSetActiveOrganizationMutationOptions = <
	TError = ErrorType<
		| SetActiveOrganization400
		| SetActiveOrganization401
		| SetActiveOrganization403
		| SetActiveOrganization404
		| SetActiveOrganization429
		| SetActiveOrganization500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof setActiveOrganization>>,
		TError,
		{ data: SetActiveOrganizationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof setActiveOrganization>>,
	TError,
	{ data: SetActiveOrganizationBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof setActiveOrganization>>,
		{ data: SetActiveOrganizationBody }
	> = (props) => {
		const { data } = props ?? {};

		return setActiveOrganization(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SetActiveOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof setActiveOrganization>>
>;
export type SetActiveOrganizationMutationBody = SetActiveOrganizationBody;
export type SetActiveOrganizationMutationError = ErrorType<
	| SetActiveOrganization400
	| SetActiveOrganization401
	| SetActiveOrganization403
	| SetActiveOrganization404
	| SetActiveOrganization429
	| SetActiveOrganization500
>;

export const useSetActiveOrganization = <
	TError = ErrorType<
		| SetActiveOrganization400
		| SetActiveOrganization401
		| SetActiveOrganization403
		| SetActiveOrganization404
		| SetActiveOrganization429
		| SetActiveOrganization500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof setActiveOrganization>>,
		TError,
		{ data: SetActiveOrganizationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof setActiveOrganization>>,
	TError,
	{ data: SetActiveOrganizationBody },
	TContext
> => {
	const mutationOptions = getSetActiveOrganizationMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Get the full organization
 */
export const getOrganization = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Organization>(
		{
			url: `/gw/stitch-web/api/auth/organization/get-full-organization`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetOrganizationQueryKey = () => {
	return [
		`/gw/stitch-web/api/auth/organization/get-full-organization`,
	] as const;
};

export const getGetOrganizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<
		| GetOrganization400
		| GetOrganization401
		| GetOrganization403
		| GetOrganization404
		| GetOrganization429
		| GetOrganization500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetOrganizationQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
		signal,
	}) => getOrganization(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getOrganization>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetOrganizationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError = ErrorType<
	| GetOrganization400
	| GetOrganization401
	| GetOrganization403
	| GetOrganization404
	| GetOrganization429
	| GetOrganization500
>;

export const useGetOrganization = <
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError = ErrorType<
		| GetOrganization400
		| GetOrganization401
		| GetOrganization403
		| GetOrganization404
		| GetOrganization429
		| GetOrganization500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetOrganizationQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * List all organizations
 */
export const getGwStitchWebApiAuthOrganizationList = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Organization[]>(
		{ url: `/gw/stitch-web/api/auth/organization/list`, method: 'GET', signal },
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationListQueryKey = () => {
	return [`/gw/stitch-web/api/auth/organization/list`] as const;
};

export const getGetGwStitchWebApiAuthOrganizationListQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationList400
		| GetGwStitchWebApiAuthOrganizationList401
		| GetGwStitchWebApiAuthOrganizationList403
		| GetGwStitchWebApiAuthOrganizationList404
		| GetGwStitchWebApiAuthOrganizationList429
		| GetGwStitchWebApiAuthOrganizationList500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthOrganizationListQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthOrganizationList(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOrganizationListQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>
>;
export type GetGwStitchWebApiAuthOrganizationListQueryError = ErrorType<
	| GetGwStitchWebApiAuthOrganizationList400
	| GetGwStitchWebApiAuthOrganizationList401
	| GetGwStitchWebApiAuthOrganizationList403
	| GetGwStitchWebApiAuthOrganizationList404
	| GetGwStitchWebApiAuthOrganizationList429
	| GetGwStitchWebApiAuthOrganizationList500
>;

export const useGetGwStitchWebApiAuthOrganizationList = <
	TData = Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationList400
		| GetGwStitchWebApiAuthOrganizationList401
		| GetGwStitchWebApiAuthOrganizationList403
		| GetGwStitchWebApiAuthOrganizationList404
		| GetGwStitchWebApiAuthOrganizationList429
		| GetGwStitchWebApiAuthOrganizationList500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationList>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationListQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Create an invitation to an organization
 */
export const createOrganizationInvitation = (
	createOrganizationInvitationBody: CreateOrganizationInvitationBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CreateOrganizationInvitation200>(
		{
			url: `/gw/stitch-web/api/auth/organization/invite-member`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createOrganizationInvitationBody,
		},
		options,
	);
};

export const getCreateOrganizationInvitationMutationOptions = <
	TError = ErrorType<
		| CreateOrganizationInvitation400
		| CreateOrganizationInvitation401
		| CreateOrganizationInvitation403
		| CreateOrganizationInvitation404
		| CreateOrganizationInvitation429
		| CreateOrganizationInvitation500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createOrganizationInvitation>>,
		TError,
		{ data: CreateOrganizationInvitationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createOrganizationInvitation>>,
	TError,
	{ data: CreateOrganizationInvitationBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createOrganizationInvitation>>,
		{ data: CreateOrganizationInvitationBody }
	> = (props) => {
		const { data } = props ?? {};

		return createOrganizationInvitation(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationInvitationMutationResult = NonNullable<
	Awaited<ReturnType<typeof createOrganizationInvitation>>
>;
export type CreateOrganizationInvitationMutationBody =
	CreateOrganizationInvitationBody;
export type CreateOrganizationInvitationMutationError = ErrorType<
	| CreateOrganizationInvitation400
	| CreateOrganizationInvitation401
	| CreateOrganizationInvitation403
	| CreateOrganizationInvitation404
	| CreateOrganizationInvitation429
	| CreateOrganizationInvitation500
>;

export const useCreateOrganizationInvitation = <
	TError = ErrorType<
		| CreateOrganizationInvitation400
		| CreateOrganizationInvitation401
		| CreateOrganizationInvitation403
		| CreateOrganizationInvitation404
		| CreateOrganizationInvitation429
		| CreateOrganizationInvitation500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createOrganizationInvitation>>,
		TError,
		{ data: CreateOrganizationInvitationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createOrganizationInvitation>>,
	TError,
	{ data: CreateOrganizationInvitationBody },
	TContext
> => {
	const mutationOptions =
		getCreateOrganizationInvitationMutationOptions(options);

	return useMutation(mutationOptions);
};

export const postGwStitchWebApiAuthOrganizationCancelInvitation = (
	postGwStitchWebApiAuthOrganizationCancelInvitationBody: PostGwStitchWebApiAuthOrganizationCancelInvitationBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/organization/cancel-invitation`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationCancelInvitationBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationCancelInvitationMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthOrganizationCancelInvitation400
			| PostGwStitchWebApiAuthOrganizationCancelInvitation401
			| PostGwStitchWebApiAuthOrganizationCancelInvitation403
			| PostGwStitchWebApiAuthOrganizationCancelInvitation404
			| PostGwStitchWebApiAuthOrganizationCancelInvitation429
			| PostGwStitchWebApiAuthOrganizationCancelInvitation500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationCancelInvitation>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthOrganizationCancelInvitationBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationCancelInvitation>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationCancelInvitationBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationCancelInvitation>
			>,
			{ data: PostGwStitchWebApiAuthOrganizationCancelInvitationBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthOrganizationCancelInvitation(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthOrganizationCancelInvitationMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationCancelInvitation>
		>
	>;
export type PostGwStitchWebApiAuthOrganizationCancelInvitationMutationBody =
	PostGwStitchWebApiAuthOrganizationCancelInvitationBody;
export type PostGwStitchWebApiAuthOrganizationCancelInvitationMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthOrganizationCancelInvitation400
		| PostGwStitchWebApiAuthOrganizationCancelInvitation401
		| PostGwStitchWebApiAuthOrganizationCancelInvitation403
		| PostGwStitchWebApiAuthOrganizationCancelInvitation404
		| PostGwStitchWebApiAuthOrganizationCancelInvitation429
		| PostGwStitchWebApiAuthOrganizationCancelInvitation500
	>;

export const usePostGwStitchWebApiAuthOrganizationCancelInvitation = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationCancelInvitation400
		| PostGwStitchWebApiAuthOrganizationCancelInvitation401
		| PostGwStitchWebApiAuthOrganizationCancelInvitation403
		| PostGwStitchWebApiAuthOrganizationCancelInvitation404
		| PostGwStitchWebApiAuthOrganizationCancelInvitation429
		| PostGwStitchWebApiAuthOrganizationCancelInvitation500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationCancelInvitation>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationCancelInvitationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<
		ReturnType<typeof postGwStitchWebApiAuthOrganizationCancelInvitation>
	>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationCancelInvitationBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationCancelInvitationMutationOptions(
			options,
		);

	return useMutation(mutationOptions);
};

/**
 * Accept an invitation to an organization
 */
export const postGwStitchWebApiAuthOrganizationAcceptInvitation = (
	postGwStitchWebApiAuthOrganizationAcceptInvitationBody: PostGwStitchWebApiAuthOrganizationAcceptInvitationBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthOrganizationAcceptInvitation200>(
		{
			url: `/gw/stitch-web/api/auth/organization/accept-invitation`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationAcceptInvitationBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationAcceptInvitationMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthOrganizationAcceptInvitation400
			| PostGwStitchWebApiAuthOrganizationAcceptInvitation401
			| PostGwStitchWebApiAuthOrganizationAcceptInvitation403
			| PostGwStitchWebApiAuthOrganizationAcceptInvitation404
			| PostGwStitchWebApiAuthOrganizationAcceptInvitation429
			| PostGwStitchWebApiAuthOrganizationAcceptInvitation500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationAcceptInvitation>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthOrganizationAcceptInvitationBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationAcceptInvitation>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationAcceptInvitationBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationAcceptInvitation>
			>,
			{ data: PostGwStitchWebApiAuthOrganizationAcceptInvitationBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthOrganizationAcceptInvitation(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthOrganizationAcceptInvitationMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationAcceptInvitation>
		>
	>;
export type PostGwStitchWebApiAuthOrganizationAcceptInvitationMutationBody =
	PostGwStitchWebApiAuthOrganizationAcceptInvitationBody;
export type PostGwStitchWebApiAuthOrganizationAcceptInvitationMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation400
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation401
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation403
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation404
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation429
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation500
	>;

export const usePostGwStitchWebApiAuthOrganizationAcceptInvitation = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation400
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation401
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation403
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation404
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation429
		| PostGwStitchWebApiAuthOrganizationAcceptInvitation500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationAcceptInvitation>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationAcceptInvitationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<
		ReturnType<typeof postGwStitchWebApiAuthOrganizationAcceptInvitation>
	>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationAcceptInvitationBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationAcceptInvitationMutationOptions(
			options,
		);

	return useMutation(mutationOptions);
};

/**
 * Get an invitation by ID
 */
export const getGwStitchWebApiAuthOrganizationGetInvitation = (
	params?: GetGwStitchWebApiAuthOrganizationGetInvitationParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthOrganizationGetInvitation200>(
		{
			url: `/gw/stitch-web/api/auth/organization/get-invitation`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationGetInvitationQueryKey = (
	params?: GetGwStitchWebApiAuthOrganizationGetInvitationParams,
) => {
	return [
		`/gw/stitch-web/api/auth/organization/get-invitation`,
		...(params ? [params] : []),
	] as const;
};

export const getGetGwStitchWebApiAuthOrganizationGetInvitationQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetInvitation400
		| GetGwStitchWebApiAuthOrganizationGetInvitation401
		| GetGwStitchWebApiAuthOrganizationGetInvitation403
		| GetGwStitchWebApiAuthOrganizationGetInvitation404
		| GetGwStitchWebApiAuthOrganizationGetInvitation429
		| GetGwStitchWebApiAuthOrganizationGetInvitation500
	>,
>(
	params?: GetGwStitchWebApiAuthOrganizationGetInvitationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthOrganizationGetInvitationQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthOrganizationGetInvitation(
			params,
			requestOptions,
			signal,
		);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOrganizationGetInvitationQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>>
	>;
export type GetGwStitchWebApiAuthOrganizationGetInvitationQueryError =
	ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetInvitation400
		| GetGwStitchWebApiAuthOrganizationGetInvitation401
		| GetGwStitchWebApiAuthOrganizationGetInvitation403
		| GetGwStitchWebApiAuthOrganizationGetInvitation404
		| GetGwStitchWebApiAuthOrganizationGetInvitation429
		| GetGwStitchWebApiAuthOrganizationGetInvitation500
	>;

export const useGetGwStitchWebApiAuthOrganizationGetInvitation = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetInvitation400
		| GetGwStitchWebApiAuthOrganizationGetInvitation401
		| GetGwStitchWebApiAuthOrganizationGetInvitation403
		| GetGwStitchWebApiAuthOrganizationGetInvitation404
		| GetGwStitchWebApiAuthOrganizationGetInvitation429
		| GetGwStitchWebApiAuthOrganizationGetInvitation500
	>,
>(
	params?: GetGwStitchWebApiAuthOrganizationGetInvitationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof getGwStitchWebApiAuthOrganizationGetInvitation>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationGetInvitationQueryOptions(
			params,
			options,
		);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Reject an invitation to an organization
 */
export const postGwStitchWebApiAuthOrganizationRejectInvitation = (
	postGwStitchWebApiAuthOrganizationRejectInvitationBody: PostGwStitchWebApiAuthOrganizationRejectInvitationBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthOrganizationRejectInvitation200>(
		{
			url: `/gw/stitch-web/api/auth/organization/reject-invitation`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationRejectInvitationBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationRejectInvitationMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthOrganizationRejectInvitation400
			| PostGwStitchWebApiAuthOrganizationRejectInvitation401
			| PostGwStitchWebApiAuthOrganizationRejectInvitation403
			| PostGwStitchWebApiAuthOrganizationRejectInvitation404
			| PostGwStitchWebApiAuthOrganizationRejectInvitation429
			| PostGwStitchWebApiAuthOrganizationRejectInvitation500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationRejectInvitation>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthOrganizationRejectInvitationBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationRejectInvitation>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationRejectInvitationBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationRejectInvitation>
			>,
			{ data: PostGwStitchWebApiAuthOrganizationRejectInvitationBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthOrganizationRejectInvitation(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthOrganizationRejectInvitationMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationRejectInvitation>
		>
	>;
export type PostGwStitchWebApiAuthOrganizationRejectInvitationMutationBody =
	PostGwStitchWebApiAuthOrganizationRejectInvitationBody;
export type PostGwStitchWebApiAuthOrganizationRejectInvitationMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthOrganizationRejectInvitation400
		| PostGwStitchWebApiAuthOrganizationRejectInvitation401
		| PostGwStitchWebApiAuthOrganizationRejectInvitation403
		| PostGwStitchWebApiAuthOrganizationRejectInvitation404
		| PostGwStitchWebApiAuthOrganizationRejectInvitation429
		| PostGwStitchWebApiAuthOrganizationRejectInvitation500
	>;

export const usePostGwStitchWebApiAuthOrganizationRejectInvitation = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationRejectInvitation400
		| PostGwStitchWebApiAuthOrganizationRejectInvitation401
		| PostGwStitchWebApiAuthOrganizationRejectInvitation403
		| PostGwStitchWebApiAuthOrganizationRejectInvitation404
		| PostGwStitchWebApiAuthOrganizationRejectInvitation429
		| PostGwStitchWebApiAuthOrganizationRejectInvitation500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<typeof postGwStitchWebApiAuthOrganizationRejectInvitation>
		>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationRejectInvitationBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<
		ReturnType<typeof postGwStitchWebApiAuthOrganizationRejectInvitation>
	>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationRejectInvitationBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationRejectInvitationMutationOptions(
			options,
		);

	return useMutation(mutationOptions);
};

export const getGwStitchWebApiAuthOrganizationListInvitations = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/organization/list-invitations`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationListInvitationsQueryKey =
	() => {
		return [`/gw/stitch-web/api/auth/organization/list-invitations`] as const;
	};

export const getGetGwStitchWebApiAuthOrganizationListInvitationsQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationListInvitations400
		| GetGwStitchWebApiAuthOrganizationListInvitations401
		| GetGwStitchWebApiAuthOrganizationListInvitations403
		| GetGwStitchWebApiAuthOrganizationListInvitations404
		| GetGwStitchWebApiAuthOrganizationListInvitations429
		| GetGwStitchWebApiAuthOrganizationListInvitations500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthOrganizationListInvitationsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthOrganizationListInvitations(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<
			ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>
		>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOrganizationListInvitationsQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>>
	>;
export type GetGwStitchWebApiAuthOrganizationListInvitationsQueryError =
	ErrorType<
		| GetGwStitchWebApiAuthOrganizationListInvitations400
		| GetGwStitchWebApiAuthOrganizationListInvitations401
		| GetGwStitchWebApiAuthOrganizationListInvitations403
		| GetGwStitchWebApiAuthOrganizationListInvitations404
		| GetGwStitchWebApiAuthOrganizationListInvitations429
		| GetGwStitchWebApiAuthOrganizationListInvitations500
	>;

export const useGetGwStitchWebApiAuthOrganizationListInvitations = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationListInvitations400
		| GetGwStitchWebApiAuthOrganizationListInvitations401
		| GetGwStitchWebApiAuthOrganizationListInvitations403
		| GetGwStitchWebApiAuthOrganizationListInvitations404
		| GetGwStitchWebApiAuthOrganizationListInvitations429
		| GetGwStitchWebApiAuthOrganizationListInvitations500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationListInvitations>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationListInvitationsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Get the member details of the active organization
 */
export const getGwStitchWebApiAuthOrganizationGetActiveMember = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetGwStitchWebApiAuthOrganizationGetActiveMember200>(
		{
			url: `/gw/stitch-web/api/auth/organization/get-active-member`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationGetActiveMemberQueryKey =
	() => {
		return [`/gw/stitch-web/api/auth/organization/get-active-member`] as const;
	};

export const getGetGwStitchWebApiAuthOrganizationGetActiveMemberQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetActiveMember400
		| GetGwStitchWebApiAuthOrganizationGetActiveMember401
		| GetGwStitchWebApiAuthOrganizationGetActiveMember403
		| GetGwStitchWebApiAuthOrganizationGetActiveMember404
		| GetGwStitchWebApiAuthOrganizationGetActiveMember429
		| GetGwStitchWebApiAuthOrganizationGetActiveMember500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthOrganizationGetActiveMemberQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthOrganizationGetActiveMember(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<
			ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>
		>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOrganizationGetActiveMemberQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>>
	>;
export type GetGwStitchWebApiAuthOrganizationGetActiveMemberQueryError =
	ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetActiveMember400
		| GetGwStitchWebApiAuthOrganizationGetActiveMember401
		| GetGwStitchWebApiAuthOrganizationGetActiveMember403
		| GetGwStitchWebApiAuthOrganizationGetActiveMember404
		| GetGwStitchWebApiAuthOrganizationGetActiveMember429
		| GetGwStitchWebApiAuthOrganizationGetActiveMember500
	>;

export const useGetGwStitchWebApiAuthOrganizationGetActiveMember = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetActiveMember400
		| GetGwStitchWebApiAuthOrganizationGetActiveMember401
		| GetGwStitchWebApiAuthOrganizationGetActiveMember403
		| GetGwStitchWebApiAuthOrganizationGetActiveMember404
		| GetGwStitchWebApiAuthOrganizationGetActiveMember429
		| GetGwStitchWebApiAuthOrganizationGetActiveMember500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMember>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationGetActiveMemberQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const postGwStitchWebApiAuthOrganizationCheckSlug = (
	postGwStitchWebApiAuthOrganizationCheckSlugBody: PostGwStitchWebApiAuthOrganizationCheckSlugBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/organization/check-slug`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationCheckSlugBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationCheckSlugMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationCheckSlug400
		| PostGwStitchWebApiAuthOrganizationCheckSlug401
		| PostGwStitchWebApiAuthOrganizationCheckSlug403
		| PostGwStitchWebApiAuthOrganizationCheckSlug404
		| PostGwStitchWebApiAuthOrganizationCheckSlug429
		| PostGwStitchWebApiAuthOrganizationCheckSlug500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCheckSlug>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationCheckSlugBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCheckSlug>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationCheckSlugBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCheckSlug>>,
		{ data: PostGwStitchWebApiAuthOrganizationCheckSlugBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthOrganizationCheckSlug(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthOrganizationCheckSlugMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCheckSlug>>
	>;
export type PostGwStitchWebApiAuthOrganizationCheckSlugMutationBody =
	PostGwStitchWebApiAuthOrganizationCheckSlugBody;
export type PostGwStitchWebApiAuthOrganizationCheckSlugMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthOrganizationCheckSlug400
		| PostGwStitchWebApiAuthOrganizationCheckSlug401
		| PostGwStitchWebApiAuthOrganizationCheckSlug403
		| PostGwStitchWebApiAuthOrganizationCheckSlug404
		| PostGwStitchWebApiAuthOrganizationCheckSlug429
		| PostGwStitchWebApiAuthOrganizationCheckSlug500
	>;

export const usePostGwStitchWebApiAuthOrganizationCheckSlug = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationCheckSlug400
		| PostGwStitchWebApiAuthOrganizationCheckSlug401
		| PostGwStitchWebApiAuthOrganizationCheckSlug403
		| PostGwStitchWebApiAuthOrganizationCheckSlug404
		| PostGwStitchWebApiAuthOrganizationCheckSlug429
		| PostGwStitchWebApiAuthOrganizationCheckSlug500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCheckSlug>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationCheckSlugBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationCheckSlug>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationCheckSlugBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationCheckSlugMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Remove a member from an organization
 */
export const postGwStitchWebApiAuthOrganizationRemoveMember = (
	postGwStitchWebApiAuthOrganizationRemoveMemberBody: PostGwStitchWebApiAuthOrganizationRemoveMemberBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthOrganizationRemoveMember200>(
		{
			url: `/gw/stitch-web/api/auth/organization/remove-member`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationRemoveMemberBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationRemoveMemberMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthOrganizationRemoveMember400
			| PostGwStitchWebApiAuthOrganizationRemoveMember401
			| PostGwStitchWebApiAuthOrganizationRemoveMember403
			| PostGwStitchWebApiAuthOrganizationRemoveMember404
			| PostGwStitchWebApiAuthOrganizationRemoveMember429
			| PostGwStitchWebApiAuthOrganizationRemoveMember500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationRemoveMember>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthOrganizationRemoveMemberBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationRemoveMember>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationRemoveMemberBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationRemoveMember>
			>,
			{ data: PostGwStitchWebApiAuthOrganizationRemoveMemberBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthOrganizationRemoveMember(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthOrganizationRemoveMemberMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationRemoveMember>>
	>;
export type PostGwStitchWebApiAuthOrganizationRemoveMemberMutationBody =
	PostGwStitchWebApiAuthOrganizationRemoveMemberBody;
export type PostGwStitchWebApiAuthOrganizationRemoveMemberMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthOrganizationRemoveMember400
		| PostGwStitchWebApiAuthOrganizationRemoveMember401
		| PostGwStitchWebApiAuthOrganizationRemoveMember403
		| PostGwStitchWebApiAuthOrganizationRemoveMember404
		| PostGwStitchWebApiAuthOrganizationRemoveMember429
		| PostGwStitchWebApiAuthOrganizationRemoveMember500
	>;

export const usePostGwStitchWebApiAuthOrganizationRemoveMember = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationRemoveMember400
		| PostGwStitchWebApiAuthOrganizationRemoveMember401
		| PostGwStitchWebApiAuthOrganizationRemoveMember403
		| PostGwStitchWebApiAuthOrganizationRemoveMember404
		| PostGwStitchWebApiAuthOrganizationRemoveMember429
		| PostGwStitchWebApiAuthOrganizationRemoveMember500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationRemoveMember>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationRemoveMemberBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationRemoveMember>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationRemoveMemberBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationRemoveMemberMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Update the role of a member in an organization
 */
export const updateOrganizationMemberRole = (
	updateOrganizationMemberRoleBody: UpdateOrganizationMemberRoleBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UpdateOrganizationMemberRole200>(
		{
			url: `/gw/stitch-web/api/auth/organization/update-member-role`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: updateOrganizationMemberRoleBody,
		},
		options,
	);
};

export const getUpdateOrganizationMemberRoleMutationOptions = <
	TError = ErrorType<
		| UpdateOrganizationMemberRole400
		| UpdateOrganizationMemberRole401
		| UpdateOrganizationMemberRole403
		| UpdateOrganizationMemberRole404
		| UpdateOrganizationMemberRole429
		| UpdateOrganizationMemberRole500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOrganizationMemberRole>>,
		TError,
		{ data: UpdateOrganizationMemberRoleBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateOrganizationMemberRole>>,
	TError,
	{ data: UpdateOrganizationMemberRoleBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateOrganizationMemberRole>>,
		{ data: UpdateOrganizationMemberRoleBody }
	> = (props) => {
		const { data } = props ?? {};

		return updateOrganizationMemberRole(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMemberRoleMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateOrganizationMemberRole>>
>;
export type UpdateOrganizationMemberRoleMutationBody =
	UpdateOrganizationMemberRoleBody;
export type UpdateOrganizationMemberRoleMutationError = ErrorType<
	| UpdateOrganizationMemberRole400
	| UpdateOrganizationMemberRole401
	| UpdateOrganizationMemberRole403
	| UpdateOrganizationMemberRole404
	| UpdateOrganizationMemberRole429
	| UpdateOrganizationMemberRole500
>;

export const useUpdateOrganizationMemberRole = <
	TError = ErrorType<
		| UpdateOrganizationMemberRole400
		| UpdateOrganizationMemberRole401
		| UpdateOrganizationMemberRole403
		| UpdateOrganizationMemberRole404
		| UpdateOrganizationMemberRole429
		| UpdateOrganizationMemberRole500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOrganizationMemberRole>>,
		TError,
		{ data: UpdateOrganizationMemberRoleBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateOrganizationMemberRole>>,
	TError,
	{ data: UpdateOrganizationMemberRoleBody },
	TContext
> => {
	const mutationOptions =
		getUpdateOrganizationMemberRoleMutationOptions(options);

	return useMutation(mutationOptions);
};

export const postGwStitchWebApiAuthOrganizationLeave = (
	postGwStitchWebApiAuthOrganizationLeaveBody: PostGwStitchWebApiAuthOrganizationLeaveBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/organization/leave`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationLeaveBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationLeaveMutationOptions = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationLeave400
		| PostGwStitchWebApiAuthOrganizationLeave401
		| PostGwStitchWebApiAuthOrganizationLeave403
		| PostGwStitchWebApiAuthOrganizationLeave404
		| PostGwStitchWebApiAuthOrganizationLeave429
		| PostGwStitchWebApiAuthOrganizationLeave500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationLeave>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationLeaveBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationLeave>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationLeaveBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationLeave>>,
		{ data: PostGwStitchWebApiAuthOrganizationLeaveBody }
	> = (props) => {
		const { data } = props ?? {};

		return postGwStitchWebApiAuthOrganizationLeave(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostGwStitchWebApiAuthOrganizationLeaveMutationResult = NonNullable<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationLeave>>
>;
export type PostGwStitchWebApiAuthOrganizationLeaveMutationBody =
	PostGwStitchWebApiAuthOrganizationLeaveBody;
export type PostGwStitchWebApiAuthOrganizationLeaveMutationError = ErrorType<
	| PostGwStitchWebApiAuthOrganizationLeave400
	| PostGwStitchWebApiAuthOrganizationLeave401
	| PostGwStitchWebApiAuthOrganizationLeave403
	| PostGwStitchWebApiAuthOrganizationLeave404
	| PostGwStitchWebApiAuthOrganizationLeave429
	| PostGwStitchWebApiAuthOrganizationLeave500
>;

export const usePostGwStitchWebApiAuthOrganizationLeave = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationLeave400
		| PostGwStitchWebApiAuthOrganizationLeave401
		| PostGwStitchWebApiAuthOrganizationLeave403
		| PostGwStitchWebApiAuthOrganizationLeave404
		| PostGwStitchWebApiAuthOrganizationLeave429
		| PostGwStitchWebApiAuthOrganizationLeave500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationLeave>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationLeaveBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationLeave>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationLeaveBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationLeaveMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * List all invitations a user has received
 */
export const getGwStitchWebApiAuthOrganizationListUserInvitations = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<
		GetGwStitchWebApiAuthOrganizationListUserInvitations200Item[]
	>(
		{
			url: `/gw/stitch-web/api/auth/organization/list-user-invitations`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationListUserInvitationsQueryKey =
	() => {
		return [
			`/gw/stitch-web/api/auth/organization/list-user-invitations`,
		] as const;
	};

export const getGetGwStitchWebApiAuthOrganizationListUserInvitationsQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getGwStitchWebApiAuthOrganizationListUserInvitations>
		>,
		TError = ErrorType<
			| GetGwStitchWebApiAuthOrganizationListUserInvitations400
			| GetGwStitchWebApiAuthOrganizationListUserInvitations401
			| GetGwStitchWebApiAuthOrganizationListUserInvitations403
			| GetGwStitchWebApiAuthOrganizationListUserInvitations404
			| GetGwStitchWebApiAuthOrganizationListUserInvitations429
			| GetGwStitchWebApiAuthOrganizationListUserInvitations500
		>,
	>(options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof getGwStitchWebApiAuthOrganizationListUserInvitations
					>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetGwStitchWebApiAuthOrganizationListUserInvitationsQueryKey();

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationListUserInvitations>
			>
		> = ({ signal }) =>
			getGwStitchWebApiAuthOrganizationListUserInvitations(
				requestOptions,
				signal,
			);

		return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationListUserInvitations>
			>,
			TError,
			TData
		> & { queryKey: QueryKey };
	};

export type GetGwStitchWebApiAuthOrganizationListUserInvitationsQueryResult =
	NonNullable<
		Awaited<
			ReturnType<typeof getGwStitchWebApiAuthOrganizationListUserInvitations>
		>
	>;
export type GetGwStitchWebApiAuthOrganizationListUserInvitationsQueryError =
	ErrorType<
		| GetGwStitchWebApiAuthOrganizationListUserInvitations400
		| GetGwStitchWebApiAuthOrganizationListUserInvitations401
		| GetGwStitchWebApiAuthOrganizationListUserInvitations403
		| GetGwStitchWebApiAuthOrganizationListUserInvitations404
		| GetGwStitchWebApiAuthOrganizationListUserInvitations429
		| GetGwStitchWebApiAuthOrganizationListUserInvitations500
	>;

export const useGetGwStitchWebApiAuthOrganizationListUserInvitations = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationListUserInvitations>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationListUserInvitations400
		| GetGwStitchWebApiAuthOrganizationListUserInvitations401
		| GetGwStitchWebApiAuthOrganizationListUserInvitations403
		| GetGwStitchWebApiAuthOrganizationListUserInvitations404
		| GetGwStitchWebApiAuthOrganizationListUserInvitations429
		| GetGwStitchWebApiAuthOrganizationListUserInvitations500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationListUserInvitations>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationListUserInvitationsQueryOptions(
			options,
		);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getGwStitchWebApiAuthOrganizationListMembers = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/organization/list-members`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationListMembersQueryKey = () => {
	return [`/gw/stitch-web/api/auth/organization/list-members`] as const;
};

export const getGetGwStitchWebApiAuthOrganizationListMembersQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationListMembers400
		| GetGwStitchWebApiAuthOrganizationListMembers401
		| GetGwStitchWebApiAuthOrganizationListMembers403
		| GetGwStitchWebApiAuthOrganizationListMembers404
		| GetGwStitchWebApiAuthOrganizationListMembers429
		| GetGwStitchWebApiAuthOrganizationListMembers500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetGwStitchWebApiAuthOrganizationListMembersQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>>
	> = ({ signal }) =>
		getGwStitchWebApiAuthOrganizationListMembers(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwStitchWebApiAuthOrganizationListMembersQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>>
	>;
export type GetGwStitchWebApiAuthOrganizationListMembersQueryError = ErrorType<
	| GetGwStitchWebApiAuthOrganizationListMembers400
	| GetGwStitchWebApiAuthOrganizationListMembers401
	| GetGwStitchWebApiAuthOrganizationListMembers403
	| GetGwStitchWebApiAuthOrganizationListMembers404
	| GetGwStitchWebApiAuthOrganizationListMembers429
	| GetGwStitchWebApiAuthOrganizationListMembers500
>;

export const useGetGwStitchWebApiAuthOrganizationListMembers = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationListMembers400
		| GetGwStitchWebApiAuthOrganizationListMembers401
		| GetGwStitchWebApiAuthOrganizationListMembers403
		| GetGwStitchWebApiAuthOrganizationListMembers404
		| GetGwStitchWebApiAuthOrganizationListMembers429
		| GetGwStitchWebApiAuthOrganizationListMembers500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwStitchWebApiAuthOrganizationListMembers>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationListMembersQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getGwStitchWebApiAuthOrganizationGetActiveMemberRole = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/stitch-web/api/auth/organization/get-active-member-role`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetGwStitchWebApiAuthOrganizationGetActiveMemberRoleQueryKey =
	() => {
		return [
			`/gw/stitch-web/api/auth/organization/get-active-member-role`,
		] as const;
	};

export const getGetGwStitchWebApiAuthOrganizationGetActiveMemberRoleQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole>
		>,
		TError = ErrorType<
			| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole400
			| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole401
			| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole403
			| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole404
			| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole429
			| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole500
		>,
	>(options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole
					>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetGwStitchWebApiAuthOrganizationGetActiveMemberRoleQueryKey();

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole>
			>
		> = ({ signal }) =>
			getGwStitchWebApiAuthOrganizationGetActiveMemberRole(
				requestOptions,
				signal,
			);

		return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole>
			>,
			TError,
			TData
		> & { queryKey: QueryKey };
	};

export type GetGwStitchWebApiAuthOrganizationGetActiveMemberRoleQueryResult =
	NonNullable<
		Awaited<
			ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole>
		>
	>;
export type GetGwStitchWebApiAuthOrganizationGetActiveMemberRoleQueryError =
	ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole400
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole401
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole403
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole404
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole429
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole500
	>;

export const useGetGwStitchWebApiAuthOrganizationGetActiveMemberRole = <
	TData = Awaited<
		ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole>
	>,
	TError = ErrorType<
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole400
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole401
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole403
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole404
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole429
		| GetGwStitchWebApiAuthOrganizationGetActiveMemberRole500
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof getGwStitchWebApiAuthOrganizationGetActiveMemberRole>
			>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwStitchWebApiAuthOrganizationGetActiveMemberRoleQueryOptions(
			options,
		);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Check if the user has permission
 */
export const postGwStitchWebApiAuthOrganizationHasPermission = (
	postGwStitchWebApiAuthOrganizationHasPermissionBody: PostGwStitchWebApiAuthOrganizationHasPermissionBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<PostGwStitchWebApiAuthOrganizationHasPermission200>(
		{
			url: `/gw/stitch-web/api/auth/organization/has-permission`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postGwStitchWebApiAuthOrganizationHasPermissionBody,
		},
		options,
	);
};

export const getPostGwStitchWebApiAuthOrganizationHasPermissionMutationOptions =
	<
		TError = ErrorType<
			| PostGwStitchWebApiAuthOrganizationHasPermission400
			| PostGwStitchWebApiAuthOrganizationHasPermission401
			| PostGwStitchWebApiAuthOrganizationHasPermission403
			| PostGwStitchWebApiAuthOrganizationHasPermission404
			| PostGwStitchWebApiAuthOrganizationHasPermission429
			| PostGwStitchWebApiAuthOrganizationHasPermission500
		>,
		TContext = unknown,
	>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationHasPermission>
			>,
			TError,
			{ data: PostGwStitchWebApiAuthOrganizationHasPermissionBody },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationHasPermission>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationHasPermissionBody },
		TContext
	> => {
		const { mutation: mutationOptions, request: requestOptions } =
			options ?? {};

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof postGwStitchWebApiAuthOrganizationHasPermission>
			>,
			{ data: PostGwStitchWebApiAuthOrganizationHasPermissionBody }
		> = (props) => {
			const { data } = props ?? {};

			return postGwStitchWebApiAuthOrganizationHasPermission(
				data,
				requestOptions,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PostGwStitchWebApiAuthOrganizationHasPermissionMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationHasPermission>>
	>;
export type PostGwStitchWebApiAuthOrganizationHasPermissionMutationBody =
	PostGwStitchWebApiAuthOrganizationHasPermissionBody;
export type PostGwStitchWebApiAuthOrganizationHasPermissionMutationError =
	ErrorType<
		| PostGwStitchWebApiAuthOrganizationHasPermission400
		| PostGwStitchWebApiAuthOrganizationHasPermission401
		| PostGwStitchWebApiAuthOrganizationHasPermission403
		| PostGwStitchWebApiAuthOrganizationHasPermission404
		| PostGwStitchWebApiAuthOrganizationHasPermission429
		| PostGwStitchWebApiAuthOrganizationHasPermission500
	>;

export const usePostGwStitchWebApiAuthOrganizationHasPermission = <
	TError = ErrorType<
		| PostGwStitchWebApiAuthOrganizationHasPermission400
		| PostGwStitchWebApiAuthOrganizationHasPermission401
		| PostGwStitchWebApiAuthOrganizationHasPermission403
		| PostGwStitchWebApiAuthOrganizationHasPermission404
		| PostGwStitchWebApiAuthOrganizationHasPermission429
		| PostGwStitchWebApiAuthOrganizationHasPermission500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationHasPermission>>,
		TError,
		{ data: PostGwStitchWebApiAuthOrganizationHasPermissionBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof postGwStitchWebApiAuthOrganizationHasPermission>>,
	TError,
	{ data: PostGwStitchWebApiAuthOrganizationHasPermissionBody },
	TContext
> => {
	const mutationOptions =
		getPostGwStitchWebApiAuthOrganizationHasPermissionMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary / page
 */
export const getPage = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/`, method: 'GET', signal },
		options,
	);
};

export const getGetPageQueryKey = () => {
	return [`/gw/stitch-web/`] as const;
};

export const getGetPageQueryOptions = <
	TData = Awaited<ReturnType<typeof getPage>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPage>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPage>>> = ({
		signal,
	}) => getPage(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPage>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPage>>
>;
export type GetPageQueryError = ErrorType<unknown>;

/**
 * @summary / page
 */
export const useGetPage = <
	TData = Awaited<ReturnType<typeof getPage>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPage>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Static assets (CSS, JS, images, etc.)
 */
export const getStaticAssets = (
	path: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/stitch-web/assets/${path}`, method: 'GET', signal },
		options,
	);
};

export const getGetStaticAssetsQueryKey = (path: string) => {
	return [`/gw/stitch-web/assets/${path}`] as const;
};

export const getGetStaticAssetsQueryOptions = <
	TData = Awaited<ReturnType<typeof getStaticAssets>>,
	TError = ErrorType<unknown>,
>(
	path: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getStaticAssets>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetStaticAssetsQueryKey(path);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getStaticAssets>>> = ({
		signal,
	}) => getStaticAssets(path, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!path,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getStaticAssets>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetStaticAssetsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getStaticAssets>>
>;
export type GetStaticAssetsQueryError = ErrorType<unknown>;

/**
 * @summary Static assets (CSS, JS, images, etc.)
 */
export const useGetStaticAssets = <
	TData = Awaited<ReturnType<typeof getStaticAssets>>,
	TError = ErrorType<unknown>,
>(
	path: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getStaticAssets>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetStaticAssetsQueryOptions(path, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Public image assets
 */
export const getPublicImages = (
	path: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/stitch-web/images/${path}`, method: 'GET', signal },
		options,
	);
};

export const getGetPublicImagesQueryKey = (path: string) => {
	return [`/gw/stitch-web/images/${path}`] as const;
};

export const getGetPublicImagesQueryOptions = <
	TData = Awaited<ReturnType<typeof getPublicImages>>,
	TError = ErrorType<unknown>,
>(
	path: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPublicImages>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPublicImagesQueryKey(path);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicImages>>> = ({
		signal,
	}) => getPublicImages(path, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!path,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPublicImages>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPublicImagesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPublicImages>>
>;
export type GetPublicImagesQueryError = ErrorType<unknown>;

/**
 * @summary Public image assets
 */
export const useGetPublicImages = <
	TData = Awaited<ReturnType<typeof getPublicImages>>,
	TError = ErrorType<unknown>,
>(
	path: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPublicImages>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPublicImagesQueryOptions(path, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /status page
 */
export const getPageStatus = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/status`, method: 'GET', signal },
		options,
	);
};

export const getGetPageStatusQueryKey = () => {
	return [`/gw/stitch-web/status`] as const;
};

export const getGetPageStatusQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageStatus>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageStatus>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageStatusQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageStatus>>> = ({
		signal,
	}) => getPageStatus(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageStatus>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageStatusQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageStatus>>
>;
export type GetPageStatusQueryError = ErrorType<unknown>;

/**
 * @summary /status page
 */
export const useGetPageStatus = <
	TData = Awaited<ReturnType<typeof getPageStatus>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageStatus>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageStatusQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /login page
 */
export const getPageLogin = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/login`, method: 'GET', signal },
		options,
	);
};

export const getGetPageLoginQueryKey = () => {
	return [`/gw/stitch-web/login`] as const;
};

export const getGetPageLoginQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageLogin>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageLogin>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageLoginQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageLogin>>> = ({
		signal,
	}) => getPageLogin(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageLogin>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageLoginQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageLogin>>
>;
export type GetPageLoginQueryError = ErrorType<unknown>;

/**
 * @summary /login page
 */
export const useGetPageLogin = <
	TData = Awaited<ReturnType<typeof getPageLogin>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageLogin>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageLoginQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /login/callback page
 */
export const getPageLoginCallback = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/login/callback`, method: 'GET', signal },
		options,
	);
};

export const getGetPageLoginCallbackQueryKey = () => {
	return [`/gw/stitch-web/login/callback`] as const;
};

export const getGetPageLoginCallbackQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageLoginCallback>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageLoginCallback>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageLoginCallbackQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageLoginCallback>>
	> = ({ signal }) => getPageLoginCallback(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageLoginCallback>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageLoginCallbackQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageLoginCallback>>
>;
export type GetPageLoginCallbackQueryError = ErrorType<unknown>;

/**
 * @summary /login/callback page
 */
export const useGetPageLoginCallback = <
	TData = Awaited<ReturnType<typeof getPageLoginCallback>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageLoginCallback>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageLoginCallbackQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /create-account page
 */
export const getPageCreateAccount = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/create-account`, method: 'GET', signal },
		options,
	);
};

export const getGetPageCreateAccountQueryKey = () => {
	return [`/gw/stitch-web/create-account`] as const;
};

export const getGetPageCreateAccountQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageCreateAccount>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageCreateAccount>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageCreateAccountQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageCreateAccount>>
	> = ({ signal }) => getPageCreateAccount(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageCreateAccount>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageCreateAccountQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageCreateAccount>>
>;
export type GetPageCreateAccountQueryError = ErrorType<unknown>;

/**
 * @summary /create-account page
 */
export const useGetPageCreateAccount = <
	TData = Awaited<ReturnType<typeof getPageCreateAccount>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageCreateAccount>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageCreateAccountQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard page
 */
export const getPageDashboard = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/dashboard`, method: 'GET', signal },
		options,
	);
};

export const getGetPageDashboardQueryKey = () => {
	return [`/gw/stitch-web/dashboard`] as const;
};

export const getGetPageDashboardQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboard>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageDashboard>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageDashboardQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboard>>
	> = ({ signal }) => getPageDashboard(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboard>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboard>>
>;
export type GetPageDashboardQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard page
 */
export const useGetPageDashboard = <
	TData = Awaited<ReturnType<typeof getPageDashboard>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageDashboard>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard/account page
 */
export const getPageDashboardAccount = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/dashboard/account`, method: 'GET', signal },
		options,
	);
};

export const getGetPageDashboardAccountQueryKey = () => {
	return [`/gw/stitch-web/dashboard/account`] as const;
};

export const getGetPageDashboardAccountQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboardAccount>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardAccount>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPageDashboardAccountQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboardAccount>>
	> = ({ signal }) => getPageDashboardAccount(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboardAccount>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardAccountQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboardAccount>>
>;
export type GetPageDashboardAccountQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard/account page
 */
export const useGetPageDashboardAccount = <
	TData = Awaited<ReturnType<typeof getPageDashboardAccount>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardAccount>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardAccountQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard/not-found page
 */
export const getPageDashboardNotFound = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/dashboard/not-found`, method: 'GET', signal },
		options,
	);
};

export const getGetPageDashboardNotFoundQueryKey = () => {
	return [`/gw/stitch-web/dashboard/not-found`] as const;
};

export const getGetPageDashboardNotFoundQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboardNotFound>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardNotFound>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPageDashboardNotFoundQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboardNotFound>>
	> = ({ signal }) => getPageDashboardNotFound(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboardNotFound>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardNotFoundQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboardNotFound>>
>;
export type GetPageDashboardNotFoundQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard/not-found page
 */
export const useGetPageDashboardNotFound = <
	TData = Awaited<ReturnType<typeof getPageDashboardNotFound>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardNotFound>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardNotFoundQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard/patients page
 */
export const getPageDashboardPatients = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/dashboard/patients`, method: 'GET', signal },
		options,
	);
};

export const getGetPageDashboardPatientsQueryKey = () => {
	return [`/gw/stitch-web/dashboard/patients`] as const;
};

export const getGetPageDashboardPatientsQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboardPatients>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardPatients>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPageDashboardPatientsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboardPatients>>
	> = ({ signal }) => getPageDashboardPatients(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboardPatients>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardPatientsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboardPatients>>
>;
export type GetPageDashboardPatientsQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard/patients page
 */
export const useGetPageDashboardPatients = <
	TData = Awaited<ReturnType<typeof getPageDashboardPatients>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardPatients>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardPatientsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard/patients/{patientId} page
 */
export const getPageDashboardPatientsPatientId = (
	patientId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{
			url: `/gw/stitch-web/dashboard/patients/${patientId}`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetPageDashboardPatientsPatientIdQueryKey = (
	patientId: string,
) => {
	return [`/gw/stitch-web/dashboard/patients/${patientId}`] as const;
};

export const getGetPageDashboardPatientsPatientIdQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>,
	TError = ErrorType<unknown>,
>(
	patientId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetPageDashboardPatientsPatientIdQueryKey(patientId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>
	> = ({ signal }) =>
		getPageDashboardPatientsPatientId(patientId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!patientId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardPatientsPatientIdQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>
>;
export type GetPageDashboardPatientsPatientIdQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard/patients/{patientId} page
 */
export const useGetPageDashboardPatientsPatientId = <
	TData = Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>,
	TError = ErrorType<unknown>,
>(
	patientId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getPageDashboardPatientsPatientId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardPatientsPatientIdQueryOptions(
		patientId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard/billing page
 */
export const getPageDashboardBilling = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/dashboard/billing`, method: 'GET', signal },
		options,
	);
};

export const getGetPageDashboardBillingQueryKey = () => {
	return [`/gw/stitch-web/dashboard/billing`] as const;
};

export const getGetPageDashboardBillingQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboardBilling>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardBilling>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPageDashboardBillingQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboardBilling>>
	> = ({ signal }) => getPageDashboardBilling(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboardBilling>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardBillingQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboardBilling>>
>;
export type GetPageDashboardBillingQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard/billing page
 */
export const useGetPageDashboardBilling = <
	TData = Awaited<ReturnType<typeof getPageDashboardBilling>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardBilling>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardBillingQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /dashboard/logout page
 */
export const getPageDashboardLogout = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/dashboard/logout`, method: 'GET', signal },
		options,
	);
};

export const getGetPageDashboardLogoutQueryKey = () => {
	return [`/gw/stitch-web/dashboard/logout`] as const;
};

export const getGetPageDashboardLogoutQueryOptions = <
	TData = Awaited<ReturnType<typeof getPageDashboardLogout>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardLogout>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetPageDashboardLogoutQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getPageDashboardLogout>>
	> = ({ signal }) => getPageDashboardLogout(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageDashboardLogout>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageDashboardLogoutQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageDashboardLogout>>
>;
export type GetPageDashboardLogoutQueryError = ErrorType<unknown>;

/**
 * @summary /dashboard/logout page
 */
export const useGetPageDashboardLogout = <
	TData = Awaited<ReturnType<typeof getPageDashboardLogout>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getPageDashboardLogout>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageDashboardLogoutQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary /v2 page
 */
export const getPageV2 = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<string>(
		{ url: `/gw/stitch-web/v2`, method: 'GET', signal },
		options,
	);
};

export const getGetPageV2QueryKey = () => {
	return [`/gw/stitch-web/v2`] as const;
};

export const getGetPageV2QueryOptions = <
	TData = Awaited<ReturnType<typeof getPageV2>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageV2>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPageV2QueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageV2>>> = ({
		signal,
	}) => getPageV2(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPageV2>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetPageV2QueryResult = NonNullable<
	Awaited<ReturnType<typeof getPageV2>>
>;
export type GetPageV2QueryError = ErrorType<unknown>;

/**
 * @summary /v2 page
 */
export const useGetPageV2 = <
	TData = Awaited<ReturnType<typeof getPageV2>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getPageV2>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetPageV2QueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};
